import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { API } from "../../config/api";
import { FaPlus, FaUndoAlt, FaCheckCircle, FaMedkit, FaInfoCircle } from 'react-icons/fa'
import "bulma/css/bulma.css";
import { useMutation } from "react-query";
import "../../index.css"
import Swal from "sweetalert2";
import swal from "sweetalert";
import Select from 'react-select';
import LoaderHome from "../Loader/LoaderHome"
import { FormatRupiah } from "@arismun/format-rupiah"
import { useParams } from "react-router-dom";
import ModalAddMedicalRecord from "./ModalMedicalRecord/ModalShowTreatment"
import axios from "axios";
import moment from "moment";
import { Modal, Toast, ToastContainer, Button, Tabs, Tab, ToggleButton, OverlayTrigger, Popover, Row, Col, Form, Badge, Stack, Container } from "react-bootstrap";
import KondisiButtonModal from "./ModalPemeriksaanGigi/KondisiButtonModal";
import RestorasiButtonModal from "./ModalPemeriksaanGigi/RestorasiButtonModal";
import RestorasiMaterialButtonModal from "./ModalPemeriksaanGigi/BahanRestorasiButtonModal";
import ProtesaButtonModal from "./ModalPemeriksaanGigi/ProtesaButtonModal";
import ProtesaMaterialButtonModal from "./ModalPemeriksaanGigi/ProtesaMaterialButtonModal";
import DebrisIndexButtonModal from "./ModalPemeriksaanGigi/DebrisIndexButtonModal";
import KalkulusIndexButtonModal from "./ModalPemeriksaanGigi/KalkulusIndexButtonModal";
import OklusiButtonModal from "./ModalPemeriksaanGigi/OklusiButtonModal";
import TorusPalatinusButtonModal from "./ModalPemeriksaanGigi/TorusPalatinusButtonModal";
import TorusMandibularisButtonModal from "./ModalPemeriksaanGigi/TorusMandibularisButtonModal";
import PalatumButtonModal from "./ModalPemeriksaanGigi/PalatumButtonModal";
import DiastemaButtonModal from "./ModalPemeriksaanGigi/DiastemaButtonModal";
import AnomaliButtonModal from "./ModalPemeriksaanGigi/AnomaliButtonModal";
import OralConditionModal from "./ModalPemeriksaanGigi/OralConditionModal";
import DecayedTeethCountModal from "./ModalPemeriksaanGigi/DecayedTeethCountModal";
import ToothMissingCountModal from "./ModalPemeriksaanGigi/ToothMissingCountModal";
import ToothFilledCountModal from "./ModalPemeriksaanGigi/ToothFilledCountModal";
import TreatmentDropdown from "./Components/AppointmentTreatmentAdd/TreatmentDropdown";

import OdontogramDebrisIndex from "./Components/Odontogram/OdontogramDebrisIndex";
import OdontogramKalkulusIndex from "./Components/Odontogram/OdontogramKalkulusIndex";
import { TOOTH_POSITIONS } from "./Components/Odontogram/ToothPosition";
import ModalCardReminder from "./ModalCardReminder/Process";
import ModalCardReminderAfter from "./ModalCardReminder/After";


export default function Login() {
  const { id, id_patient_status } = useParams()
  const idParams = { id }

  document.title = "SDC Apps";
  const navigate = useNavigate()
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(500);
  const [limitTreatment, setLimitTreatment] = useState(10);
  const [ascendingLimit, setAscendingLimit] = useState(0);


  const [ascending, setAscending] = useState(1);
  const [search, setSearch] = useState(1);
  const token = localStorage.getItem("token");
  const [getDataDokter, setGetDataDokter] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedTeeth, setSelectedTeeth] = useState([]);
  const [activeTab, setActiveTab] = useState('keadaan_gigi');

  const [selectedTooth, setSelectedTooth] = useState([]);
  const [activeMode, setActiveMode] = useState(null);

  const [choiceToothCategory, setChoiceToothCategory] = useState(null);
  const [categorySelected, setCategorySelected] = useState(null);
  const [modalCardReminder, setModalCardReminder] = useState(false);
  const [modalCardReminderAfter, setModalCardReminderAfter] = useState(false);
  const [reminderShown, setReminderShown] = useState(false)

  const [activeIndex, setActiveIndex] = useState("");

  const [visibleOdontogram, setVisibleOdontogram] = useState(true);
  const [visibleOdontogramKalkulus, setVisibleOdontogramKalkulus] = useState(true);

  const [getDataDebrisIndex, setGetDataDebrisIndex] = useState([]);
  const [debrisPerTooth, setDebrisPerTooth] = useState({});
  const [getDataKalkulusIndex, setGetDataKalkulusIndex] = useState([]);
  const [kalkulusPerTooth, setKalkulusPerTooth] = useState({});




  const [openModalType, setOpenModalType] = useState(null);

  const openModal = (type) => {
    setOpenModalType(type);
  };

  const closeModal = () => {
    setOpenModalType(null);
  };

  const [resetSignal, setResetSignal] = useState(0);
  const [debrisIndexGigi, setDebrisIndexGigi] = useState("");
  const [kalkulusIndexGigi, setKalkulusIndexGigi] = useState("");


  // Kondisi
  const [shouldPromptCondition, setShouldPromptCondition] = useState(false);
  const [getDataDentalCondition, setGetDataDentalCondition] = useState([]);
  const [conditionData, setConditionData] = useState([]);
  const [kondisiGigi, setKondisiGigi] = useState("");
  const [isKondisiClicked, setIsKondisiClicked] = useState(false);
  const [activeConditionSelections, setActiveConditionSelections] = useState(null);
  const [isApplyConditionMode, setIsApplyConditionMode] = useState(false);
  const [toothConditions, setToothConditions] = useState({});
  const [tempSelections, setTempSelections] = useState([]);
  const [kondisiGigiColor, setKondisiGigikliColor] = useState("");
  const [selectedToothData, setSelectedToothData] = useState([]);
  const [onlyDisplayNameConditions, setOnlyDisplayNameConditions] = useState([]);
  const [buttonChoiceCondition, setButtonChoiceCondition] = useState(false);

  // Restorasi
  const [shouldPromptRestoration, setShouldPromptRestoration] = useState(false);
  const [restorationData, setRestorationData] = useState([]);
  const [restorasiGigiColor, setRestorasiGigiColor] = useState("");
  const [getDataDentalRestoration, setGetDataDentalRestoration] = useState([]);
  const [restorasiGigi, setRestorasiGigi] = useState("");
  const [toothRestorations, setToothRestorations] = useState({});
  const [activeRestorasiSelections, setActiveRestorasiSelections] = useState([]);
  const [tempRestorasiSelections, setTempRestorasiSelections] = useState([]);
  const [isRestorasiClicked, setIsRestorasiClicked] = useState(false);
  const [isApplyRestorasiMode, setIsApplyRestorasiMode] = useState(false);
  const [selectedToothDataRestoration, setSelectedToothDataRestoration] = useState([]);
  const [buttonChoiceRestoration, setButtonChoiceRestoration] = useState(false);



  // Bahan Restorasi
  const [shouldPromptRestorationMaterial, setShouldPromptRestorationMaterial] = useState(false);
  const [restorationMaterialData, setRestorationMaterialData] = useState([]);
  const [restorasiMaterialGigiColor, setRestorasiMaterialGigiColor] = useState("");
  const [getDataDentalRestorationMaterial, setGetDataDentalRestorationMaterial] = useState([]);
  const [restorasiMaterialGigi, setRestorasiMaterialGigi] = useState("");
  const [toothRestorationMaterials, setToothRestorationMaterials] = useState({});
  const [activeRestorasiMaterialSelections, setActiveRestorasiMaterialSelections] = useState([]);
  const [tempRestorasiMaterialSelections, setTempRestorasiMaterialSelections] = useState([]);
  const [isRestorasiMaterialClicked, setIsRestorasiMaterialClicked] = useState(false);
  const [isApplyRestorasiMaterialMode, setIsApplyRestorasiMaterialMode] = useState(false);
  const [selectedToothDataRestorationMaterial, setSelectedToothDataRestorationMaterial] = useState([]);
  const [buttonChoiceRestorationMaterial, setButtonChoiceRestorationMaterial] = useState(false);


  // Protesa
  const [shouldPromptProtesa, setShouldPromptProtesa] = useState(false);
  const [protesaData, setProtesaData] = useState([]);
  const [protesaGigiColor, setProtesaGigiColor] = useState("");
  const [getDataDentalProtesa, setGetDataDentalProtesa] = useState([]);
  const [protesaGigi, setProtesaGigi] = useState("");
  const [toothProtesas, setToothProtesas] = useState({});
  const [activeProtesaSelections, setActiveProtesaSelections] = useState([]);
  const [tempProtesaSelections, setTempProtesaSelections] = useState([]);
  const [isProtesaClicked, setIsProtesaClicked] = useState(false);
  const [isApplyProtesaMode, setIsApplyProtesaMode] = useState(false);
  const [selectedToothDataProtesa, setSelectedToothDataProtesa] = useState([]);
  const [buttonChoiceProtesa, setButtonChoiceProtesa] = useState(false);




  // Bahan Protesa
  const [shouldPromptProtesaMaterial, setShouldPromptProtesaMaterial] = useState(false);
  const [protesaMaterialData, setProtesaMaterialData] = useState([]);
  const [protesaMaterialGigiColor, setProtesaMaterialGigiColor] = useState("");
  const [getDataDentalProtesaMaterial, setGetDataDentalProtesaMaterial] = useState([]);
  const [protesaMaterialGigi, setProtesaMaterialGigi] = useState("");
  const [toothProtesaMaterial, setToothProtesaMaterial] = useState({});
  const [activeProtesaMaterialSelections, setActiveProtesaMaterialSelections] = useState([]);
  const [tempProtesaMaterialSelections, setTempProtesaMaterialSelections] = useState([]);
  const [isProtesaMaterialClicked, setIsProtesaMaterialClicked] = useState(false);
  const [isApplyProtesaMaterialMode, setIsApplyProtesaMaterialMode] = useState(false);
  const [selectedToothDataProtesaMaterial, setSelectedToothDataProtesaMaterial] = useState([]);
  const [buttonChoiceProtesaMaterial, setButtonChoiceProtesaMaterial] = useState(false);



  // Oklusi
  const [getDataDentalOcclusi, setGetDataDentalOcclusi] = useState([]);
  const [occlusiGigi, setOcclusiGigi] = useState("");
  const [toothOcclusi, setToothOcclusi] = useState({});
  const [activeOcclusiSelections, setActiveOcclusiSelections] = useState([]);
  const [tempOcclusiSelections, setTempOcclusiSelections] = useState([]);
  const [isOcclusiClicked, setIsOcclusiClicked] = useState(false);
  const [isApplyOcclusiMode, setIsApplyOcclusiMode] = useState(false);
  const [selectedOcclusiLabel, setSelectedOcclusiLabel] = useState("");
  const [selectedToothDataOcclusi, setSelectedToothDataOcclusi] = useState([]);
  const [onlyDisplayNameOcclusi, setOnlyDisplayNameOcclusi] = useState([]);

  const handleOcclusiSelected = (selectedLabels) => {
    setOcclusiGigi(selectedLabels.join(", "));
  };

  // Torus Palatinus
  const [getDataDentalTorusPalatinus, setGetDataDentalTorusPalatinus] = useState([]);
  const [torusPalatinusGigi, setTorusPalatinusGigi] = useState("");
  const [toothTorusPalatinus, setToothTorusPalatinus] = useState({});
  const [activeTorusPalatinusSelections, setActiveTorusPalatinusSelections] = useState([]);
  const [tempTorusPalatinusSelections, setTempTorusPalatinusSelections] = useState([]);
  const [isTorusPalatinusClicked, setIsTorusPalatinusClicked] = useState(false);
  const [isApplyTorusPalatinusMode, setIsApplyTorusPalatinusMode] = useState(false);
  const [selectedTorusPalatinusLabel, setSelectedTorusPalatinusLabel] = useState("");
  const [onlyDisplayNameTorusPalatinus, setOnlyDisplayNameTorusPalatinus] = useState([]);
  const handleTorusPalatinusSelected = (selectedTorusPalatinusLabels) => {
    const joinedLabel = selectedTorusPalatinusLabels.join(', ');
    setTorusPalatinusGigi(joinedLabel);
  };

  // Torus MandiBularis
  const [getDataDentalTorusMandiBularis, setGetDataDentalTorusMandiBularis] = useState([]);
  const [torusMandiBularisGigi, setTorusMandiBularisGigi] = useState("");
  const [toothTorusMandiBularis, setToothTorusMandiBularis] = useState({});
  const [activeTorusMandiBularisSelections, setActiveTorusMandiBularisSelections] = useState([]);
  const [tempTorusMandiBularisSelections, setTempTorusMandiBularisSelections] = useState([]);
  const [isTorusMandiBularisClicked, setIsTorusMandiBularisClicked] = useState(false);
  const [isApplyTorusMandiBularisMode, setIsApplyTorusMandiBularisMode] = useState(false);
  const [selectedTorusMandiBularisLabel, setSelectedTorusMandiBularisLabel] = useState("");
  const [onlyDisplayNameTorusMandibularis, setOnlyDisplayNameTorusMandibularis] = useState([]);

  const handleTorusMandiBularisSelected = (selectedTorusMandiBularisLabels) => {
    const joinedLabel = selectedTorusMandiBularisLabels.join(', ');
    setTorusMandiBularisGigi(joinedLabel);
  };

  // palatum
  const [getDataDentalPalatum, setGetDataDentalPalatum] = useState([]);
  const [palatumGigi, setPalatumGigi] = useState("");
  const [toothPalatum, setToothPalatum] = useState({});
  const [activePalatumSelections, setActivePalatumSelections] = useState([]);
  const [tempPalatumSelections, setTempPalatumSelections] = useState([]);
  const [isPalatumClicked, setIsPalatumClicked] = useState(false);
  const [isApplyPalatumMode, setIsApplyPalatumMode] = useState(false);
  const [selectedPalatumLabel, setSelectedPalatumLabel] = useState("");
  const [onlyDisplayNamePalatum, setOnlyDisplayNamePalatum] = useState([]);

  const handlePalatumSelected = (selectedPalatumLabels) => {
    const joinedLabel = selectedPalatumLabels.join(', ');
    setPalatumGigi(joinedLabel);
  };

  // diastema
  const [getDataDentalDiastema, setGetDataDentalDiastema] = useState([]);
  const [diastemaGigi, setDiastemaGigi] = useState("");
  const [toothDiastema, setToothDiastema] = useState({});
  const [activeDiastemaSelections, setActiveDiastemaSelections] = useState([]);
  const [tempDiastemaSelections, setTempDiastemaSelections] = useState([]);
  const [isDiastemaClicked, setIsDiastemaClicked] = useState(false);
  const [isApplyDiastemaMode, setIsApplyDiastemaMode] = useState(false);
  const [selectedDiastemaLabel, setSelectedDiastemaLabel] = useState("");
  const [onlyDisplayNameDiastema, setOnlyDisplayNameDiastema] = useState([]);
  const [descriptionDiastema, setDescriptionDiastema] = useState("");


  const handleDiastemaSelected = (selectedDiastemaLabels) => {
    const joinedLabel = selectedDiastemaLabels.join(', ');
    setDiastemaGigi(joinedLabel);
  };


  // anomali
  const [getDataDentalAnomali, setGetDataDentalAnomali] = useState([]);
  const [anomaliGigi, setAnomaliGigi] = useState("");
  const [toothAnomali, setToothAnomali] = useState({});
  const [activeAnomaliSelections, setActiveAnomaliSelections] = useState([]);
  const [tempAnomaliSelections, setTempAnomaliSelections] = useState([]);
  const [isAnomaliClicked, setIsAnomaliClicked] = useState(false);
  const [isApplyAnomaliMode, setIsApplyAnomaliMode] = useState(false);
  const [selectedAnomaliLabel, setSelectedAnomaliLabel] = useState("");
  const [onlyDisplayNameAnomali, setOnlyDisplayNameAnomali] = useState([]);
  const [descriptionAnomali, setDescriptionAnomali] = useState("");

  const handleAnomaliSelected = (selectedAnomaliLabels) => {
    const joinedLabel = selectedAnomaliLabels.join(', ');
    setAnomaliGigi(joinedLabel);
  };

  // Position
  const [positionTooth, setPositionTooth] = useState(null);

  // Status Oral
  const [oralConditionNote, setOralConditionNote] = useState("");
  const [showModalOralCondition, setShowModalOralCondition] = useState(false);

  // Status Decayed
  const [decayedTeethCountNote, setDecayedTeethCountNote] = useState("");
  const [showModalDecayedTeethCount, setShowModalDecayedTeethCount] = useState(false);

  //  Status Missing
  const [toothMissingCountNote, setToothMissingCountNote] = useState("");
  const [showModalToothMissingCount, setShowModalToothMissingCount] = useState(false);

  //  Status Filled
  const [toothFilledCountNote, setToothFilledCountNote] = useState("");
  const [showModalToothFilledCount, setShowModalToothFilledCount] = useState(false);




  const [resetKey, setResetKey] = useState(0);

  // Untuk Close Proops Data
  const [getDataAppointmentById, setGetDataAppointmentById] = useState([]);
  const [getDataAppointmentArragmentData, setGetDataAppointmentArragmentData] = useState([]);
  const [getDataAppointmentByIdTreatmentPlan, setGetDataAppointmentByIdTreatmentPlan] = useState([]);
  const [getDataAppointmentByIdTreatmentPlanStatusButton, setGetDataAppointmentByIdTreatmentPlanStatusButton] = useState([]);
  const [getDataAppointmentByIdDoctor, setGetDataAppointmentByIdDoctor] = useState([]);
  const [getDataAppointmentByIdPatient, setGetDataAppointmentByIdPatient] = useState([]);
  const [getDataDetailsApproval, setGetDataDetailsApproval] = useState([]);
  const [initialDentalCondition, setInitialDentalCondition] = useState([]);
  const [getDataTreatmentById, setGetDataTreatmentById] = useState([]);
  const [getDataApprovalById, setGetDataApprovalById] = useState([]);
  const [loading, setLoading] = useState(false);
  const [getDataTreatment, setGetDataTreatment] = useState([]);
  const [getDataTreatmentOneQty, setGetDataTreatmentOneQty] = useState([]);
  const [getDataMedicalRecordPatientForStatusMember, setGetDataMedicalRecordPatientForStatusMember] = useState([]);
  const [getDataDiagnosaPatient, setGetDataDiagnosaPatient] = useState([]);
  const [idStoreMedicarRecord, setIdStoreMedicalRecord] = useState([]);
  const [idRoleDokter, setIdRoleDokter] = useState("");
  const [nameRoleDoctor, setNameRoleDoktor] = useState("Doctor");
  const [keyword, setKeyword] = useState("");
  // const [formTreatment, setFormTreatment] = useState({ assistants: [] });
  const [inputList, setInputList] = useState([]);




  // const cleanedTooth = selectedTooth?.trim();
  const cleanedTooth = typeof selectedTooth === 'string' ? selectedTooth.trim() : '';



  const handleClearCondition = () => {
    setIsKondisiClicked(false);
    setToothConditions(prev => ({
      ...prev,
      [cleanedTooth]: [],
    }));
  };




  const [dataItem, setGetDataItem] = useState({
    id_doctor: "",
    id_treatment: "",
    id_room: "",
    tooth_number: "",
    qty: "1",
    choiceGigi: "satu_gigi",
    treatment_price_min: "",
    treatment_price_max: "",
    estimate_price: "",
    id_description: "",
    description: "",
    code_description: "",

    other_dental_oral_conditions: "",
    number_of_decayed_teeth: "",
    number_of_missing_teeth: "",
    number_of_teeth_filled: "",


    assistants: ["", ""]
  })

  const [inputListObat, setInputListObat] = useState([{ id_medical_item: "", qty: "", description: "", price: "" }]);
  const initialEstimatePriceTotal = inputList.reduce((total, item) => {
    const estimatePrice = parseFloat(item.estimate_price);
    if (!isNaN(estimatePrice)) {
      return total + estimatePrice;
    }
    return total;
  }, 0); // Initial total is 0

  const [form, setForm] = useState({
    id_appointment: "",
    id_doctor: "",
    id_patient: "",
    name_patient_firstname: "",
    name_patient_lastname: "",
    name_doctor_firstname: "",
    name_doctor_lastname: "",

    description_tooth_diastema: "",
    description_tooth_anomali: "",

    anamnesa: "",
    date_plan: "",
    other_dental_oral_conditions: "",
    number_of_decayed_teeth: "",
    number_of_missing_teeth: "",
    number_of_teeth_filled: "",
    estimate_price_total: initialEstimatePriceTotal, // Inisialisasi dengan nilai 0
    estimate_price_obat: 0,
    time: "",
    choiceGigi: "satu_gigi",
  });

  const [formchoiceGigi, setFormchoiceGigi] = useState({
    choiceGigi: "satu_gigi"
  });

  // modal role add 
  const [idPatientMedicalRecord, setIdModalMedicalRecordPatient] = useState();
  const [idPatientMedicalRecordFirstName, setIdModalMedicalRecordPatientFirstName] = useState();
  const [idPatientMedicalRecordLastName, setIdModalMedicalRecordPatientLastName] = useState();
  const [modalMedicalRecord, setModalMedicalRecord] = useState(false);
  let [cBase64, setBase64] = useState();
  const [getDataFee, setGetDataFee] = useState([]);
  const [getOpenAddObat, setGetOpenAddObat] = useState(false);
  const [mainLoading, setMainLoading] = useState(false);
  const [extraLoading, setExtraLoading] = useState(false);


  const cleanedArrayInputList = inputList.map((obj) => ({
    ...obj,
    assistants: obj.assistants.filter((assistant) => assistant !== null)
  }));

  let fetchParams = {
    headers: { "Authorization": `${token}`, "Content-Type": "application/json" }
  };


  const fetchDataRef = useRef();

  const fetchData = async () => {
    try {
      const [
        dataTreatment,
        treatmentOneQty,
        appointmentByID,
        dataFee,
        dataDokter,
        dataMedicalRecord,
        diagnosaPatientResponse,
        dataTreatmentPlan
      ] = await axios.all([
        API.get(`/transaction-service/treatments?page=${page}&limit=${limitTreatment}&ascending=${ascendingLimit}&search=${keyword}`, fetchParams).catch(e => e.response),
        API.get(`/transaction-service/treatment-one-qtys?page=${page}&limit=${limitTreatment}&ascending=${ascendingLimit}&search=${keyword}`, fetchParams).catch(e => e.response),
        API.get(`/transaction-service/appointments/${id}`, fetchParams).catch(e => e.response),
        API.get(`/transaction-service/fees?page=${page}&limit=${limit}&ascending=${0}`, fetchParams).catch(e => e.response),
        API.get(`/user-service/users?page=${page}&limit=${limit}&ascending=${ascending}&id_role=${idRoleDokter}&name_role=${nameRoleDoctor}`, fetchParams).catch(e => e.response),
        API.get(`/emr-service/medical-records?page=${page}&limit=${limit}&ascending=${ascending}&search=${keyword}&search=${search}&id_patient=${id_patient_status}`, fetchParams).catch(e => e.response),
        API.get(`/user-service/diagnosa-patients?page=${page}&limit=1000&ascending=${ascendingLimit}&search=${keyword}`, fetchParams).catch(e => e.response),
        API.get(`/emr-service/treatment-plans/appointment/${id}`, fetchParams).catch(e => e.response)
      ]);

      // Cek status dan isi data seperti biasa
      if (dataTreatment?.status === 200) setGetDataTreatment(dataTreatment.data.data);
      if (treatmentOneQty?.status === 200) setGetDataTreatmentOneQty(treatmentOneQty.data.data);
      if (appointmentByID?.status === 200) {
        setGetDataAppointmentById(appointmentByID.data.data);
        setGetDataAppointmentArragmentData(appointmentByID.data.data.arrangement_data);
        setGetDataAppointmentByIdPatient(appointmentByID.data.data.patient_data);
        setGetDataAppointmentByIdDoctor(appointmentByID.data.data.doctor_data.user_detail);
      }
      if (dataFee?.status === 200) {
        // setGetDataFee(dataFee.data.data);
      }
      if (dataDokter?.status === 200) setGetDataDokter(dataDokter.data.data);
      if (dataMedicalRecord?.status === 200) setGetDataMedicalRecordPatientForStatusMember(dataMedicalRecord.data.pagination.total);
      if (diagnosaPatientResponse?.status === 200) setGetDataDiagnosaPatient(diagnosaPatientResponse.data.data);

      if (dataTreatmentPlan?.status === 200) {
        setGetDataAppointmentByIdTreatmentPlan(
          dataTreatmentPlan.data.data.length === 0 || dataTreatmentPlan.data.data.treatment_plan_data === null
            ? ""
            : dataTreatmentPlan.data.data.id
        );
        setGetDataAppointmentByIdTreatmentPlanStatusButton(dataTreatmentPlan.data.data);
      } else {
        setGetDataAppointmentByIdTreatmentPlan("");
        setGetDataAppointmentByIdTreatmentPlanStatusButton(null);
      }

    } catch (error) {
      swal({
        title: 'Failed',
        text: `${error?.response?.data?.message || 'Internal Server Error'}`,
        icon: 'error',
        timer: 3000,
        buttons: false
      });
    }
  };

  // useEffect(() => {
  //   fetchDataRef.current = fetchData;
  //   fetchDataRef.current();
  // }, []);


  const GetResponseDataApproval = async () => {
    try {
      // e.preventDefault();
      setLoading(true)
      const response = await API.get(`/emr-service/treatment-plans/${getDataApprovalById}`, fetchParams)

      // Checking process
      if (response?.status === 200) {
        setGetDataDetailsApproval(response.data.data.details)
        setLoading(false)
      }
    } catch (error) {
      setLoading(false)
      swal({
        title: 'Failed',
        text: `${error.response.data.message}`,
        icon: 'error',
        timer: 3000,
        buttons: false
      });
    }
  }


  const GetResponseDataDentalCondition = async () => {
    try {
      // setLoading(true);
      const response = await API.get(`/emr-service/dental-conditions?page=${page}&limit=${limit}&ascending=${ascending}&id_role=${idRoleDokter}&name_role=${nameRoleDoctor}`, fetchParams);
      if (response?.status === 200) {
        setGetDataDentalCondition(response.data.data);
      }

      // setLoading(false);
    } catch (error) {
      // setLoading(false);
      swal({
        title: 'Failed',
        text: `${error.response?.data?.message || 'Something went wrong'}`,
        icon: 'error',
        timer: 3000,
        buttons: false
      });
    }
  };

  const GetResponseDataDentalRestoration = async () => {
    try {
      // setLoading(true);
      const response = await API.get(`/emr-service/dental-restorations?page=${page}&limit=${limit}&ascending=${ascending}&id_role=${idRoleDokter}&name_role=${nameRoleDoctor}`, fetchParams);
      if (response?.status === 200) {
        setGetDataDentalRestoration(response.data.data);
      }

      // setLoading(false);
    } catch (error) {
      // setLoading(false);
      swal({
        title: 'Failed',
        text: `${error.response?.data?.message || 'Something went wrong'}`,
        icon: 'error',
        timer: 3000,
        buttons: false
      });
    }
  };

  const GetResponseDataDentalRestorationMaterial = async () => {
    try {
      // setLoading(true);
      const response = await API.get(`/emr-service/dental-restoration-materials?page=${page}&limit=${limit}&ascending=${ascending}&id_role=${idRoleDokter}&name_role=${nameRoleDoctor}`, fetchParams);
      if (response?.status === 200) {
        setGetDataDentalRestorationMaterial(response.data.data);
      }

      // setLoading(false);
    } catch (error) {
      // setLoading(false);
      swal({
        title: 'Failed',
        text: `${error.response?.data?.message || 'Something went wrong'}`,
        icon: 'error',
        timer: 3000,
        buttons: false
      });
    }
  };

  const GetResponseDataDentalProtesa = async () => {
    try {
      // setLoading(true);
      const response = await API.get(`/emr-service/dental-protesas?page=${page}&limit=${limit}&ascending=${ascending}&id_role=${idRoleDokter}&name_role=${nameRoleDoctor}`, fetchParams);
      if (response?.status === 200) {
        setGetDataDentalProtesa(response.data.data);
      }

      // setLoading(false);
    } catch (error) {
      // setLoading(false);
      swal({
        title: 'Failed',
        text: `${error.response?.data?.message || 'Something went wrong'}`,
        icon: 'error',
        timer: 3000,
        buttons: false
      });
    }
  };

  const GetResponseDataDentalProtesaMaterial = async () => {
    try {
      // setLoading(true);
      const response = await API.get(`/emr-service/dental-protesa-materials?page=${page}&limit=${limit}&ascending=${ascending}&id_role=${idRoleDokter}&name_role=${nameRoleDoctor}`, fetchParams);
      if (response?.status === 200) {
        setGetDataDentalProtesaMaterial(response.data.data);
      }

      // setLoading(false);
    } catch (error) {
      // setLoading(false);
      swal({
        title: 'Failed',
        text: `${error.response?.data?.message || 'Something went wrong'}`,
        icon: 'error',
        timer: 3000,
        buttons: false
      });
    }
  };

  const GetResponseDataDentalOcclusi = async () => {
    try {
      // setLoading(true);
      const response = await API.get(`/emr-service/dental-occlusions?page=${page}&limit=${limit}&ascending=${ascending}&id_role=${idRoleDokter}&name_role=${nameRoleDoctor}`, fetchParams);
      if (response?.status === 200) {
        setGetDataDentalOcclusi(response.data.data);
      }

      // setLoading(false);
    } catch (error) {
      // setLoading(false);
      swal({
        title: 'Failed',
        text: `${error.response?.data?.message || 'Something went wrong'}`,
        icon: 'error',
        timer: 3000,
        buttons: false
      });
    }
  };

  const GetResponseDataDentalTorusPalatinus = async () => {
    try {
      // setLoading(true);
      const response = await API.get(`/emr-service/dental-torus-palatinuses?page=${page}&limit=${limit}&ascending=${ascending}&id_role=${idRoleDokter}&name_role=${nameRoleDoctor}`, fetchParams);
      if (response?.status === 200) {
        setGetDataDentalTorusPalatinus(response.data.data);
      }

      // setLoading(false);
    } catch (error) {
      // setLoading(false);
      swal({
        title: 'Failed',
        text: `${error.response?.data?.message || 'Something went wrong'}`,
        icon: 'error',
        timer: 3000,
        buttons: false
      });
    }
  };

  const GetResponseDataDentalTorusMandibularis = async () => {
    try {
      // setLoading(true);
      const response = await API.get(`/emr-service/dental-torus-mandibularises?page=${page}&limit=${limit}&ascending=${ascending}&id_role=${idRoleDokter}&name_role=${nameRoleDoctor}`, fetchParams);
      if (response?.status === 200) {
        setGetDataDentalTorusMandiBularis(response.data.data);
      }

      // setLoading(false);
    } catch (error) {
      // setLoading(false);
      swal({
        title: 'Failed',
        text: `${error.response?.data?.message || 'Something went wrong'}`,
        icon: 'error',
        timer: 3000,
        buttons: false
      });
    }
  };

  const GetResponseDataDentalPalatum = async () => {
    try {
      // setLoading(true);
      const response = await API.get(`/emr-service/dental-palantum?page=${page}&limit=${limit}&ascending=${ascending}&id_role=${idRoleDokter}&name_role=${nameRoleDoctor}`, fetchParams);
      if (response?.status === 200) {
        setGetDataDentalPalatum(response.data.data);
      }

      // setLoading(false);
    } catch (error) {
      // setLoading(false);
      swal({
        title: 'Failed',
        text: `${error.response?.data?.message || 'Something went wrong'}`,
        icon: 'error',
        timer: 3000,
        buttons: false
      });
    }
  };

  const GetResponseDataDentalDiastema = async () => {
    try {
      // setLoading(true);
      const response = await API.get(`/emr-service/dental-diastemas?page=${page}&limit=${limit}&ascending=${ascending}&id_role=${idRoleDokter}&name_role=${nameRoleDoctor}`, fetchParams);
      if (response?.status === 200) {
        setGetDataDentalDiastema(response.data.data);
      }

      // setLoading(false);
    } catch (error) {
      // setLoading(false);
      swal({
        title: 'Failed',
        text: `${error.response?.data?.message || 'Something went wrong'}`,
        icon: 'error',
        timer: 3000,
        buttons: false
      });
    }
  };

  const GetResponseDataDentalAnomali = async () => {
    try {
      // setLoading(true);
      const response = await API.get(`/emr-service/dental-anomalis?page=${page}&limit=${limit}&ascending=${ascending}&id_role=${idRoleDokter}&name_role=${nameRoleDoctor}`, fetchParams);
      if (response?.status === 200) {
        setGetDataDentalAnomali(response.data.data);
      }

      // setLoading(false);
    } catch (error) {
      // setLoading(false);
      swal({
        title: 'Failed',
        text: `${error.response?.data?.message || 'Something went wrong'}`,
        icon: 'error',
        timer: 3000,
        buttons: false
      });
    }
  };


  const GetResponseDataApprovalByTreatmentPlan = async () => {
    try {
      // e.preventDefault();
      // setLoading(true)
      const response = await API.get(`/emr-service/treatment-plans/${getDataAppointmentByIdTreatmentPlan}`, fetchParams)

      // Checking process
      if (response?.status === 200) {
        setGetDataDetailsApproval(response.data.data.details)
        // setLoading(false)
      }
    } catch (error) {
      // setLoading(false)
      swal({
        title: 'Failed',
        text: `${error.response.data.message}`,
        icon: 'error',
        timer: 3000,
        buttons: false
      });
    }
  }

  const GetResponseDataByIdAppointmentTreatmentPlan = async () => {
    try {
      // e.preventDefault();
      setLoading(true)
      const response = await API.get(`/emr-service/treatment-plans/appointment/${id}`, fetchParams)
      // Checking process
      if (response?.status === 200) {
        setGetDataAppointmentByIdTreatmentPlan(response.data.data.length === 0 || response.data.data.treatment_plan_data === null ? "" : response.data.data.id)
        setGetDataAppointmentByIdTreatmentPlanStatusButton(response.data.data)
      }
    } catch (error) {
      setGetDataAppointmentByIdTreatmentPlan("")
      setGetDataAppointmentByIdTreatmentPlanStatusButton(null)
      // swal({
      //   title: 'Failed',
      //   text: `${error.response.data.message}`,
      //   icon: 'error',
      //   timer: 3000,
      //   buttons: false
      // });
    }
  }

  function calculateTotalPrice() {
    let totalPrice = 0;
    inputList.forEach((item) => {
      const estimatePrice = parseFloat(item.estimate_price);
      if (!isNaN(estimatePrice)) {
        totalPrice += estimatePrice;
      }
    });
    return totalPrice;
  }


  // untuk auto merender ketika trigger 
  useEffect(() => {
    const loadAllData = async () => {
      setLoading(true);
      try {
        await Promise.all([
          fetchDataRef.current(), // fetch utama
        ]);
        await GetResponseDataDentalCondition();
        await GetResponseDataDentalRestoration();
        await GetResponseDataDentalRestorationMaterial();
        await GetResponseDataDentalProtesa();
        await GetResponseDataDentalProtesaMaterial();
        await GetResponseDataDentalOcclusi();
        await GetResponseDataDentalTorusPalatinus();
        await GetResponseDataDentalTorusMandibularis();
        await GetResponseDataDentalPalatum();
        await GetResponseDataDentalDiastema();
        await GetResponseDataDentalAnomali();
        setModalCardReminder(true);
      } catch (error) {
        swal({
          title: 'Failed',
          text: `${error.response?.data?.message || 'Something went wrong'}`,
          icon: 'error',
          timer: 3000,
          buttons: false
        });
      } finally {
        setLoading(false);
      }
    };

    fetchDataRef.current = fetchData;
    loadAllData();
  }, []);


  const handleCloseModal = () => {
    setModalCardReminder(false)
  }

  // useEffect(() => {
  //   const loadAllData = async () => {
  //     try {
  //       await Promise.all([
  //         GetResponseDataDentalCondition(),
  //         GetResponseDataDentalRestoration(),
  //         GetResponseDataDentalRestorationMaterial(),
  //         GetResponseDataDentalProtesa(),
  //         GetResponseDataDentalProtesaMaterial(),
  //         GetResponseDataDentalOcclusi(),
  //         GetResponseDataDentalTorusPalatinus(),
  //         GetResponseDataDentalTorusMandibularis(),
  //         GetResponseDataDentalPalatum(),
  //         GetResponseDataDentalDiastema(),
  //         GetResponseDataDentalAnomali(),
  //       ]);
  //     } catch (error) {
  //       console.error(error);
  //     }
  //   };

  //   loadAllData();
  // }, []);




  useEffect(() => {
    if (getDataApprovalById.length !== 0) {
      GetResponseDataByIdAppointmentTreatmentPlan()
      GetResponseDataApproval()
    }
  }, [getDataApprovalById])

  useEffect(() => {
    if (getDataAppointmentByIdTreatmentPlan.length !== 0) {
      GetResponseDataApprovalByTreatmentPlan()
    }
  }, [getDataAppointmentByIdTreatmentPlan])


  const convertToPayloadArray = (obj) =>
    Object.entries(obj).map(([tooth, datas]) => ({
      tooth_number: tooth,
      datas,
    }));



  useEffect(() => {
    const allToothKeys = Object.keys(selectedToothData || {}).join(" ");

    let allToothConditions = [];
    let allToothRestorations = [];
    let allToothRestorationMaterials = [];
    let allToothProtesas = [];
    let allTootProtesaMaterial = [];
    let allToothDebrisIndex = [];
    let allToothKalkulusIndex = [];

    inputList.forEach((user) => {
      const toothData = user?.tooth_conditions;
      if (toothData && typeof toothData === 'object') {
        Object.entries(toothData).forEach(([tooth_number, datas]) => {
          allToothConditions.push({
            tooth_number,
            datas,
          });
        });
      }
    });

    inputList.forEach((user) => {
      const toothData = user.tooth_restorations;
      if (toothData && typeof toothData === 'object') {
        Object.entries(toothData).forEach(([tooth_number, datas]) => {
          allToothRestorations.push({
            tooth_number,
            datas,
          });
        });
      }
    });

    inputList.forEach((user) => {
      const toothData = user.tooth_restoration_materials;
      if (toothData && typeof toothData === 'object') {
        Object.entries(toothData).forEach(([tooth_number, datas]) => {
          allToothRestorationMaterials.push({
            tooth_number,
            datas,
          });
        });
      }
    });

    inputList.forEach((user) => {
      const toothData = user.tooth_protesas;
      if (toothData && typeof toothData === 'object') {
        Object.entries(toothData).forEach(([tooth_number, datas]) => {
          allToothProtesas.push({
            tooth_number,
            datas,
          });
        });
      }
    });

    inputList.forEach((user) => {
      const toothData = user.tooth_protesa_materials;
      if (toothData && typeof toothData === 'object') {
        Object.entries(toothData).forEach(([tooth_number, datas]) => {
          allTootProtesaMaterial.push({
            tooth_number,
            datas,
          });
        });
      }
    });

    inputList.forEach((user) => {
      const toothData = user.tooth_debris_index;
      if (toothData && typeof toothData === 'object') {
        Object.entries(toothData).forEach(([tooth_number, datas]) => {
          allToothDebrisIndex.push({
            tooth_number,
            datas,
          });
        });
      }
    });

    inputList.forEach((user) => {
      const toothData = user.tooth_kalkulus_index;
      if (toothData && typeof toothData === 'object') {
        Object.entries(toothData).forEach(([tooth_number, datas]) => {
          allToothKalkulusIndex.push({
            tooth_number,
            datas,
          });
        });
      }
    });

    setForm({
      ...form,
      id_appointment: `${id}`,
      id_doctor: `${getDataAppointmentById?.id_doctor}`,
      id_patient: `${getDataAppointmentById?.id_patient}`,
      name_patient_firstname: `${getDataAppointmentByIdPatient?.first_name}`,
      name_patient_lastname: `${getDataAppointmentByIdPatient?.last_name}`,
      name_doctor_firstname: `${getDataAppointmentByIdDoctor?.firstname}`,
      name_doctor_lastname: `${getDataAppointmentByIdDoctor?.lastname}`,
      anamnesa: `${getDataAppointmentById?.anamnesa}`,
      date_plan: `${getDataAppointmentById?.date}`,
      time: `${getDataAppointmentById?.time}`,
      other_dental_oral_conditions: form.other_dental_oral_conditions || '',
      number_of_decayed_teeth: form.number_of_decayed_teeth || '',
      number_of_missing_teeth: form.number_of_missing_teeth || '',
      number_of_teeth_filled: form.number_of_teeth_filled || '',

      description_tooth_diastema: descriptionDiastema,
      description_tooth_anomali: descriptionAnomali,


      // Masukkan hasil konversi ke dalam form
      tooth_number: allToothKeys,
      tooth_conditions: allToothConditions,
      tooth_restorations: allToothRestorations,
      tooth_restoration_materials: allToothRestorationMaterials,
      tooth_protesas: allToothProtesas,
      tooth_protesa_materials: allTootProtesaMaterial,
      tooth_debris_index: allToothDebrisIndex,
      tooth_kalkulus_index: allToothKalkulusIndex,
      tooth_occlusis: onlyDisplayNameOcclusi,
      tooth_torus_palatinus:
        Object.values(onlyDisplayNameTorusPalatinus || {}).flat()[0]?.id || "",
      tooth_torus_mandibularis:
        Object.values(onlyDisplayNameTorusMandibularis || {}).flat()[0]?.id || "",
      tooth_palatum:
        Object.values(onlyDisplayNamePalatum || {}).flat()[0]?.id || "",
      tooth_diastema:
        Object.values(onlyDisplayNameDiastema || {}).flat()[0]?.id || "",
      tooth_anomali:
        Object.values(onlyDisplayNameAnomali || {}).flat()[0]?.id || "",


      // tooth_palatum: convertToPayloadArray(selectedToothDataPalatum),
      // tooth_diastema: convertToPayloadArray(selectedToothDataDiastema),
      // tooth_anomali: convertToPayloadArray(selectedToothDataAnomali),
    });

    setGetDataItem({
      ...dataItem,
      assistants: [
        `${getDataAppointmentArragmentData?.id_nurse}`,
        `${getDataAppointmentArragmentData?.id_nurse2}`,
      ],
      id_room: `${getDataAppointmentArragmentData?.id_room}`,
      id_doctor: `${getDataAppointmentById?.id_doctor}`,
    });
  }, [
    getDataAppointmentById,
    getDataAppointmentByIdDoctor,
    getDataAppointmentByIdPatient,
    getDataAppointmentArragmentData,
    selectedToothData,
    selectedToothDataRestoration,
    onlyDisplayNameOcclusi,
    onlyDisplayNameTorusPalatinus,
    onlyDisplayNameTorusMandibularis,
    onlyDisplayNamePalatum,
    onlyDisplayNameDiastema,
    onlyDisplayNameAnomali,
    inputList,
  ]);

  useEffect(() => {
    if (getDataAppointmentById) {
      // Dapatkan id_doctor dari getDataAppointmentById
      const newIdDoctor = getDataAppointmentById?.id_doctor;

      // Update nilai id_doctor pada inputList
      setInputList((prevInputList) => {
        // Copy inputList yang lama dan ubah id_doctor
        const updatedInputList = prevInputList.map((item) => ({
          ...item,
          id_doctor: newIdDoctor
        }));
        return updatedInputList;
      });
    }
  }, [getDataAppointmentById]);

  useEffect(() => {
    setToothConditions(prev => {
      const cleaned = {};
      Object.entries(prev).forEach(([key, val]) => {
        cleaned[key.trim()] = val;
      });
      return cleaned;
    });
  }, []);

  useEffect(() => {
    if (getDataTreatmentById) {
      const newEstimatePricemin = getDataTreatmentById?.treatment_price_min;
      const newEstimatePricemax = getDataTreatmentById?.treatment_price_max;

      setInputList((prevInputList) => {
        const updatedInputList = prevInputList.map((item, index) => ({
          ...item,
          estimate_price: newEstimatePricemin,
          treatment_price_min: newEstimatePricemin,
          treatment_price_max: newEstimatePricemax,
        }));
        return updatedInputList;
      });
    }
  }, [getDataTreatmentById]);

  useEffect(() => {
    setInputList(inputList => {
      return inputList.map(item => ({
        ...item,
        id_room: form.id_room
      }));
    });
  }, [form.id_room]);

  useEffect(() => {
    setInputList(inputList => {
      return inputList.map(item => ({
        ...item,
        assistants: [form?.id_nurse1, form?.id_nurse2]
      }));
    });
  }, [form?.id_nurse1, form?.id_nurse2]);

  useEffect(() => {
    if (dataItem?.id_treatment) {
      const selectedTreatment = getDataTreatment.find((treatment) => treatment.id === dataItem.id_treatment);

      if (selectedTreatment) {
        setGetDataItem((prevDataItem) => ({
          ...prevDataItem,
          treatment_price_min: selectedTreatment.treatment_price_min,
          treatment_price_max: selectedTreatment.treatment_price_max,
          estimate_price: selectedTreatment.treatment_price_min,
        }));
      }
    }
  }, [dataItem.id_treatment, getDataTreatment]);

  useEffect(() => {
    // if (formchoiceGigi?.choiceGigi === "ra_rb_full") {
    //   const polygons = document.querySelectorAll(`polygon`);
    //   polygons.forEach((polygon) => {
    //     polygon.style.fill = 'white';
    //   });
    //   setGetDataItem({
    //     ...dataItem,
    //     tooth_number: " 18  17  16  15  14  13  12  11  21  22  23  24  25  26  27  28  55  54  53  52  51  61  62  63  64  65  85  84  83  82  81  71  72  73  74  75  48  47  46  45  44  43  42  41  31  32  33  34  35  36  37  38 ",
    //   });
    //   const selectedToothNumbers = [" 18 ", " 17 ", " 16 ", " 15 ", " 14 ", " 13 ", " 12 ", " 11 ", " 21 ", " 22 ", " 23 ", " 24 ", " 25 ", " 26 ", " 27 ", " 28 ", " 55 ", " 54 ", " 53 ", " 52 ", " 51 ", " 61 ", " 62 ", " 63 ", " 64 ", " 65 ", " 85 ", " 84 ", " 83 ", " 82 ", " 81 ", " 71 ", " 72 ", " 73 ", " 74 ", " 75 ", " 48 ", " 47 ", " 46 ", " 45 ", " 44 ", " 43 ", " 42 ", " 41 ", " 31 ", " 32 ", " 33 ", " 34 ", " 35 ", " 36 ", " 37 ", " 38 "];
    //   selectedToothNumbers.forEach((toothNumber) => {
    //     const polygons = document.querySelectorAll(`polygon[data-nomor-gigi="${toothNumber}"]`);
    //     polygons.forEach((polygon) => {
    //       polygon.style.fill = 'aqua';
    //     });
    //   });
    // }


    if (formchoiceGigi?.choiceGigi === "ra_rb_dewasa") {
      const polygons = document.querySelectorAll(`polygon`);
      polygons.forEach((polygon) => {
        polygon.style.fill = 'white';
      });
      setGetDataItem({
        ...dataItem,
        tooth_number: " 18  17  16  15  14  13  12  11  21  22  23  24  25  26  27  28  48  47  46  45  44  43  42  41  31  32  33  34  35  36  37  38 ",
      });
      const selectedToothNumbers = [" 18 ", " 17 ", " 16 ", " 15 ", " 14 ", " 13 ", " 12 ", " 11 ", " 21 ", " 22 ", " 23 ", " 24 ", " 25 ", " 26 ", " 27 ", " 28 ", " 48 ", " 47 ", " 46 ", " 45 ", " 44 ", " 43 ", " 42 ", " 41 ", " 31 ", " 32 ", " 33 ", " 34 ", " 35 ", " 36 ", " 37 ", " 38 "];
      selectedToothNumbers.forEach((toothNumber) => {
        const polygons = document.querySelectorAll(`polygon[data-nomor-gigi="${toothNumber}"]`);
        polygons.forEach((polygon) => {
          polygon.style.fill = 'aqua';
        });
      });
    }
    if (formchoiceGigi?.choiceGigi === "ra_rb_anak") {
      const polygons = document.querySelectorAll(`polygon`);
      polygons.forEach((polygon) => {
        polygon.style.fill = 'white';
      });
      setGetDataItem({
        ...dataItem,
        tooth_number: " 55  54  53  52  51  61  62  63  64  65  85  84  83  82  81  71  72  73  74  75 ",
      });
      const selectedToothNumbers = [" 55 ", " 54 ", " 53 ", " 52 ", " 51 ", " 61 ", " 62 ", " 63 ", " 64 ", " 65 ", " 85 ", " 84 ", " 83 ", " 82 ", " 81 ", " 71 ", " 72 ", " 73 ", " 74 ", " 75 "];
      selectedToothNumbers.forEach((toothNumber) => {
        const polygons = document.querySelectorAll(`polygon[data-nomor-gigi="${toothNumber}"]`);
        polygons.forEach((polygon) => {
          polygon.style.fill = 'aqua';
        });
      });
    }
    if (formchoiceGigi?.choiceGigi === "ra_dewasa_anak") {
      const polygons = document.querySelectorAll(`polygon`);
      polygons.forEach((polygon) => {
        polygon.style.fill = 'white';
      });
      setGetDataItem({
        ...dataItem,
        tooth_number: " 18  17  16  15  14  13  12  11  21  22  23  24  25  26  27  28  55  54  53  52  51  61  62  63  64  65 ",
      });
      const selectedToothNumbers = [" 18 ", " 17 ", " 16 ", " 15 ", " 14 ", " 13 ", " 12 ", " 11 ", " 21 ", " 22 ", " 23 ", " 24 ", " 25 ", " 26 ", " 27 ", " 28 ", " 55 ", " 54 ", " 53 ", " 52 ", " 51 ", " 61 ", " 62 ", " 63 ", " 64 ", " 65 "];
      selectedToothNumbers.forEach((toothNumber) => {
        const polygons = document.querySelectorAll(`polygon[data-nomor-gigi="${toothNumber}"]`);
        polygons.forEach((polygon) => {
          polygon.style.fill = 'aqua';
        });
      });
    }
    if (formchoiceGigi?.choiceGigi === "ra_dewasa") {
      const polygons = document.querySelectorAll(`polygon`);
      polygons.forEach((polygon) => {
        polygon.style.fill = 'white';
      });
      setGetDataItem({
        ...dataItem,
        tooth_number: " 18  17  16  15  14  13  12  11  21  22  23  24  25  26  27  28 ",
      });
      const selectedToothNumbers = [" 18 ", " 17 ", " 16 ", " 15 ", " 14 ", " 13 ", " 12 ", " 11 ", " 21 ", " 22 ", " 23 ", " 24 ", " 25 ", " 26 ", " 27 ", " 28 "];
      selectedToothNumbers.forEach((toothNumber) => {
        const polygons = document.querySelectorAll(`polygon[data-nomor-gigi="${toothNumber}"]`);
        polygons.forEach((polygon) => {
          polygon.style.fill = 'aqua';
        });
      });
    }
    if (formchoiceGigi?.choiceGigi === "ra_anak") {
      const polygons = document.querySelectorAll(`polygon`);
      polygons.forEach((polygon) => {
        polygon.style.fill = 'white';
      });
      setGetDataItem({
        ...dataItem,
        tooth_number: " 55  54  53  52  51  61  62  63  64  65 ",
      });
      const selectedToothNumbers = [" 55 ", " 54 ", " 53 ", " 52 ", " 51 ", " 61 ", " 62 ", " 63 ", " 64 ", " 65 "];
      selectedToothNumbers.forEach((toothNumber) => {
        const polygons = document.querySelectorAll(`polygon[data-nomor-gigi="${toothNumber}"]`);
        polygons.forEach((polygon) => {
          polygon.style.fill = 'aqua';
        });
      });
    }
    if (formchoiceGigi?.choiceGigi === "rb_dewasa_anak") {
      const polygons = document.querySelectorAll(`polygon`);
      polygons.forEach((polygon) => {
        polygon.style.fill = 'white';
      });
      setGetDataItem({
        ...dataItem,
        tooth_number: " 85  84  83  82  81  71  72  73  74  75  48  47  46  45  44  43  42  41  31  32  33  34  35  36  37  38 ",
      });
      const selectedToothNumbers = [" 85 ", " 84 ", " 83 ", " 82 ", " 81 ", " 71 ", " 72 ", " 73 ", " 74 ", " 75 ", " 48 ", " 47 ", " 46 ", " 45 ", " 44 ", " 43 ", " 42 ", " 41 ", " 31 ", " 32 ", " 33 ", " 34 ", " 35 ", " 36 ", " 37 ", " 38 "];
      selectedToothNumbers.forEach((toothNumber) => {
        const polygons = document.querySelectorAll(`polygon[data-nomor-gigi="${toothNumber}"]`);
        polygons.forEach((polygon) => {
          polygon.style.fill = 'aqua';
        });
      });
    }
    if (formchoiceGigi?.choiceGigi === "rb_dewasa") {
      const polygons = document.querySelectorAll(`polygon`);
      polygons.forEach((polygon) => {
        polygon.style.fill = 'white';
      });
      setGetDataItem({
        ...dataItem,
        tooth_number: " 48  47  46  45  44  43  42  41  31  32  33  34  35  36  37  38 ",
      });
      const selectedToothNumbers = [" 48 ", " 47 ", " 46 ", " 45 ", " 44 ", " 43 ", " 42 ", " 41 ", " 31 ", " 32 ", " 33 ", " 34 ", " 35 ", " 36 ", " 37 ", " 38 "];
      selectedToothNumbers.forEach((toothNumber) => {
        const polygons = document.querySelectorAll(`polygon[data-nomor-gigi="${toothNumber}"]`);
        polygons.forEach((polygon) => {
          polygon.style.fill = 'aqua';
        });
      });
    }
    if (formchoiceGigi?.choiceGigi === "rb_anak") {
      const polygons = document.querySelectorAll(`polygon`);
      polygons.forEach((polygon) => {
        polygon.style.fill = 'white';
      });
      setGetDataItem({
        ...dataItem,
        tooth_number: " 85  84  83  82  81  71  72  73  74  75 ",
      });
      const selectedToothNumbers = [" 85 ", " 84 ", " 83 ", " 82 ", " 81 ", " 71 ", " 72 ", " 73 ", " 74 ", " 75 "];
      selectedToothNumbers.forEach((toothNumber) => {
        const polygons = document.querySelectorAll(`polygon[data-nomor-gigi="${toothNumber}"]`);
        polygons.forEach((polygon) => {
          polygon.style.fill = 'aqua';
        });
      });
    }
    if (formchoiceGigi?.choiceGigi === "regio_1") {
      const polygons = document.querySelectorAll(`polygon`);
      polygons.forEach((polygon) => {
        polygon.style.fill = 'white';
      });
      setGetDataItem({
        ...dataItem,
        tooth_number: " 18  17  16  15  14  13  12  11 ",
      });
      const selectedToothNumbers = [" 18 ", " 17 ", " 16 ", " 15 ", " 14 ", " 13 ", " 12 ", " 11 "];
      selectedToothNumbers.forEach((toothNumber) => {
        const polygons = document.querySelectorAll(`polygon[data-nomor-gigi="${toothNumber}"]`);
        polygons.forEach((polygon) => {
          polygon.style.fill = 'aqua';
        });
      });
    }
    if (formchoiceGigi?.choiceGigi === "regio_2") {
      const polygons = document.querySelectorAll(`polygon`);
      polygons.forEach((polygon) => {
        polygon.style.fill = 'white';
      });
      setGetDataItem({
        ...dataItem,
        tooth_number: " 21  22  23  24  25  26  27  28 ",
      });
      const selectedToothNumbers = [" 21 ", " 22 ", " 23 ", " 24 ", " 25 ", " 26 ", " 27 ", " 28 "];
      selectedToothNumbers.forEach((toothNumber) => {
        const polygons = document.querySelectorAll(`polygon[data-nomor-gigi="${toothNumber}"]`);
        polygons.forEach((polygon) => {
          polygon.style.fill = 'aqua';
        });
      });
    }
    if (formchoiceGigi?.choiceGigi === "regio_3") {
      const polygons = document.querySelectorAll(`polygon`);
      polygons.forEach((polygon) => {
        polygon.style.fill = 'white';
      });
      setGetDataItem({
        ...dataItem,
        tooth_number: " 31  32  33  34  35  36  37  38 ",
      });
      const selectedToothNumbers = [" 31 ", " 32 ", " 33 ", " 34 ", " 35 ", " 36 ", " 37 ", " 38 "];
      selectedToothNumbers.forEach((toothNumber) => {
        const polygons = document.querySelectorAll(`polygon[data-nomor-gigi="${toothNumber}"]`);
        polygons.forEach((polygon) => {
          polygon.style.fill = 'aqua';
        });
      });
    }
    if (formchoiceGigi?.choiceGigi === "regio_4") {
      const polygons = document.querySelectorAll(`polygon`);
      polygons.forEach((polygon) => {
        polygon.style.fill = 'white';
      });
      setGetDataItem({
        ...dataItem,
        tooth_number: " 48  47  46  45  44  43  42  41 ",
      });
      const selectedToothNumbers = [" 48 ", " 47 ", " 46 ", " 45 ", " 44 ", " 43 ", " 42 ", " 41 "];
      selectedToothNumbers.forEach((toothNumber) => {
        const polygons = document.querySelectorAll(`polygon[data-nomor-gigi="${toothNumber}"]`);
        polygons.forEach((polygon) => {
          polygon.style.fill = 'aqua';
        });
      });
    }
    if (formchoiceGigi?.choiceGigi === "regio_5") {
      const polygons = document.querySelectorAll(`polygon`);
      polygons.forEach((polygon) => {
        polygon.style.fill = 'white';
      });
      setGetDataItem({
        ...dataItem,
        tooth_number: " 55  54  53  52  51 ",
      });
      const selectedToothNumbers = [" 55 ", " 54 ", " 53 ", " 52 ", " 51 "];
      selectedToothNumbers.forEach((toothNumber) => {
        const polygons = document.querySelectorAll(`polygon[data-nomor-gigi="${toothNumber}"]`);
        polygons.forEach((polygon) => {
          polygon.style.fill = 'aqua';
        });
      });
    }
    if (formchoiceGigi?.choiceGigi === "regio_6") {
      const polygons = document.querySelectorAll(`polygon`);
      polygons.forEach((polygon) => {
        polygon.style.fill = 'white';
      });
      setGetDataItem({
        ...dataItem,
        tooth_number: " 61  62  63  64  65 ",
      });
      const selectedToothNumbers = [" 61 ", " 62 ", " 63 ", " 64 ", " 65 "];
      selectedToothNumbers.forEach((toothNumber) => {
        const polygons = document.querySelectorAll(`polygon[data-nomor-gigi="${toothNumber}"]`);
        polygons.forEach((polygon) => {
          polygon.style.fill = 'aqua';
        });
      });
    }
    if (formchoiceGigi?.choiceGigi === "regio_7") {
      const polygons = document.querySelectorAll(`polygon`);
      polygons.forEach((polygon) => {
        polygon.style.fill = 'white';
      });
      setGetDataItem({
        ...dataItem,
        tooth_number: " 71  72  73  74  75 ",
      });
      const selectedToothNumbers = [" 71 ", " 72 ", " 73 ", " 74 ", " 75 "];
      selectedToothNumbers.forEach((toothNumber) => {
        const polygons = document.querySelectorAll(`polygon[data-nomor-gigi="${toothNumber}"]`);
        polygons.forEach((polygon) => {
          polygon.style.fill = 'aqua';
        });
      });
    }
    if (formchoiceGigi?.choiceGigi === "regio_8") {
      const polygons = document.querySelectorAll(`polygon`);
      polygons.forEach((polygon) => {
        polygon.style.fill = 'white';
      });
      setGetDataItem({
        ...dataItem,
        tooth_number: " 85  84  83  82  81 ",
      });
      const selectedToothNumbers = [" 85 ", " 84 ", " 83 ", " 82 ", " 81 "];
      selectedToothNumbers.forEach((toothNumber) => {
        const polygons = document.querySelectorAll(`polygon[data-nomor-gigi="${toothNumber}"]`);
        polygons.forEach((polygon) => {
          polygon.style.fill = 'aqua';
        });
      });
    }
  }, [formchoiceGigi.choiceGigi]);

  const handleChange = (e) => {
    // resetPolygonColors();
    // handleResetPolygon();
    const { name, value } = e.target

    setChoiceToothCategory(value)

    setFormchoiceGigi({
      ...formchoiceGigi,
      [e.target.name]: e.target.value,
    });
  };



  const handleChangeForm = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = useMutation(async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      // Hitung total harga estimasi
      const totalPrice = calculateTotalPrice();

      const updatedForm = {
        ...form,
        estimate_price_total: totalPrice,
      };



      const response = await API.post("/emr-service/treatment-plans/store", {
        ...updatedForm,
        treatments: cleanedArrayInputList,
      }, fetchParams);


      // Checking process
      if (response?.status === 200) {
        try {
          const requestData = {
            time_finish: moment().format('HH:mm:ss'),
            id_appointment: idParams?.id,
            date: getDataAppointmentById?.waiting_data?.date,
            time_start: getDataAppointmentById?.waiting_data?.time_start
          };
          // Kirim tanpa `date` jika kosong
          await API.put(
            `/transaction-service/waiting-lists/${getDataAppointmentById?.waiting_data?.id}`,
            requestData,
            fetchParams
          );
        } catch (error) {
          console.log(error)
        }
        navigateHome()
        swal({
          title: 'Success',
          text: response.data.message,
          icon: 'success',
          timer: 5000,
          buttons: false
        });
        // setGetDataApprovalById(response.data.id)
        setLoading(false);
      }
    } catch (error) {
      swal({
        title: 'Failed',
        text: `${error.response.data.message}`,
        icon: 'error',
        timer: 3000,
        buttons: false
      });
      setLoading(false);
    }
  });

  const handleInputChange = (e, index, fieldName) => {
    setGetDataItem({
      ...dataItem,
      [e.target.name]: e.target.value,
    });
  };

  const handleInputChange2 = (e) => {
    setGetDataItem({
      ...dataItem,
      id_treatment: e.value,
    });
  };

  const handleInputChange3 = (e) => {
    const selectedDiagnosa = getDataDiagnosaPatient.find(
      (user) => user.id === e.value
    );

    setGetDataItem({
      ...dataItem,
      id_description: e.value,
      description: selectedDiagnosa ? selectedDiagnosa.name_str : "",
      code_description: selectedDiagnosa ? selectedDiagnosa.code_skri : "",
    });
  };


  const initialDataItem = {
    id_doctor: `${getDataAppointmentById?.id_doctor}`,
    id_treatment: "",
    id_room: dataItem.id_room,
    tooth_number: "",
    qty: "1",
    choiceGigi: "satu_gigi",
    treatment_price_min: "",
    treatment_price_max: "",
    estimate_price: "",
    description: "",
    id_description: "",
    code_description: "",
    oral_condition_note: "",
    assistants: dataItem.assistants,

    other_dental_oral_condition: "",
  };

  const initialDataItemReset = {
    // id_doctor: "",
    id_treatment: "",
    id_room: dataItem.id_room,
    tooth_number: "",
    qty: "1",
    choiceGigi: "satu_gigi",
    treatment_price_min: "",
    treatment_price_max: "",
    estimate_price: "",
    description: "",
    id_description: "",
    code_description: "",
    assistants: dataItem.assistants,
  };

  const initialForm = {
    choiceGigi: "satu_gigi"
  };

  const resetPolygonColors = () => {
    const polygons = document.querySelectorAll('polygon');

    polygons.forEach((polygon) => {
      const fill = polygon.style.fill;

      // Kalau warnanya tidak putih dan ada nilainya, reset
      if (fill && fill !== 'white') {
        polygon.style.fill = 'white';
      }

      // Atau jika ingin reset semua tanpa pengecualian:
      // polygon.style.fill = 'white';
    });
  };

  const [selectKey, setSelectKey] = useState(0);

  const [selectKeyDiagnosa, setSelectKeyDiagnosa] = useState(0);

  const resetSelect = () => {
    setSelectKey(prevKey => prevKey + 1);
    setSelectKeyDiagnosa(prevKey => prevKey + 1);
  };

  const resetAllToothStates = () => {
    // condition
    setToothConditions({});
    setGetDataDentalCondition(prev =>
      prev.map(item => ({ ...item, checked: false }))
    );
    setKondisiGigi("");
    setIsApplyConditionMode(false)
    setIsKondisiClicked(false);
    setTempSelections([]);
    setActiveConditionSelections([])

    // // restoration
    setToothRestorations({});
    setGetDataDentalRestoration(prev =>
      prev.map(item => ({ ...item, checked: false }))
    );
    setRestorasiGigi("");
    setIsApplyRestorasiMode(false)
    setIsRestorasiClicked(false);
    setTempRestorasiSelections([]);
    setActiveRestorasiSelections([])

    // // restoration material
    setToothRestorationMaterials({});
    setGetDataDentalRestorationMaterial(prev =>
      prev.map(item => ({ ...item, checked: false }))
    );
    setRestorasiMaterialGigi("");
    setIsApplyRestorasiMaterialMode(false)
    setIsRestorasiMaterialClicked(false);
    setTempRestorasiMaterialSelections([]);
    setActiveRestorasiMaterialSelections([])

    // protesa
    setToothProtesas({});
    setGetDataDentalProtesa(prev =>
      prev.map(item => ({ ...item, checked: false }))
    );
    setProtesaGigi("");
    setIsApplyProtesaMode(false)
    setIsProtesaClicked(false);
    setTempProtesaSelections([]);
    setActiveProtesaSelections([])

    // setSelectedTeeth([]);
    // setInfoGigi("XX-X");
    // setGetDataItem(initialDataItem);
    // setFormchoiceGigi(initialForm);

    // resetPolygonColors();
    // // resetSelect();
    // setResetKey(prev => prev + 1);
    // handlePolygonClickSatuBagian(
    //   { target: { getAttribute: () => selectedTooth[0]?.toString() || "" } },
    //   "tooth_number",
    //   true
    // );

    // protesa Material
    setToothProtesaMaterial({});
    setGetDataDentalProtesaMaterial(prev =>
      prev.map(item => ({ ...item, checked: false }))
    );
    setProtesaMaterialGigi("");
    setIsApplyProtesaMaterialMode(false)
    setTempProtesaMaterialSelections([]);
    setActiveProtesaMaterialSelections([])

    // // Occlusi
    setToothOcclusi({});
    setGetDataDentalOcclusi(prev =>
      prev.map(item => ({ ...item, checked: false }))
    );
    setOcclusiGigi("");
    setIsApplyOcclusiMode(false)
    setIsOcclusiClicked(false);
    setTempOcclusiSelections([]);
    setActiveOcclusiSelections([])

    // // TorusPalatinus
    setToothTorusPalatinus({});
    setGetDataDentalTorusPalatinus(prev =>
      prev.map(item => ({ ...item, checked: false }))
    );
    setTorusPalatinusGigi("");
    setIsApplyTorusPalatinusMode(false)
    setIsTorusPalatinusClicked(false);
    setTempTorusPalatinusSelections([]);
    // setActiveTorusPalatinusSelections([])

    // // TorusMandibularis
    setToothTorusMandiBularis({});
    setGetDataDentalTorusMandiBularis(prev =>
      prev.map(item => ({ ...item, checked: false }))
    );
    setTorusMandiBularisGigi("");
    setIsApplyTorusMandiBularisMode(false)
    setIsTorusMandiBularisClicked(false);
    setTempTorusMandiBularisSelections([]);
    setActiveTorusMandiBularisSelections([]);

    // // palatum
    setToothPalatum({});
    setGetDataDentalPalatum(prev =>
      prev.map(item => ({ ...item, checked: false }))
    );
    setPalatumGigi("");
    setIsApplyPalatumMode(false)
    setIsPalatumClicked(false);
    setTempPalatumSelections([]);
    setActivePalatumSelections([]);

    // setSelectedTeeth([]);
    // setInfoGigi("XX-X");
    // setGetDataItem(initialDataItem);
    // setFormchoiceGigi(initialForm);

    // // diastemas
    setToothDiastema({});
    setGetDataDentalDiastema(prev =>
      prev.map(item => ({ ...item, checked: false }))
    );
    setDiastemaGigi("");
    setIsApplyDiastemaMode(false)
    setIsDiastemaClicked(false);
    setTempDiastemaSelections([]);
    setActiveDiastemaSelections([]);

    // // anomalis
    setToothAnomali({});
    setGetDataDentalAnomali(prev =>
      prev.map(item => ({ ...item, checked: false }))
    );
    setAnomaliGigi("");
    setIsApplyAnomaliMode(false)
    setIsAnomaliClicked(false);
    setTempAnomaliSelections([]);
    setActiveAnomaliSelections([]);

    // setSelectedTeeth([]);
    // setInfoGigi("XX-X");
    // setGetDataItem(initialDataItem);
    // setFormchoiceGigi(initialForm);



    setForm({
      other_dental_oral_conditions: '',
      number_of_decayed_teeth: '',
      number_of_missing_teeth: '',
      number_of_teeth_filled: '',
    });

    // setOralConditionNote("");
    // setDecayedTeethCountNote("")
    // setToothMissingCountNote("")
    // setToothFilledCountNote("")

    // resetPolygonColors();
    // // resetSelect();
    // setResetKey(prev => prev + 1);
    // handlePolygonClickSatuBagian(
    //   { target: { getAttribute: () => selectedTooth[0]?.toString() || "" } },
    //   "tooth_number",
    //   true
    // );

  };

  useEffect(() => {
    if (Object.keys(toothConditions).length === 0) {
      setKondisiGigi("");
    }

    if (Object.keys(toothRestorations).length === 0) {
      setRestorasiGigi("");
    }

    if (Object.keys(toothRestorationMaterials).length === 0) {
      setRestorasiMaterialGigi("");
    }

    if (Object.keys(toothProtesas).length === 0) {
      setProtesaGigi("");
    }

    if (Object.keys(toothProtesaMaterial).length === 0) {
      setProtesaMaterialGigi("");
    }

    if (Object.keys(toothOcclusi).length === 0) {
      setOcclusiGigi("");
    }

    if (Object.keys(toothTorusPalatinus).length === 0) {
      setTorusPalatinusGigi("");
    }

    if (Object.keys(toothTorusMandiBularis).length === 0) {
      setTorusMandiBularisGigi("");
    }

    if (Object.keys(toothPalatum).length === 0) {
      setPalatumGigi("");
    }

    if (Object.keys(toothDiastema).length === 0) {
      setDiastemaGigi("");
    }

    if (Object.keys(toothAnomali).length === 0) {
      setAnomaliGigi("");
    }
  }, [
    toothConditions,
    toothRestorations,
    toothRestorationMaterials,
    toothProtesas,
    toothProtesaMaterial,
    toothOcclusi,
    toothTorusPalatinus,
    toothTorusMandiBularis,
    toothPalatum,
    toothDiastema,
    toothAnomali
  ]);

  const handleDiastemaDescriptionChange = (desc) => {
    setDescriptionDiastema(desc);
    setForm(prev => ({
      ...prev,
      description_tooth_diastema: desc,
    }));
  };

  const handleAnomaliDescriptionChange = (desc) => {
    setDescriptionAnomali(desc);
    setForm(prev => ({
      ...prev,
      description_tooth_anomali: desc,
    }));
  };

  const handleAddClick = (e) => {

    setModalCardReminderAfter(true)

    const matchingTreatment = getDataTreatment.find(
      item => item.id === dataItem?.id_treatment
    );


    // Pastikan selectedTooth dalam bentuk array
    const toothNumbersArray = [...new Set(selectedTooth)];

    const qty = toothNumbersArray.length;

    console.log("=== DEBUG ===");

    // // ===== Validasi Utama =====
    // if (!matchingTreatment) {
    //   return Swal.fire('Treatment tidak ditemukan', 'Coba pilih ulang', 'error');
    // }

    // // Hanya validasi pemilihan gigi jika bukan "Perawatan Dasar"
    // if (
    //   matchingTreatment.name_category !== "Perawatan Dasar" &&
    //   qty === 0
    // ) {
    //   return Swal.fire(
    //     'Pilih Gigi Terlebih Dahulu',
    //     'Minimal pilih satu gigi',
    //     'warning'
    //   );
    // }

    // if (!dataItem?.id_doctor) {
    //   return Swal.fire(
    //     'Pilih Dokter Terlebih Dahulu',
    //     'Mohon periksa kembali',
    //     'warning'
    //   );
    // }

    // if (!dataItem?.id_treatment) {
    //   return Swal.fire(
    //     'Pilih Treatment Terlebih Dahulu',
    //     'Mohon periksa kembali',
    //     'warning'
    //   );
    // }

    const estimate_price =
      dataItem.estimate_price || matchingTreatment?.price || 0;

    if (estimate_price === 0) {
      setModalCardReminderAfter(false)
      return Swal.fire(
        'Harga Treatment Belum Diisi',
        'Silakan isi atau periksa kembali',
        'warning'
      );
    }

    if (!dataItem?.description) {
      setModalCardReminderAfter(false)
      return Swal.fire(
        'Diagnosa Kosong',
        'Mohon isi terlebih dahulu',
        'warning'
      );
    }

    const conditionDataMapped = {};
    const restorationDataMapped = {};
    const restorationMaterialDataMapped = {};
    const protesaDataMapped = {};
    const protesaMaterialDataMapped = {};
    const occlusiDataMapped = {};


    // Start Debris Index
    const allData = debrisPerTooth;

    const debrisReference = Object.values(allData)
      .flat()
      .filter((item) => item && typeof item === "object" && item.id);


    const onlyDisplayNameDebrisIndex = Object.entries(allData)
      .filter(([_, value]) => Array.isArray(value))
      .reduce((acc, [toothId, arr]) => {
        acc[toothId] = arr
          .map((item) => {
            // Ambil posisi dari constant atau existing data
            const position =
              TOOTH_POSITIONS[toothId] ||
              positionTooth?.[toothId] ||
              null;

            if (item?.id && item?.display_name) {
              return {
                id: item.id,
                display_name: item.display_name,
                position: position?.label || null,
                code_position: position?.code_position || null,
              };
            }

            // kalau item hanya ID → cari di debrisReference
            const found = debrisReference.find((ref) => ref.id === item);

            return found
              ? {
                id: found.id,
                display_name: found.display_name,
                position: position?.label || null,
                code_position: position?.code_position || null,
              }
              : null;
          })
          .filter(Boolean);

        return acc;
      }, {});


    // End Debris Index
    // Start Kalkulus Index
    const allDataKalkulus = kalkulusPerTooth;

    const kalulusReference = Object.values(allDataKalkulus)
      .flat()
      .filter((item) => item && typeof item === "object" && item.id);


    const onlyDisplayNameKalkulusIndex = Object.entries(allDataKalkulus)
      .filter(([_, value]) => Array.isArray(value))
      .reduce((acc, [toothId, arr]) => {
        acc[toothId] = arr
          .map((item) => {

            const position =
              TOOTH_POSITIONS[toothId] ||
              positionTooth?.[toothId] ||
              null;

            if (item?.id && item?.display_name) {
              return {
                id: item.id,
                display_name: item.display_name,
                position: position?.label || null,
                code_position: position?.code_position || null,
              };
            }

            const found = kalulusReference.find((ref) => ref.id === item);

            return found
              ? {
                id: found.id,
                display_name: found.display_name,
                position: position?.label || null,
                code_position: position?.code_position || null,
              }
              : null;
          })
          .filter(Boolean);

        return acc;
      }, {});



    toothNumbersArray.forEach(toothId => {
      conditionDataMapped[toothId] = getDisplayNamesForTooth(toothId, "kondisi");
    });

    selectedTooth.forEach(toothId => {
      restorationDataMapped[toothId] = getDisplayNamesForTooth(toothId, "restorasi");
    });

    selectedTooth.forEach(toothId => {
      restorationMaterialDataMapped[toothId] = getDisplayNamesForTooth(toothId, "restorasi_material");
    });

    selectedTooth.forEach(toothId => {
      protesaDataMapped[toothId] = getDisplayNamesForTooth(toothId, "protesa");
    });

    selectedTooth.forEach(toothId => {
      protesaMaterialDataMapped[toothId] = getDisplayNamesForTooth(toothId, "protesa_material");
    });

    selectedTooth.forEach(toothId => {
      occlusiDataMapped[toothId] = getDisplayNamesForTooth(toothId, "occlusi");
    });

    const onlyDisplayNameConditions = {};
    Object.entries(conditionDataMapped).forEach(([toothId, items]) => {
      onlyDisplayNameConditions[toothId] = items.map(item => ({
        id: item.id,
        display_name: item.display_name
      }));
    });

    setOnlyDisplayNameConditions(onlyDisplayNameConditions)


    const onlyDisplayNameRestorations = {};
    Object.entries(restorationDataMapped).forEach(([toothId, items]) => {
      onlyDisplayNameRestorations[toothId] = items.map(item => ({
        id: item.id,
        display_name: item.display_name
      }));
    });

    const onlyDisplayNameRestorationMaterials = {};
    Object.entries(restorationMaterialDataMapped).forEach(([toothId, items]) => {
      onlyDisplayNameRestorationMaterials[toothId] = items.map(item => ({
        id: item.id,
        display_name: item.display_name
      }));
    });

    const onlyDisplayNameProtesas = {};
    Object.entries(protesaDataMapped).forEach(([toothId, items]) => {
      onlyDisplayNameProtesas[toothId] = items.map(item => ({
        id: item.id,
        display_name: item.display_name
      }));
    });

    const onlyDisplayNameProtesaMaterials = {};
    Object.entries(protesaMaterialDataMapped).forEach(([toothId, items]) => {
      onlyDisplayNameProtesaMaterials[toothId] = items.map(item => ({
        id: item.id,
        display_name: item.display_name
      }));
    });

    const onlyDisplayNameOcclusi = (toothOcclusi[""] || []).map(id => {
      const found = getDataDentalOcclusi.find(item => item.id === id);
      return found ? { id: found.id, display_name: found.display_name } : null;
    }).filter(Boolean);

    setOnlyDisplayNameOcclusi(onlyDisplayNameOcclusi)

    const onlyDisplayNameTorusPalatinus = {};
    Object.entries(toothTorusPalatinus).forEach(([toothId, ids]) => {
      onlyDisplayNameTorusPalatinus[toothId] = ids
        .map(id => {
          const found = getDataDentalTorusPalatinus.find(item => item.id === id);
          return found ? {
            id: found.id,
            display_name: found.display_name,
            description: found.description
          } : null;
        })
        .filter(Boolean);
    });
    setOnlyDisplayNameTorusPalatinus(onlyDisplayNameTorusPalatinus);

    const onlyDisplayNameTorusMandibularis = {};
    Object.entries(toothTorusMandiBularis).forEach(([toothId, ids]) => {
      onlyDisplayNameTorusMandibularis[toothId] = ids
        .map(id => {
          const found = getDataDentalTorusMandiBularis.find(item => item.id === id);
          return found ? {
            id: found.id,
            display_name: found.display_name,
            description: found.description
          } : null;
        })
        .filter(Boolean);
    });

    setOnlyDisplayNameTorusMandibularis(onlyDisplayNameTorusMandibularis);

    const onlyDisplayNamePalatum = {};
    Object.entries(toothPalatum).forEach(([toothId, ids]) => {
      onlyDisplayNamePalatum[toothId] = ids
        .map(id => {
          const found = getDataDentalPalatum.find(item => item.id === id);
          return found ? {
            id: found.id,
            display_name: found.display_name,
            description: found.description
          } : null;
        })
        .filter(Boolean);
    });
    setOnlyDisplayNamePalatum(onlyDisplayNamePalatum);

    const onlyDisplayNameDiastema = {};
    Object.entries(toothDiastema).forEach(([toothId, ids]) => {
      onlyDisplayNameDiastema[toothId] = ids
        .map(id => {
          const found = getDataDentalDiastema.find(item => item.id === id);
          return found ? {
            id: found.id,
            display_name: found.display_name,
            description: found.description
          } : null;
        })
        .filter(Boolean);
    });
    setOnlyDisplayNameDiastema(onlyDisplayNameDiastema);

    const onlyDisplayNameAnomali = {};
    Object.entries(toothAnomali).forEach(([toothId, ids]) => {
      onlyDisplayNameAnomali[toothId] = ids
        .map(id => {
          const found = getDataDentalAnomali.find(item => item.id === id);
          return found ? {
            id: found.id,
            display_name: found.display_name,
            description: found.description
          } : null;
        })
        .filter(Boolean);
    });
    setOnlyDisplayNameAnomali(onlyDisplayNameAnomali);

    const newInputItem = {
      id_doctor: dataItem.id_doctor,
      id_treatment: dataItem.id_treatment,
      id_room: dataItem.id_room,
      tooth_number: toothNumbersArray.join(' '),
      qty,
      choiceGigi: dataItem.choiceGigi,
      treatment_price_min: dataItem.treatment_price_min,
      treatment_price_max: dataItem.treatment_price_max,
      estimate_price,

      other_dental_oral_conditions: form.other_dental_oral_conditions,
      number_of_decayed_teeth: form.number_of_decayed_teeth,
      number_of_missing_teeth: form.number_of_missing_teeth,
      number_of_teeth_filled: form.number_of_teeth_filled,

      description_tooth_diastema: form.description_tooth_diastema,
      description_tooth_anomali: form.description_tooth_anomali,


      description: dataItem.description,
      id_description: dataItem.id_description,
      code_description: dataItem.code_description,
      assistants: dataItem.assistants,

      tooth_conditions: onlyDisplayNameConditions,
      tooth_restorations: onlyDisplayNameRestorations,
      tooth_restoration_materials: onlyDisplayNameRestorationMaterials,
      tooth_protesas: onlyDisplayNameProtesas,
      tooth_protesa_materials: onlyDisplayNameProtesaMaterials,
      tooth_occlusis: onlyDisplayNameOcclusi,
      tooth_torus_palatinus: onlyDisplayNameTorusPalatinus,
      tooth_torus_mandibularis: onlyDisplayNameTorusMandibularis,
      tooth_palatum: onlyDisplayNamePalatum,
      tooth_diastema: onlyDisplayNameDiastema,
      tooth_anomali: onlyDisplayNameAnomali,
      tooth_debris_index: onlyDisplayNameDebrisIndex,
      tooth_kalkulus_index: onlyDisplayNameKalkulusIndex,


      oral_condition_note: oralConditionNote,
      decayed_teeth_count: decayedTeethCountNote,
      tooth_missing_count: toothMissingCountNote,
      tooth_filled_count: toothFilledCountNote,
    };


    console.log(newInputItem, "newInputItem")
    setInputList(prev => [...prev, newInputItem]);
    setSelectedToothData(conditionDataMapped);
    setSelectedToothDataRestoration(restorationDataMapped);
    setSelectedToothDataRestorationMaterial(restorationMaterialDataMapped)
    setSelectedToothDataProtesa(protesaDataMapped)
    setSelectedToothDataProtesaMaterial(protesaMaterialDataMapped)

    setOralConditionNote("");
    setDecayedTeethCountNote("");
    setToothMissingCountNote("");
    setToothFilledCountNote("");

    setSelectedTooth([])
    // Kondisi
    setConditionData([])
    setKondisiGigi("")
    setIsKondisiClicked(false)
    setToothConditions({})
    setTempSelections([])
    setShouldPromptCondition(false)

    setRestorasiGigi("")
    setRestorationData([])
    setShouldPromptRestoration(false)

    setRestorasiMaterialGigi("")
    setRestorationMaterialData([])
    setShouldPromptRestorationMaterial(false)

    setProtesaGigi("")
    setProtesaData([])
    setShouldPromptProtesa(false)

    setProtesaMaterialGigi("")
    setProtesaMaterialData([])
    setShouldPromptProtesaMaterial(false)


    // ===== Reset Semua =====
    setSelectedTeeth([]);
    setConditionData([]);
    setRestorationData([]);
    setRestorationMaterialData([]);
    setProtesaData([]);
    setProtesaMaterialData([])
    setGetDataItem(initialDataItem);
    setFormchoiceGigi(initialForm);
    resetSelect();
    resetPolygonColors();

    setToothConditions({});
    setToothRestorations({});
    setToothRestorationMaterials({});
    setToothProtesas({});
    setToothProtesaMaterial({});
    setToothOcclusi({});
    setToothTorusPalatinus({});
    setToothTorusMandiBularis({});
    setToothPalatum({});
    setToothDiastema({});
    setToothAnomali({});
    setKalkulusPerTooth({});
    setDebrisPerTooth({});

    setGetDataDentalCondition(prev => prev.map(item => ({ ...item, checked: false })));
    setGetDataDentalRestoration(prev => prev.map(item => ({ ...item, checked: false })));
    setGetDataDentalRestorationMaterial(prev => prev.map(item => ({ ...item, checked: false })));
    setGetDataDentalProtesa(prev => prev.map(item => ({ ...item, checked: false })));
    setGetDataDentalProtesaMaterial(prev => prev.map(item => ({ ...item, checked: false })));
    setGetDataDentalOcclusi(prev => prev.map(item => ({ ...item, checked: false })));
    setGetDataDentalTorusPalatinus(prev => prev.map(item => ({ ...item, checked: false })));
    setGetDataDentalTorusMandiBularis(prev => prev.map(item => ({ ...item, checked: false })));
    setGetDataDentalPalatum(prev => prev.map(item => ({ ...item, checked: false })));
    setGetDataDentalDiastema(prev => prev.map(item => ({ ...item, checked: false })));
    setGetDataDentalAnomali(prev => prev.map(item => ({ ...item, checked: false })));

    setKondisiGigi("");
    setRestorasiGigi("");
    setRestorasiMaterialGigi("");
    setProtesaGigi("");
    setProtesaMaterialGigi("");
    setOcclusiGigi("");
    setTorusPalatinusGigi("");
    setTorusMandiBularisGigi("");
    setPalatumGigi("");
    setDiastemaGigi("");
    setAnomaliGigi("");
    setOralConditionNote("");
    setDecayedTeethCountNote("");
    setToothMissingCountNote("");
    setToothFilledCountNote("");
    setKalkulusIndexGigi("");
    setDebrisIndexGigi("")

    setIsApplyConditionMode(false);
    setIsApplyRestorasiMode(false);
    setIsApplyRestorasiMaterialMode(false);
    setIsApplyProtesaMode(false);
    setIsApplyProtesaMaterialMode(false);
    setIsApplyOcclusiMode(false);
    setIsApplyTorusPalatinusMode(false);
    setIsApplyTorusMandiBularisMode(false);
    setIsApplyPalatumMode(false);
    setIsApplyDiastemaMode(false);
    setIsApplyAnomaliMode(false);

    setIsKondisiClicked(false);
    setIsRestorasiClicked(false);
    setIsRestorasiMaterialClicked(false);
    setIsProtesaClicked(false);
    setIsProtesaMaterialClicked(false);
    setIsOcclusiClicked(false);
    setIsTorusPalatinusClicked(false);
    setIsTorusMandiBularisClicked(false);
    setIsPalatumClicked(false);
    setIsDiastemaClicked(false);
    setIsAnomaliClicked(false);
    setShouldPromptCondition(false);

    setShouldPromptRestoration(false)
    setShouldPromptRestorationMaterial(false)
    setShouldPromptProtesa(false)
    setShouldPromptProtesaMaterial(false)


    setShowModalOralCondition(false);
    setShowModalDecayedTeethCount(false);
    setShowModalToothMissingCount(false);

    setForm({
      other_dental_oral_conditions: '',
      number_of_decayed_teeth: '',
      number_of_missing_teeth: '',
      number_of_teeth_filled: '',
    });

    setActiveIndex("")

    resetAllToothStates();
  };







  const handleResetPolygon = () => {
    resetAllToothStates();
    setSelectedTooth([])
    setShouldPromptCondition(false)
    setShouldPromptRestoration(false)
    setShouldPromptRestorationMaterial(false)
    setShouldPromptProtesa(false)
    setShouldPromptProtesaMaterial(false)
    setActiveOcclusiSelections([]);
    setTempTorusPalatinusSelections([]);

    setResetSignal(prev => prev + 1);

    // setInputList([]);
    resetSelect();
    resetPolygonColors();
    setGetDataKalkulusIndex([]);
    setGetDataDebrisIndex([]);


    setKondisiGigi("")
    setRestorasiGigi("")
    setRestorasiMaterialGigi("")
    setProtesaGigi("")
    setProtesaMaterialGigi("")
    setProtesaMaterialGigi("")
    setVisibleOdontogram(true)
  };


  const handleRemoveClick = index => {
    const updatedInputList = [...inputList];
    updatedInputList.splice(index, 1);

    // Hitung ulang total harga estimasi
    let totalPrice = 0;
    updatedInputList.forEach((item) => {
      const estimatePrice = parseFloat(item.estimate_price);
      if (!isNaN(estimatePrice)) {
        totalPrice += estimatePrice;
      }
    });
    setForm({
      ...form,
      estimate_price_total: totalPrice,
    });

    setInputList(updatedInputList);
  };

  const navigateHome = () => {
    navigate('/appointments')
  }

  const approvedItems = getDataDetailsApproval.filter(item => item.patient_approval === 1);

  const ApproveTreatment = async (id, description, id_description, code_description) => {
    Swal.fire({
      title: `<div>Klik Approve Untuk Melanjutkan!</div>`,
      text: ``,
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Approve'
    }).then(async (result) => {
      if (result.isConfirmed) {
        const response = await API.post(`emr-service/treatment-plan-details/approve/${id}`,
          {
            filename: "signature_approve.png",
            content: cBase64,
          }
          , fetchParams);
        if (response.data.error == false) {
          setIdStoreMedicalRecord(id)
          GetResponseDataApprovalByTreatmentPlan()
          handleSubmitObat(id, description, id_description, code_description)
          swal({
            title: 'Success',
            text: "Appointment Anda Telah Berhasil Di proses",
            icon: 'success',
            timer: 3000,
            buttons: false
          });
        }
      }
    })
  };

  const handleCloseModalCardReminder = () => {
    setModalCardReminder(false)
    setModalCardReminderAfter(false)
  }


  const handleSubmitObat = async (id, description, id_description, code_description) => {
    try {
      const nonEmptyObatItems = inputListObat.filter(item => item.id_medical_item === "");

      // setLoading(true)
      // Insert data for login process
      const response = await API.post("emr-service/medical-records/store", {
        id_patient: `${getDataAppointmentByIdPatient?.id}`,
        diagnose: description,
        id_diagnose: id_description,
        code_diagnose: code_description,
        id_treatment_plan_detail: id,
        id_appointment: idParams?.id,
        medical_prescriptions: inputListObat.length === 0 || inputListObat[0].id_medical_item === "" ? [] : inputListObat
      }, fetchParams);

      // Checking process
      if (response?.status === 200) {
        swal({
          title: 'Success',
          text: response.data.message,
          icon: 'success',
          timer: 5000,
          buttons: false
        })

        setInputListObat([])
        // window.location.reload()
        // setLoading(false
      }

    } catch (error) {
      // setLoading(false)
      swal({
        title: 'Failed',
        text: `${error.response.data.message}`,
        icon: 'error',
        timer: 3000,
        buttons: false
      });
    }

  };

  let totalDataTreatmentPrice = 0;
  getDataDetailsApproval.forEach((user) => {
    totalDataTreatmentPrice += user?.estimate_price *
      (getDataTreatmentOneQty.filter(item => item?.id_treatment === user?.id_treatment).length > 0 ? 1 : user?.qty) || 0;
  });


  let totalDataTreatmentPriceList = 0;

  inputList.forEach((user) => {
    // Convert the estimate_price to a number using parseInt
    const estimatePrice = parseInt(user?.estimate_price || 0, 10);
    totalDataTreatmentPriceList += estimatePrice * (
      getDataTreatmentOneQty.filter(item => item?.id_treatment === user?.id_treatment).length > 0
        ? 1
        : (user?.qty === 32 ? 1 : user?.qty)
    );
  });





  // let toltalDataTreatmentPriceOn = totalDataFeePrice + totalDataTreatmentPriceList;
  let toltalDataTreatmentPriceOn = totalDataTreatmentPriceList;

  const handleSubmitMedicalInvoice = async () => {
    Swal.fire({
      title: `<div>Apakah Anda Telah Selesai Menyelesaikan Treatment?</div>`,
      text: ``,
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Selesai'
    }).then(async (result) => {
      if (result.isConfirmed) {
        const response = await API.post("emr-service/medical-invoices/store", {
          id_appointment: `${id}`
        }, fetchParams);

        if (response.data.error === false) {
          Swal.fire(
            'Selamat Anda Berhasil Melakukan Treatment Pasien',
            'Silahkan Lanjutkan Proses',
            'success'
          )
          navigate('/appointments')
        }
      }
    })
  };

  const viewModalMedicalRecord = () => {
    setIdModalMedicalRecordPatient(getDataAppointmentById?.id_patient)
    setIdModalMedicalRecordPatientFirstName(getDataAppointmentByIdPatient?.first_name)
    setIdModalMedicalRecordPatientLastName(getDataAppointmentByIdPatient?.last_name)
    setModalMedicalRecord(true)
  }

  function formatToRupiah(angka) {
    const formatter = new Intl.NumberFormat('id-ID', {
      style: 'currency',
      currency: 'IDR',
      minimumFractionDigits: 0,
    });

    // Format angka ke format mata uang Rupiah
    const formattedString = formatter.format(angka);

    // Menghilangkan simbol "RP" (simbol mata uang) dari hasil format
    const rupiahWithoutSymbol = formattedString.replace('Rp', '');

    return rupiahWithoutSymbol.trim(); // Menghilangkan spasi yang mungkin ada
  }

  const MODE = {
    KONDISI: 'kondisi',
    RESTORASI: 'restorasi',
    BAHAN: 'bahan',
    PROTESA: 'protesa',
    PROTESAMATERIAL: 'protesa_material'
  };

  const handlePolygonClick = (e, source = '', isReset = false) => {

    const fullKodeGigi = e?.target?.getAttribute('data-nomor-gigi');
    if (!fullKodeGigi) return;

    const cleanedKode = fullKodeGigi.trim();
    const element = e.target;

    // Update state selectedTooth
    setSelectedTooth(prev => {
      if (prev.includes(cleanedKode)) return prev;
      return [...prev, cleanedKode];
    });

    if (isReset || !activeMode) {
      element.style.setProperty('fill', 'white', 'important');
      return;
    }

    switch (activeMode) {
      case MODE.KONDISI: {
        const kondisiExist = conditionData.some(
          item => item.tooth === cleanedKode && item.conditions.length > 0
        );

        if (kondisiExist) {
          // ✅ Jika sudah punya kondisi → reset
          setToothConditions(prev => {
            const updated = { ...prev };
            delete updated[cleanedKode];
            return updated;
          });

          setConditionData(prev =>
            prev.filter(item => item.tooth !== cleanedKode)
          );

          element.style.setProperty('fill', 'white', 'important');
        } else {
          // ➕ Belum punya kondisi → buka modal
          setSelectedTeeth([cleanedKode]);
          setShouldPromptCondition(true);
          openModal('kondisi');
        }

        break;
      }
      case MODE.RESTORASI: {
        const restorasiExist = restorationData.some(
          item => item.tooth === cleanedKode && item.restorations.length > 0
        );

        if (restorasiExist) {
          // ✅ Jika sudah punya kondisi → reset
          setToothRestorations(prev => {
            const updated = { ...prev };
            delete updated[cleanedKode];
            return updated;
          });

          setRestorationData(prev =>
            prev.filter(item => item.tooth !== cleanedKode)
          );

          element.style.setProperty('fill', 'white', 'important');
        } else {
          // ➕ Belum punya kondisi → buka modal
          setSelectedTeeth([cleanedKode]);
          setShouldPromptRestoration(true);
          openModal('restorasi');
        }

        break;
      }
      case MODE.BAHAN: {
        const restorasiMaterialExist = restorationMaterialData.some(
          item => item.tooth === cleanedKode && item.restoration_materials.length > 0
        );

        if (restorasiMaterialExist) {
          // ✅ Jika sudah punya kondisi → reset
          setToothRestorationMaterials(prev => {
            const updated = { ...prev };
            delete updated[cleanedKode];
            return updated;
          });

          setRestorationMaterialData(prev =>
            prev.filter(item => item.tooth !== cleanedKode)
          );

          element.style.setProperty('fill', 'white', 'important');
        } else {
          setSelectedTeeth([cleanedKode]);
          setShouldPromptRestorationMaterial(true);
          openModal('bahan');
        }

        break;
      }
      case MODE.PROTESA: {
        const protesaExist = protesaData.some(
          item => item.tooth === cleanedKode && item.protesas.length > 0
        );

        if (protesaExist) {
          // ✅ Jika sudah punya kondisi → reset
          setToothProtesas(prev => {
            const updated = { ...prev };
            delete updated[cleanedKode];
            return updated;
          });

          setProtesaData(prev =>
            prev.filter(item => item.tooth !== cleanedKode)
          );

          element.style.setProperty('fill', 'white', 'important');
        } else {
          setSelectedTeeth([cleanedKode]);
          setShouldPromptProtesa(true);
          openModal('protesa');
        }

        break;
      }

      case MODE.PROTESAMATERIAL: {
        const protesaExist = protesaData.some(
          item => item.tooth === cleanedKode && item.protesa_materials.length > 0
        );

        if (protesaExist) {
          // ✅ Jika sudah punya kondisi → reset
          setToothProtesas(prev => {
            const updated = { ...prev };
            delete updated[cleanedKode];
            return updated;
          });

          setProtesaMaterialData(prev =>
            prev.filter(item => item.tooth !== cleanedKode)
          );

          element.style.setProperty('fill', 'white', 'important');
        } else {
          setSelectedTeeth([cleanedKode]);
          setShouldPromptProtesaMaterial(true);
          openModal('protesa_material');
        }

        break;
      }

      default:
        break;
    }
  };


  const handlePolygonClickSatuBagian = (e, source = '', isReset = false) => {
    const nomorGigi = e?.target?.getAttribute('data-nomor-gigi');
    if (!nomorGigi) return;

    const cleanedTooth = nomorGigi.trim();
    const element = e.target;

    setSelectedTooth(prev => {
      if (prev.includes(cleanedTooth)) return prev;
      return [...prev, cleanedTooth];
    });

    switch (activeMode) {
      case MODE.KONDISI: {
        const kondisiExist = conditionData.some(
          item => item.tooth === cleanedTooth && Array.isArray(item.conditions) && item.conditions.length > 0
        );


        if (kondisiExist) {
          setToothConditions(prev => {
            const updated = { ...prev };
            delete updated[cleanedTooth];
            return updated;
          });

          setConditionData(prev =>
            prev.filter(item => item.tooth !== cleanedTooth)
          );

          element.style.setProperty('fill', 'white', 'important');
        } else {
          setSelectedTeeth([cleanedTooth]);
          setShouldPromptCondition(true);
          if (!buttonChoiceRestoration && !buttonChoiceRestorationMaterial && !buttonChoiceProtesa && !buttonChoiceProtesaMaterial && buttonChoiceCondition) {
            openModal('kondisi');
          }
        }

        break;
      }
      case MODE.RESTORASI: {
        const restorasiExist = restorationData.some(
          item => item.tooth === cleanedTooth && Array.isArray(item.restorations) && item.restorations.length > 0
        );

        if (restorasiExist) {
          // ✅ Jika sudah punya kondisi → reset
          setToothRestorations(prev => {
            const updated = { ...prev };
            delete updated[cleanedTooth];
            return updated;
          });

          setRestorationData(prev =>
            prev.filter(item => item.tooth !== cleanedTooth)
          );

          element.style.setProperty('fill', 'white', 'important');
        } else {
          // ➕ Belum punya kondisi → buka modal
          setSelectedTeeth([cleanedTooth]);
          setShouldPromptRestoration(true);
          if (!buttonChoiceCondition && !buttonChoiceRestorationMaterial && !buttonChoiceProtesa && !buttonChoiceProtesaMaterial && buttonChoiceRestoration) {
            openModal('restorasi');
          }
        }

        break;
      }
      case MODE.BAHAN: {
        const bahanExist = restorationMaterialData.some(
          item => item.tooth === cleanedTooth && Array.isArray(item.restoration_materials) && item.restoration_materials.length > 0
        );

        if (bahanExist) {
          // ✅ Jika sudah punya kondisi → reset
          setToothRestorationMaterials(prev => {
            const updated = { ...prev };
            delete updated[cleanedTooth];
            return updated;
          });

          setRestorationMaterialData(prev =>
            prev.filter(item => item.tooth !== cleanedTooth)
          );

          element.style.setProperty('fill', 'white', 'important');
        } else {
          setSelectedTeeth([cleanedTooth]);
          setShouldPromptRestorationMaterial(true);
          if (!buttonChoiceCondition && !buttonChoiceRestoration && !buttonChoiceProtesa && !buttonChoiceProtesaMaterial && buttonChoiceRestorationMaterial) {
            openModal('bahan');
          }
        }

        break;
      }
      case MODE.PROTESA: {
        const protesaExist = protesaData.some(
          item => item.tooth === cleanedTooth && Array.isArray(item.protesas) && item.protesas.length > 0
        );

        if (protesaExist) {
          // ✅ Jika sudah punya kondisi → reset
          setToothProtesas(prev => {
            const updated = { ...prev };
            delete updated[cleanedTooth];
            return updated;
          });

          setProtesaData(prev =>
            prev.filter(item => item.tooth !== cleanedTooth)
          );

          element.style.setProperty('fill', 'white', 'important');
        } else {
          setSelectedTeeth([cleanedTooth]);
          setShouldPromptProtesa(true);
          if (!buttonChoiceCondition && !buttonChoiceRestoration && !buttonChoiceRestorationMaterial && !buttonChoiceProtesaMaterial && buttonChoiceProtesa) {
            openModal('protesa');
          }
        }

        break;
      }
      case MODE.PROTESAMATERIAL: {
        const protesaMaterialExist = protesaData.some(
          item => item.tooth === cleanedTooth && Array.isArray(item.protesa_materials) && item.protesa_materials.length > 0
        );

        if (protesaMaterialExist) {
          setToothProtesaMaterial(prev => {
            const updated = { ...prev };
            delete updated[cleanedTooth];
            return updated;
          });

          setProtesaMaterialData(prev =>
            prev.filter(item => item.tooth !== cleanedTooth)
          );

          element.style.setProperty('fill', 'white', 'important');
        } else {
          setSelectedTeeth([cleanedTooth]);
          setShouldPromptProtesaMaterial(true);
          if (!buttonChoiceCondition && !buttonChoiceRestoration && !buttonChoiceRestorationMaterial && !buttonChoiceProtesa && buttonChoiceProtesaMaterial) {
            openModal('protesa_material');
          }
        }

        break;
      }


      default:
        break;
    }


    setSelectedTeeth(prev => (
      prev.includes(cleanedTooth) ? prev : [...prev, cleanedTooth]
    ));
    setGetDataItem(prev => {
      const updated = { ...prev };
      if (!updated.tooth_number?.includes(cleanedTooth)) {
        updated.tooth_number = (updated.tooth_number || '') + cleanedTooth;
      }
      return updated;
    });
  };

  const getDisplayNamesForTooth = (toothId, type = "kondisi") => {
    const idMap = {
      kondisi: toothConditions,
      restorasi: toothRestorations,
      restorasi_material: toothRestorationMaterials,
      protesa: toothProtesas,
      protesa_material: toothProtesaMaterial,
      occlusi: toothOcclusi,
      torus_palatinus: toothTorusPalatinus,
      torus_mandibularis: toothTorusMandiBularis,
      palatum: toothPalatum,
      diastema: toothDiastema,
      anomali: toothAnomali,
      kalkulus_index: kalkulusPerTooth,
      debris_index: debrisPerTooth,
    };

    const dataMap = {
      kondisi: getDataDentalCondition,
      restorasi: getDataDentalRestoration,
      restorasi_material: getDataDentalRestorationMaterial,
      protesa: getDataDentalProtesa,
      protesa_material: getDataDentalProtesaMaterial,
      occlusi: getDataDentalOcclusi,
      torus_palatinus: getDataDentalTorusPalatinus,
      torus_mandibularis: getDataDentalTorusMandiBularis,
      palatum: getDataDentalPalatum,
      diastema: getDataDentalDiastema,
      anomali: getDataDentalAnomali,
      debris_index: getDataDebrisIndex,
      kalkulus_index: getDataKalkulusIndex
    };

    const sourceData = dataMap[type] || [];


    // 🎯 Tipe yang tidak tergantung gigi
    const globalTypes = [
      "occlusi",
      "torus_palatinus",
      "torus_mandibularis",
      "palatum",
      "diastema",
      "anomali",
    ];

    // Jika global type, ambil langsung dari data yang checked
    if (globalTypes.includes(type)) {
      return sourceData
        .filter(item => item.checked) // Atau filter lain sesuai kebutuhan
        .map(item => ({
          id: item.id,
          display_name: item.display_name
        }));
    }

    // Untuk tipe yang tergantung toothId
    const ids = idMap[type]?.[toothId] || [];

    return ids
      .map(id => {
        const found = sourceData.find(item => item.id === id);
        return found
          ? { id: found.id, display_name: found.display_name }
          : null;
      })
      .filter(Boolean);
  };

  const getDisplayNamesForToothDebrisIndex = (toothId) => {
    const items = debrisPerTooth[toothId] || [];
    if (!Array.isArray(items) || items.length === 0) return [];

    // Kalau item sudah mengandung display_name langsung ambil
    if (items[0]?.display_name) {
      return items.map((item) => item.display_name);
    }

    // Kalau cuma ID, baru cari dari getDataDebrisIndex
    if (!Array.isArray(getDataDebrisIndex)) return [];

    return items
      .map((id) => getDataDebrisIndex.find((item) => item.id === id))
      .filter(Boolean)
      .map((item) => item.display_name);
  };

  const getDisplayNamesForToothKalkulusIndex = (toothId) => {
    const items = kalkulusPerTooth[toothId] || [];
    if (!Array.isArray(items) || items.length === 0) return [];

    if (items[0]?.display_name) {
      return items.map((item) => item.display_name);
    }

    if (!Array.isArray(getDataKalkulusIndex)) return [];

    return items
      .map((id) => getDataKalkulusIndex.find((item) => item.id === id))
      .filter(Boolean)
      .map((item) => item.display_name);
  };





  const [infoGigi, setInfoGigi] = useState("XX-X")

  const renderPopover = (toothNumber, user) => {
    const key = toothNumber?.toString().trim();
    const toothConditions = user?.tooth_conditions?.[key] || [];
    const toothRestorations = user?.tooth_restorations?.[key] || [];
    const toothRestorationMaterials = user?.tooth_restoration_materials?.[key] || [];
    const toothProtesas = user?.tooth_protesas?.[key] || [];
    const toothProtesaMaterials = user?.tooth_protesa_materials?.[key] || [];
    const toothDebrisIndex = user?.tooth_debris_index?.[key] || [];
    const toothKalkulusIndex = user?.tooth_kalkulus_index?.[key] || [];

    const rows = [];

    const addRows = (label, data, keyPrefix) => {
      if (!data || data.length === 0) return;

      if (keyPrefix === 'toothPosition') {
        const uniquePositions = Array.from(
          new Set(data.map((item) => item?.position).filter(Boolean))
        );

        uniquePositions.forEach((pos, idx) => {
          rows.push(
            <tr key={`${keyPrefix}-${idx}`}>
              <td>{idx === 0 ? label : ''}</td>
              <td>&bull; {pos}</td>
            </tr>
          );
        });
        return;
      }

      data.forEach((item, idx) => {
        rows.push(
          <tr key={`${keyPrefix}-${idx}`}>
            <td>{idx === 0 ? label : ''}</td>
            <td>&bull; {typeof item === 'object' ? item.display_name : item}</td>
          </tr>
        );
      });
    };

    addRows('Kondisi Gigi', toothConditions, 'cond');
    addRows('Restorasi Gigi', toothRestorations, 'resto');
    addRows('Bahan Restorasi', toothRestorationMaterials, 'material');
    addRows('Protesa', toothProtesas, 'protesa');
    addRows('Bahan Protesa', toothProtesaMaterials, 'protesaMaterial');
    addRows('Debris Index', toothDebrisIndex, 'debrisIndex');
    addRows('Kalkulus Index', toothKalkulusIndex, 'kalkulusIndex');
    addRows('Posisi', toothDebrisIndex, 'toothPosition');

    const hasExtraData =
      user?.oral_condition_note ||
      user?.decayed_teeth_count ||
      user?.tooth_missing_count ||
      user?.tooth_filled_count;

    // Tampilkan pesan jika tidak ada data
    if (rows.length === 0 && !hasExtraData) {
      rows.push(
        <tr>
          <td colSpan="2" style={{ textAlign: 'center' }}>Tidak ada data untuk gigi ini</td>
        </tr>
      );
    }


    return (
      <Popover id={`popover-${key}`} style={{ minWidth: 600, maxWidth: 800 }}>
        <div style={{ maxHeight: 200, overflowY: 'auto' }}>
          <table className="table table-bordered table-sm mb-0">
            <thead className="table-light">
              <tr>
                <th style={{ position: 'sticky', top: 0, backgroundColor: '#f8f9fa', zIndex: 1 }}>Jenis</th>
                <th style={{ position: 'sticky', top: 0, backgroundColor: '#f8f9fa', zIndex: 1 }}>Detail</th>
              </tr>
            </thead>
            <tbody>
              {rows}
              {user?.tooth_occlusis?.length > 0 && (
                <>
                  <tr>
                    <td>Oklusi</td>
                    <td>
                      {user.tooth_occlusis.map((item, index) => (
                        <div key={index}>&bull; {item.display_name}</div>
                      ))}
                    </td>
                  </tr>
                </>
              )}

              {user?.tooth_torus_palatinus && Object.keys(user.tooth_torus_palatinus).length > 0 && (
                <>
                  <tr>
                    <td>Torus Palatinus</td>
                    <td>
                      {Object.entries(user.tooth_torus_palatinus).map(([toothId, items]) => (
                        <div key={toothId}>
                          <ul>
                            {items.map((item, index) => (
                              <li key={index}>{item.display_name}</li>
                            ))}
                          </ul>
                        </div>
                      ))}
                    </td>
                  </tr>
                </>
              )}

              {user?.tooth_torus_mandibularis && Object.keys(user.tooth_torus_mandibularis).length > 0 && (
                <>
                  <tr>
                    <td>Torus Mandibularis</td>
                    <td>
                      {Object.entries(user.tooth_torus_mandibularis).map(([toothId, items]) => (
                        <div key={toothId}>
                          <ul>
                            {items.map((item, index) => (
                              <li key={index}>{item.display_name}</li>
                            ))}
                          </ul>
                        </div>
                      ))}
                    </td>
                  </tr>
                </>
              )}

              {user?.tooth_palatum && Object.keys(user.tooth_palatum).length > 0 && (
                <>
                  <tr>
                    <td>Palatum</td>
                    <td>
                      {Object.entries(user.tooth_palatum).map(([toothId, items]) => (
                        <div key={toothId}>
                          <ul className="mb-1">
                            {items.map((item, index) => (
                              <li key={index}>{item.display_name}</li>
                            ))}
                          </ul>
                        </div>
                      ))}
                    </td>
                  </tr>
                </>
              )}
              {user?.tooth_diastema && Object.keys(user.tooth_diastema).length > 0 && (
                <>
                  <tr>
                    <td>Diastema</td>
                    <td>
                      {Object.entries(user.tooth_diastema).map(([toothId, items]) => (
                        <div key={toothId}>
                          <ul className="mb-1">
                            {items.map((item, index) => (
                              <li key={index}>{item.display_name}</li>
                            ))}
                          </ul>
                        </div>
                      ))}
                    </td>
                  </tr>
                </>
              )}
              {user?.tooth_anomali && Object.keys(user.tooth_anomali).length > 0 && (
                <>
                  <tr>
                    <td>Anomali</td>
                    <td>
                      {Object.entries(user.tooth_anomali).map(([toothId, items]) => (
                        <div key={toothId}>
                          <ul className="mb-1">
                            {items.map((item, index) => (
                              <li key={index}>{item.display_name}</li>
                            ))}
                          </ul>
                        </div>
                      ))}
                    </td>
                  </tr>
                </>
              )}
              {user?.other_dental_oral_condition && (
                <tr>
                  <td>Kondisi gigi dan mulut lainnya</td>
                  <td style={{ whiteSpace: 'pre-wrap' }}>{user.other_dental_oral_condition}</td>
                </tr>
              )}

              {user?.number_of_decayed_teeth && (
                <tr>
                  <td>Jumlah Gigi Decayed</td>
                  <td style={{ whiteSpace: 'pre-wrap' }}>{user.number_of_decayed_teeth}</td>
                </tr>
              )}

              {user?.number_of_missing_teeth && (
                <tr>
                  <td>Jumlah Gigi Missing</td>
                  <td style={{ whiteSpace: 'pre-wrap' }}>{user.number_of_missing_teeth}</td>
                </tr>
              )}

              {user?.number_of_teeth_filled && (
                <tr>
                  <td>Jumlah Gigi Filled</td>
                  <td style={{ whiteSpace: 'pre-wrap' }}>{user.number_of_teeth_filled}</td>
                </tr>
              )}


            </tbody>
          </table>
        </div>
      </Popover>
    );
  };



  const noteBoxStyle = {
    whiteSpace: 'pre-wrap',
    background: '#f8f9fa',
    padding: '8px',
    borderRadius: '6px',
    cursor: 'pointer',
    fontSize: '14px',
    overflowWrap: 'break-word',
    wordBreak: 'break-word',
  };

  const buttonStyle = {
    width: '100%',
    whiteSpace: 'normal',
    wordWrap: 'break-word',
    textAlign: 'center',
    fontSize: '0.75rem',
    lineHeight: '1rem',
    padding: '4px',
    backgroundColor: 'transparent',
    color: '#343a40',
    borderColor: '#ced4da',
    borderWidth: '1px',
    borderStyle: 'solid',
  };

  const getToothFillColor = (nomor) => {
    if ((toothConditions[nomor]?.length ?? 0) > 0) return "aqua";       // kondisi
    if ((toothRestorations[nomor]?.length ?? 0) > 0) return "green";    // restorasi
    if ((toothRestorationMaterials[nomor]?.length ?? 0) > 0) return "yellow"; // bahan
    if ((toothProtesas[nomor]?.length ?? 0) > 0) return "gray";         // protesa
    if ((toothProtesaMaterial[nomor]?.length ?? 0) > 0) return "orange";// protesa material

    return "white"; // default
  };

  const toothShapes = [
    { part: "top", points: "0,0 40,0 30,10 10,10", label: "Bukal" },
    { part: "bottom", points: "10,30 30,30 40,40 0,40", label: "Palatal" },
    { part: "right", points: "30,10 40,0 40,40 30,30", label: "Mesial" },
    { part: "left", points: "0,0 10,10 10,30 0,40", label: "Distal" },
    { part: "center", points: "10,10 30,10 30,30 10,30", label: "Oklusal" }
  ];

  const customToothShapes = {
    "13": [
      { part: "top", points: "0,0 40,0 30,20 0,20" },
      { part: "bottom", points: "0,20 30,20 40,40 0,40" },
      { part: "right", points: "30,20 40,0 40,40 35,30" },
      { part: "left", points: "0,0 5,10 10,20 0,40" }
    ],
    "12": [
      { part: "top", points: "0,0 40,0 30,20 0,20" },
      { part: "bottom", points: "0,20 30,20 40,40 0,40" },
      { part: "right", points: "30,20 40,0 40,40 35,30" },
      { part: "left", points: "0,0 5,10 10,20 0,40" }
    ],
    "11": [
      { part: "top", points: "0,0 40,0 30,20 0,20" },
      { part: "bottom", points: "0,20 30,20 40,40 0,40" },
      { part: "right", points: "30,20 40,0 40,40 35,30" },
      { part: "left", points: "0,0 5,10 10,20 0,40" }
    ],
    "21": [
      { part: "top", points: "0,0 40,0 30,20 0,20" },
      { part: "bottom", points: "0,20 30,20 40,40 0,40" },
      { part: "right", points: "30,20 40,0 40,40 35,30" },
      { part: "left", points: "0,0 5,10 10,20 0,40" }
    ],
    "22": [
      { part: "top", points: "0,0 40,0 30,20 0,20" },
      { part: "bottom", points: "0,20 30,20 40,40 0,40" },
      { part: "right", points: "30,20 40,0 40,40 35,30" },
      { part: "left", points: "0,0 5,10 10,20 0,40" }
    ],
    "23": [
      { part: "top", points: "0,0 40,0 30,20 0,20" },
      { part: "bottom", points: "0,20 30,20 40,40 0,40" },
      { part: "right", points: "30,20 40,0 40,40 35,30" },
      { part: "left", points: "0,0 5,10 10,20 0,40" }
    ],
    "51": [
      { part: "top", points: "0,0 40,0 30,20 0,20" },
      { part: "bottom", points: "0,20 30,20 40,40 0,40" },
      { part: "right", points: "30,20 40,0 40,40 35,30" },
      { part: "left", points: "0,0 5,10 10,20 0,40" }
    ],
    "52": [
      { part: "top", points: "0,0 40,0 30,20 0,20" },
      { part: "bottom", points: "0,20 30,20 40,40 0,40" },
      { part: "right", points: "30,20 40,0 40,40 35,30" },
      { part: "left", points: "0,0 5,10 10,20 0,40" }
    ],
    "53": [
      { part: "top", points: "0,0 40,0 30,20 0,20" },
      { part: "bottom", points: "0,20 30,20 40,40 0,40" },
      { part: "right", points: "30,20 40,0 40,40 35,30" },
      { part: "left", points: "0,0 5,10 10,20 0,40" }
    ],
    "61": [
      { part: "top", points: "0,0 40,0 30,20 0,20" },
      { part: "bottom", points: "0,20 30,20 40,40 0,40" },
      { part: "right", points: "30,20 40,0 40,40 35,30" },
      { part: "left", points: "0,0 5,10 10,20 0,40" }
    ],
    "62": [
      { part: "top", points: "0,0 40,0 30,20 0,20" },
      { part: "bottom", points: "0,20 30,20 40,40 0,40" },
      { part: "right", points: "30,20 40,0 40,40 35,30" },
      { part: "left", points: "0,0 5,10 10,20 0,40" }
    ],
    "63": [
      { part: "top", points: "0,0 40,0 30,20 0,20" },
      { part: "bottom", points: "0,20 30,20 40,40 0,40" },
      { part: "right", points: "30,20 40,0 40,40 35,30" },
      { part: "left", points: "0,0 5,10 10,20 0,40" }
    ],
    "81": [
      { part: "top", points: "0,0 40,0 30,20 0,20" },
      { part: "bottom", points: "0,20 30,20 40,40 0,40" },
      { part: "right", points: "30,20 40,0 40,40 35,30" },
      { part: "left", points: "0,0 5,10 10,20 0,40" }
    ],
    "82": [
      { part: "top", points: "0,0 40,0 30,20 0,20" },
      { part: "bottom", points: "0,20 30,20 40,40 0,40" },
      { part: "right", points: "30,20 40,0 40,40 35,30" },
      { part: "left", points: "0,0 5,10 10,20 0,40" }
    ],
    "83": [
      { part: "top", points: "0,0 40,0 30,20 0,20" },
      { part: "bottom", points: "0,20 30,20 40,40 0,40" },
      { part: "right", points: "30,20 40,0 40,40 35,30" },
      { part: "left", points: "0,0 5,10 10,20 0,40" }
    ],
    "71": [
      { part: "top", points: "0,0 40,0 30,20 0,20" },
      { part: "bottom", points: "0,20 30,20 40,40 0,40" },
      { part: "right", points: "30,20 40,0 40,40 35,30" },
      { part: "left", points: "0,0 5,10 10,20 0,40" }
    ],
    "72": [
      { part: "top", points: "0,0 40,0 30,20 0,20" },
      { part: "bottom", points: "0,20 30,20 40,40 0,40" },
      { part: "right", points: "30,20 40,0 40,40 35,30" },
      { part: "left", points: "0,0 5,10 10,20 0,40" }
    ],
    "73": [
      { part: "top", points: "0,0 40,0 30,20 0,20" },
      { part: "bottom", points: "0,20 30,20 40,40 0,40" },
      { part: "right", points: "30,20 40,0 40,40 35,30" },
      { part: "left", points: "0,0 5,10 10,20 0,40" }
    ],
    "41": [
      { part: "top", points: "0,0 40,0 30,20 0,20" },
      { part: "bottom", points: "0,20 30,20 40,40 0,40" },
      { part: "right", points: "30,20 40,0 40,40 35,30" },
      { part: "left", points: "0,0 5,10 10,20 0,40" }
    ],
    "42": [
      { part: "top", points: "0,0 40,0 30,20 0,20" },
      { part: "bottom", points: "0,20 30,20 40,40 0,40" },
      { part: "right", points: "30,20 40,0 40,40 35,30" },
      { part: "left", points: "0,0 5,10 10,20 0,40" }
    ],
    "43": [
      { part: "top", points: "0,0 40,0 30,20 0,20" },
      { part: "bottom", points: "0,20 30,20 40,40 0,40" },
      { part: "right", points: "30,20 40,0 40,40 35,30" },
      { part: "left", points: "0,0 5,10 10,20 0,40" }
    ],
    "31": [
      { part: "top", points: "0,0 40,0 30,20 0,20" },
      { part: "bottom", points: "0,20 30,20 40,40 0,40" },
      { part: "right", points: "30,20 40,0 40,40 35,30" },
      { part: "left", points: "0,0 5,10 10,20 0,40" }
    ],
    "32": [
      { part: "top", points: "0,0 40,0 30,20 0,20" },
      { part: "bottom", points: "0,20 30,20 40,40 0,40" },
      { part: "right", points: "30,20 40,0 40,40 35,30" },
      { part: "left", points: "0,0 5,10 10,20 0,40" }
    ],
    "33": [
      { part: "top", points: "0,0 40,0 30,20 0,20" },
      { part: "bottom", points: "0,20 30,20 40,40 0,40" },
      { part: "right", points: "30,20 40,0 40,40 35,30" },
      { part: "left", points: "0,0 5,10 10,20 0,40" }
    ],
  };

  // Satu Gigi
  const renderToothPolygon = (points, nomorGigi) => {
    const trimmedNomor = nomorGigi.trim();
    const shouldDisableClick =
      formchoiceGigi?.choiceGigi === "ra_rb_full" ||
      formchoiceGigi?.choiceGigi === "ra_rb_dewasa" ||
      formchoiceGigi?.choiceGigi === "ra_rb_anak" ||
      formchoiceGigi?.choiceGigi === "ra_dewasa_anak" ||
      formchoiceGigi?.choiceGigi === "ra_dewasa" ||
      formchoiceGigi?.choiceGigi === "ra_anak" ||
      formchoiceGigi?.choiceGigi === "rb_dewasa_anak" ||
      formchoiceGigi?.choiceGigi === "rb_dewasa" ||
      formchoiceGigi?.choiceGigi === "rb_anak" ||
      formchoiceGigi?.choiceGigi === "regio_1" ||
      formchoiceGigi?.choiceGigi === "regio_2" ||
      formchoiceGigi?.choiceGigi === "regio_3" ||
      formchoiceGigi?.choiceGigi === "regio_4" ||
      formchoiceGigi?.choiceGigi === "regio_5" ||
      formchoiceGigi?.choiceGigi === "regio_6" ||
      formchoiceGigi?.choiceGigi === "regio_7" ||
      formchoiceGigi?.choiceGigi === "regio_8";

    // Jika klik dinonaktifkan, kembalikan polygon tanpa onClick
    return (
      <polygon
        key={points}
        data-nomor-gigi={trimmedNomor}
        points={points}
        // Tambahkan logika kondisi untuk onClick
        onClick={(e) => !shouldDisableClick && handlePolygonClickSatuBagian(e, "tooth_number")}
        onMouseEnter={(e) => {
          const nomor = e.target.getAttribute("data-nomor-gigi")?.trim();
          setInfoGigi(nomor);

          const kondisiNames = getDisplayNamesForTooth(nomor, "kondisi").map(x => x.display_name);
          const restorasiNames = getDisplayNamesForTooth(nomor, "restorasi").map(x => x.display_name);
          const restorasiMaterialNames = getDisplayNamesForTooth(nomor, "restorasi_material").map(x => x.display_name);
          const protesaNames = getDisplayNamesForTooth(nomor, "protesa").map(x => x.display_name);
          const protesaMaterialNames = getDisplayNamesForTooth(nomor, "protesa_material").map(x => x.display_name);


          setKondisiGigi(kondisiNames.join(", "));
          setRestorasiGigi(restorasiNames.join(", "));
          setRestorasiMaterialGigi(restorasiMaterialNames.join(", "));
          setProtesaGigi(protesaNames.join(", "));
          setProtesaMaterialGigi(protesaMaterialNames.join(", "));
        }}
        onMouseLeave={() => {
          setInfoGigi("XX-X");
          setKondisiGigi("");
          setRestorasiGigi("");
          setRestorasiMaterialGigi("");
          setProtesaGigi("");
          setProtesaMaterialGigi("");
        }}
        style={{
          fill: getToothFillColor(trimmedNomor),
          stroke: "black",
        }}
      />
    );
  };


  const renderToothPolygonDebrisIndex = (points, nomorGigi, fillColor = "white") => {
    const trimmedNomor = nomorGigi.trim();
    const shouldDisableClick =
      formchoiceGigi?.choiceGigi === "ra_rb_full" ||
      formchoiceGigi?.choiceGigi === "ra_rb_dewasa" ||
      formchoiceGigi?.choiceGigi === "ra_rb_anak" ||
      formchoiceGigi?.choiceGigi === "ra_dewasa_anak" ||
      formchoiceGigi?.choiceGigi === "ra_dewasa" ||
      formchoiceGigi?.choiceGigi === "ra_anak" ||
      formchoiceGigi?.choiceGigi === "rb_dewasa_anak" ||
      formchoiceGigi?.choiceGigi === "rb_dewasa" ||
      formchoiceGigi?.choiceGigi === "rb_anak" ||
      formchoiceGigi?.choiceGigi === "regio_1" ||
      formchoiceGigi?.choiceGigi === "regio_2" ||
      formchoiceGigi?.choiceGigi === "regio_3" ||
      formchoiceGigi?.choiceGigi === "regio_4" ||
      formchoiceGigi?.choiceGigi === "regio_5" ||
      formchoiceGigi?.choiceGigi === "regio_6" ||
      formchoiceGigi?.choiceGigi === "regio_7" ||
      formchoiceGigi?.choiceGigi === "regio_8";


    return (
      <polygon
        key={points}
        data-nomor-gigi={trimmedNomor}
        onClick={(e) => {
          if (!shouldDisableClick) {
            const nomor = e.target.getAttribute("data-nomor-gigi")?.trim();
            const debrisIndexNames = getDisplayNamesForToothDebrisIndex(nomor) || [];
            setDebrisIndexGigi(debrisIndexNames.join(", "));
          }
        }}
        points={points}
        onMouseEnter={(e) => {
          const nomor = e.target.getAttribute("data-nomor-gigi")?.trim();
          setInfoGigi(nomor);

          const debrisIndexNames = getDisplayNamesForToothDebrisIndex(nomor) || [];
          setDebrisIndexGigi(debrisIndexNames.join(", "));
        }}
        onMouseLeave={() => {
          setInfoGigi("XX-X");
          setDebrisIndexGigi("")
        }}
        style={{
          fill: fillColor,
          stroke: "black",
        }}
      />
    );
  };

  const renderToothPolygonKalkulusIndex = (points, nomorGigi, fillColor = "white") => {
    const trimmedNomor = nomorGigi.trim();
    const shouldDisableClick =
      formchoiceGigi?.choiceGigi === "ra_rb_full" ||
      formchoiceGigi?.choiceGigi === "ra_rb_dewasa" ||
      formchoiceGigi?.choiceGigi === "ra_rb_anak" ||
      formchoiceGigi?.choiceGigi === "ra_dewasa_anak" ||
      formchoiceGigi?.choiceGigi === "ra_dewasa" ||
      formchoiceGigi?.choiceGigi === "ra_anak" ||
      formchoiceGigi?.choiceGigi === "rb_dewasa_anak" ||
      formchoiceGigi?.choiceGigi === "rb_dewasa" ||
      formchoiceGigi?.choiceGigi === "rb_anak" ||
      formchoiceGigi?.choiceGigi === "regio_1" ||
      formchoiceGigi?.choiceGigi === "regio_2" ||
      formchoiceGigi?.choiceGigi === "regio_3" ||
      formchoiceGigi?.choiceGigi === "regio_4" ||
      formchoiceGigi?.choiceGigi === "regio_5" ||
      formchoiceGigi?.choiceGigi === "regio_6" ||
      formchoiceGigi?.choiceGigi === "regio_7" ||
      formchoiceGigi?.choiceGigi === "regio_8";


    return (
      <polygon
        key={points}
        data-nomor-gigi={trimmedNomor}
        onClick={(e) => {
          if (!shouldDisableClick) {
            const nomor = e.target.getAttribute("data-nomor-gigi")?.trim();
            const kalakulusIndexNames = getDisplayNamesForToothKalkulusIndex(nomor) || [];
            setKalkulusIndexGigi(kalakulusIndexNames.join(", "));
          }
        }}
        points={points}
        onMouseEnter={(e) => {
          const nomor = e.target.getAttribute("data-nomor-gigi")?.trim();
          setInfoGigi(nomor);

          const kalkulusIndexNames = getDisplayNamesForToothKalkulusIndex(nomor) || [];
          setKalkulusIndexGigi(kalkulusIndexNames.join(", "));
        }}
        onMouseLeave={() => {
          setInfoGigi("XX-X");
          setKalkulusIndexGigi("")
        }}
        style={{
          fill: fillColor,
          stroke: "black",
        }}
      />
    );
  };



  // Per Gigi
  const bagianGigiMap = [
    { kode: "B", points: "0,0 40,0 30,10 10,10" },
    { kode: "P", points: "10,30 30,30 40,40 0,40" },
    { kode: "M", points: "30,10 40,0 40,40 30,30" },
    { kode: "D", points: "0,0 10,10 10,30 0,40" },
    { kode: "O", points: "10,10 30,10 30,30 10,30" },
  ];

  const bagianGigiMapOther = [
    { kode: "L", points: "0,0 40,0 30,20 0,20", label: "Labial" },
    { kode: "P", points: "0,20 30,20 100,100 0,100", label: "Palatal" },
    { kode: "M", points: "30,20 40,0 40,40 35,30", label: "Mesial" },
    { kode: "D", points: "0,0 5,10 10,20 0,40", label: "Distal" }
  ];

  const handleMouseEnterBagianGigi = (e) => {
    const nomor = e.target.getAttribute("data-nomor-gigi")?.trim();
    setInfoGigi(nomor);

    const kondisiNames = getDisplayNamesForTooth(nomor, "kondisi").map(x => x.display_name);
    const restorasiNames = getDisplayNamesForTooth(nomor, "restorasi").map(x => x.display_name);
    const restorasiMaterialNames = getDisplayNamesForTooth(nomor, "restorasi_material").map(x => x.display_name);
    const protesaNames = getDisplayNamesForTooth(nomor, "protesa").map(x => x.display_name);
    const protesaMaterialNames = getDisplayNamesForTooth(nomor, "protesa_material").map(x => x.display_name);

    setKondisiGigi(kondisiNames.join(", "));
    setRestorasiGigi(restorasiNames.join(", "));
    setRestorasiMaterialGigi(restorasiMaterialNames.join(", "));
    setProtesaGigi(protesaNames.join(", "));
    setProtesaMaterialGigi(protesaMaterialNames.join(", "));
  };

  const handleMouseLeaveBagianGigi = () => {
    setInfoGigi("XX-X");
    setKondisiGigi("");
    setRestorasiGigi("");
    setRestorasiMaterialGigi("");
    setProtesaGigi("");
    setProtesaMaterialGigi("");
  };


  const handleChildData = (data, debrisIndexGigi) => {
    setGetDataDebrisIndex(data, debrisIndexGigi);
  };

  const handleChildDataKalkulus = (data, kalkulusIndexGigi) => {
    setGetDataKalkulusIndex(data, kalkulusIndexGigi);
  };


  return (
    <div style={{ backgroundColor: "white", marginTop: "15px", marginLeft: "10px", marginRight: "10px", boxShadow: "2px 2px 10px #BFBFBF" }}>
      {modalMedicalRecord && <ModalAddMedicalRecord idPatientMedicalRecord={idPatientMedicalRecord} idPatientMedicalRecordFirstName={idPatientMedicalRecordFirstName} idPatientMedicalRecordLastName={idPatientMedicalRecordLastName} show={modalMedicalRecord} onHide={() => setModalMedicalRecord(false)} />}
      {modalCardReminder && (
        <ModalCardReminder
          show={modalCardReminder}
          onHide={handleCloseModalCardReminder}
        />
      )}
      {modalCardReminderAfter && (
        <ModalCardReminderAfter
          show={modalCardReminderAfter}
          onHide={handleCloseModalCardReminder}
        />
      )}
      {loading && <LoaderHome />}

      <div style={{ paddingLeft: "0px", width: "100%", borderBottom: "5px solid #EEEEEE", display: "flex", padding: "10px 0px", fontFamily: "sans-serif" }}>
        <div style={{ fontSize: "16px", display: "flex", aunlocklignItems: "center", paddingLeft: "10px", color: "#001F8B" }}>
          <div onClick={viewModalMedicalRecord} style={{ display: "flex", marginRight: "10px", fontSize: "11px", color: "white", backgroundColor: "#ABC1FF", padding: "5px 10px", borderRadius: "3px", cursor: "pointer", border: "none", borderTopLeftRadius: "5px", borderBottomLeftRadius: "5px" }}>
            <div style={{ display: "flex", alignItems: "center", height: "100%", marginRight: "3px" }}>
              <FaMedkit style={{ display: "flex", alignItems: "center", fontSize: "15px" }} />
            </div>
            <div style={{ display: "flex", alignItems: "center", height: "100%", fontSize: "12px" }}>
              Data Medis
            </div>
          </div>
          {/* <div style={{flex:"50%",fontSize:"16px",display:"flex", alignItems:"center", paddingLeft:"10px", color:"#001F8B"}}>
          <FaAddressBook style={{marginRight:"5px"}}/>Treatment Plan
        </div> */}
          <button
            onClick={() => setModalCardReminder(true)}
            title="Lihat Kartu Pengingat"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              height: "32px",
              padding: "0px 10px",
              marginRight: "5px",
              backgroundColor: "white",
              border: "1px solid #DEDEDE",
              borderRadius: "3px",
              cursor: "pointer",
              color: "#001f8b"
            }}
          >
            <FaInfoCircle style={{ fontSize: "15px" }} />
          </button>
          <div>
            Treatment Plan
          </div>

        </div>
      </div>

      {getDataAppointmentByIdTreatmentPlanStatusButton === null ?
        <>
          <Form onSubmit={
            (e) => handleSubmit.mutate(e)
          } style={{ padding: "0px 0px 30px 0px", fontFamily: "sans-serif" }} >
            <div style={{ padding: "10px 20px 20px 20px", backgroundColor: "#50D1FF", borderBottom: "5px solid #EEEEEE" }}>
              <div className="" style={{ display: "flex" }}>
                <div style={{ flex: "50%", display: "flex", alignItems: "center", marginRight: "20px" }}>
                  <div style={{ width: "100%" }}>
                    <div style={{ fontSize: "12px", color: "", fontStyle: "", fontWeight: "bold" }}>Dokter</div>
                    <input disabled type="text" value={form?.name_doctor_firstname + ` ` + form?.name_doctor_lastname} name="id_doctor" onChange={handleChange} style={{ backgroundColor: "#DEDEDE", width: "100%", border: "1px solid #C9C9C9", outline: "none", height: "35px", borderRadius: "5px", paddingLeft: "5px", appearance: "textfield" }} />
                    {/* <div style={{fontSize:"10px", color:"#898989", fontStyle:"italic", fontWeight:"bold"}}>Anamnesa</div> */}
                  </div>
                </div>
                <div style={{ flex: "50%", display: "flex", alignItems: "center" }}>
                  <div style={{ width: "100%" }}>
                    <div style={{ fontSize: "12px", color: "", fontStyle: "", fontWeight: "bold" }}>Pasien</div>
                    <input disabled type="text" value={form?.name_patient_firstname + ` ` + form?.name_patient_lastname + "  " + (getDataMedicalRecordPatientForStatusMember === 0 || getDataMedicalRecordPatientForStatusMember === "0" ? "(pasien baru)" : "")} name="id_patient" onChange={handleChange}
                      style={{ color: getDataMedicalRecordPatientForStatusMember === 0 || getDataMedicalRecordPatientForStatusMember === "0" ? "red" : "", backgroundColor: "#DEDEDE", width: "100%", border: "1px solid #C9C9C9", outline: "none", height: "35px", borderRadius: "5px", paddingLeft: "5px" }} />
                    {/* <div style={{fontSize:"10px", color:"#898989", fontStyle:"italic", fontWeight:"bold"}}>Anamnesa</div> */}
                  </div>
                </div>
              </div>

              <div className="mt-2" style={{ display: "flex" }}>
                <div style={{ flex: "50%", display: "flex", alignItems: "center", marginRight: "20px" }}>
                  <div style={{ width: "100%" }}>
                    <div style={{ fontSize: "12px", color: "", fontStyle: "", fontWeight: "bold" }}>Tanggal Dan Waktu Appointment</div>
                    <input autoFofcus type='text' disabled
                      value={
                        `${form?.date_plan}`.split('-')[2] + ` ` +
                        (`${form?.date_plan}`.split('-')[1] === "01" ? "Januari" : "" ||
                          `${form?.date_plan}`.split('-')[1] === "02" ? "Februari" : "" ||
                            `${form?.date_plan}`.split('-')[1] === "03" ? "Maret" : "" ||
                              `${form?.date_plan}`.split('-')[1] === "04" ? "April" : "" ||
                                `${form?.date_plan}`.split('-')[1] === "05" ? "Mei" : "" ||
                                  `${form?.date_plan}`.split('-')[1] === "06" ? "Juni" : "" ||
                                    `${form?.date_plan}`.split('-')[1] === "07" ? "Juli" : "" ||
                                      `${form?.date_plan}`.split('-')[1] === "08" ? "Agustus" : "" ||
                                        `${form?.date_plan}`.split('-')[1] === "09" ? "September" : "" ||
                                          `${form?.date_plan}`.split('-')[1] === "10" ? "Oktober" : "" ||
                                            `${form?.date_plan}`.split('-')[1] === "11" ? "November" : "" ||
                                              `${form?.date_plan}`.split('-')[1] === "12" ? "Desember" : "") + ` ` +
                        `${form?.date_plan}`.split('-')[0] + "   |   " + `${form?.time}`.split(':')[0] + ` : ` + `${form?.time}`.split(':')[1]
                      }
                      name="date_plan" style={{ backgroundColor: "#DEDEDE", width: "100%", border: "1px solid #C9C9C9", outline: "none", height: "35px", borderRadius: "5px", paddingLeft: "5px" }} />
                  </div>
                </div>
                <div style={{ flex: "50%", display: "flex", alignItems: "center" }}>
                  <div style={{ width: "100%" }}>
                    <div style={{ fontSize: "12px", color: "", fontStyle: "", fontWeight: "bold" }}>Anamnesa</div>
                    <input className="focused" type="text" value={form?.anamnesa} name="anamnesa" onChange={handleChangeForm} style={{ backgroundColor: "", width: "100%", border: "1px solid #C9C9C9", outline: "none", height: "35px", borderRadius: "5px", paddingLeft: "5px" }} />
                  </div>
                </div>
              </div>
            </div>

            <div className="mt-2" style={{ display: "flex", fontWeight: "bold", padding: "0px 10px" }}>Treatment :</div>
            <div className="App">
              <div className="mt-2" style={{ padding: "0px 10px" }}>
                <>
                  <div className="" style={{ display: "flex" }}>
                    <div style={{ flex: "35%", display: "flex", alignItems: "", marginRight: "10px" }}>
                      <div style={{ width: "100%" }}>
                        <div style={{ fontSize: "12px", color: "", fontStyle: "", fontWeight: "bold" }}>Dokter</div>
                        <select className="form-select" aria-label="Default select example" value={dataItem?.id_doctor} onChange={handleInputChange} name="id_doctor" style={{ textAlign: "", cursor: "pointer" }}>
                          <option value="">Select Dokter</option>
                          {getDataDokter.map((user, index) => (
                            <option value={user?.id} style={{ textAlign: "" }}>{user?.firstname} {user?.lastname}</option>
                          ))}
                        </select>
                      </div>
                    </div>
                    {/* Disini */}
                    <TreatmentDropdown
                      key={selectKey}
                      page={1}
                      limit={0}
                      ascending={ascending}
                      keyword={keyword}
                      selectKey={selectKey}
                      setGetDataTreatment={setGetDataTreatment}
                      handleInputChange2={handleInputChange2}
                      getDataTreatment={getDataTreatment}
                    />
                  </div>


                  <div className="mt-4 mb-3" style={{ display: "flex" }}>
                    <div style={{ flex: "10%", display: "flex", alignItems: " center", fontSize: "15px", color: "", fontStyle: "", fontWeight: "bold" }}>
                      Nomor Gigi :
                    </div>

                    <div className="mr-2" style={{ flex: "30%", display: "flex", alignItems: "center" }}>
                      <div style={{ width: "100%" }}>
                        <select className="form-select" aria-label="Default select example" value={formchoiceGigi?.choiceGigi} onChange={handleChange} name="choiceGigi" style={{ textAlign: "", cursor: "pointer" }}>
                          <option value="satu_gigi">Satu Gigi</option>
                          <option value="per_gigi">Bagian Gigi</option>
                          <option value="ra_rb_full">RA + RB ( Dewasa+Anak )</option>
                          <option value="ra_rb_dewasa">RA + RB Dewasa</option>
                          <option value="ra_rb_anak">RA + RB Anak</option>
                          <option value="ra_dewasa_anak">RA ( Dewasa+Anak )</option>
                          <option value="ra_dewasa">RA ( Dewasa )</option>
                          <option value="ra_anak">RA ( Anak )</option>
                          <option value="rb_dewasa_anak">RB ( Dewasa+Anak )</option>
                          <option value="rb_dewasa">RB ( Dewasa )</option>
                          <option value="rb_anak">RB ( Anak )</option>
                          <option value="regio_1">Regio 1</option>
                          <option value="regio_2">Regio 2</option>
                          <option value="regio_3">Regio 3</option>
                          <option value="regio_4">Regio 4</option>
                          <option value="regio_5">Regio 5</option>
                          <option value="regio_6">Regio 6</option>
                          <option value="regio_7">Regio 7</option>
                          <option value="regio_8">Regio 8</option>
                        </select>
                      </div>
                    </div>

                    <div style={{ flex: "35%", display: "flex", alignItems: "center", marginRight: "10px" }}>
                      <div style={{ width: "100%", cursor: "pointer" }}>
                        <Select
                          key={selectKeyDiagnosa}
                          name="description"
                          onChange={handleInputChange3}
                          options={getDataDiagnosaPatient.map(user => ({ value: user.id, label: user.code_skri + " | " + user.name_str }))}
                          placeholder="Pilih Diagnosa"
                        />
                      </div>
                    </div>
                    {/* <div style={{ flex: "30%", display: "flex", alignItems: "start", marginLeft: "10px" }}> */}
                    <div style={{ flex: "30%", display: "flex", alignItems: "center" }}>
                      <div style={{ width: "100%" }}>
                        <div style={{ fontSize: "12px", color: "", fontStyle: "", fontWeight: "bold", display: "flex", justifyContent: "" }}>Harga : {formatToRupiah(dataItem.treatment_price_min)} - {formatToRupiah(dataItem.treatment_price_max)}</div>
                        <input className="focused" step={50000} type='number' placeholder="Masukan Harga" name="estimate_price" min={dataItem.treatment_price_min} max={dataItem.treatment_price_max} value={dataItem?.estimate_price} onChange={handleInputChange}
                          style={{ width: "100%", height: "37.5px", textAlign: "center", border: "1px solid #C9C9C9", borderRadius: "5px" }} />
                        {/* </div> */}
                      </div>
                    </div>
                  </div>

                  <Row>
                    {/* Label Pemeriksaan Gigi */}
                    <Col md="auto">
                      <div style={{ fontSize: '15px', fontWeight: 'bold', whiteSpace: 'nowrap' }}>
                        Pemeriksaan Gigi:
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <KondisiButtonModal
                      openModalType={openModalType}
                      openModal={openModal}
                      closeModal={closeModal}
                      setVisibleOdontogram={false}
                      getDataDentalCondition={getDataDentalCondition}
                      getDataDentalRestoration={getDataDentalRestoration}
                      cleanedTooth={selectedTooth}
                      setSelectedTooth={setSelectedTooth}
                      toothConditions={toothConditions}
                      setToothConditions={setToothConditions}
                      selectedTeeth={selectedTeeth}
                      setSelectedTeeth={setSelectedTeeth}
                      activeConditionSelections={activeConditionSelections}
                      setActiveConditionSelections={setActiveConditionSelections}
                      tempSelections={tempSelections}
                      setTempSelections={setTempSelections}
                      kondisiGigiColor={kondisiGigiColor}
                      activeMode={activeMode}
                      setActiveMode={setActiveMode}
                      shouldPromptCondition={shouldPromptCondition}
                      setShouldPromptCondition={setShouldPromptCondition}
                      shouldPromptRestoration={shouldPromptRestoration}
                      setShouldPromptRestoration={setShouldPromptRestoration}
                      shouldPromptRestorationMaterial={shouldPromptRestorationMaterial}
                      setShouldPromptRestorationMaterial={setShouldPromptRestorationMaterial}
                      shouldPromptProtesa={shouldPromptProtesa}
                      setShouldPromptProtesa={setShouldPromptProtesa}
                      shouldPromptProtesaMaterial={shouldPromptProtesaMaterial}
                      setShouldPromptProtesaMaterial={setShouldPromptProtesaMaterial}
                      conditionData={conditionData}
                      setConditionData={setConditionData}
                      toothColors={kondisiGigiColor}
                      buttonChoiceCondition={buttonChoiceCondition}
                      setButtonChoiceCondition={setButtonChoiceCondition}
                      buttonChoiceRestoration={buttonChoiceRestoration}
                      setButtonChoiceRestoration={setButtonChoiceRestoration}
                      buttonChoiceRestorationMaterial={buttonChoiceRestorationMaterial}
                      setButtonChoiceRestorationMaterial={setButtonChoiceRestorationMaterial}
                      buttonChoiceProtesa={buttonChoiceProtesa}
                      setButtonChoiceProtesa={setButtonChoiceProtesa}
                      buttonChoiceProtesaMaterial={buttonChoiceProtesaMaterial}
                      setButtonChoiceProtesaMaterial={setButtonChoiceProtesaMaterial}
                      choiceToothCategory={choiceToothCategory}
                    />
                    <RestorasiButtonModal
                      openModalType={openModalType}
                      openModal={openModal}
                      closeModal={closeModal}
                      getDataDentalRestoration={getDataDentalRestoration}
                      cleanedTooth={selectedTooth}
                      setVisibleOdontogram={false}
                      setSelectedTooth={setSelectedTooth}
                      toothRestorations={toothRestorations}
                      setToothRestorations={setToothRestorations}
                      selectedTeeth={selectedTeeth}
                      setSelectedTeeth={setSelectedTeeth}
                      activeRestorasiSelections={activeRestorasiSelections}
                      setActiveRestorasiSelections={setActiveRestorasiSelections}
                      tempRestorasiSelections={tempRestorasiSelections}
                      setTempRestorasiSelections={setTempRestorasiSelections}
                      activeMode={activeMode}
                      setActiveMode={setActiveMode}
                      shouldPromptRestoration={shouldPromptRestoration}
                      setShouldPromptRestoration={setShouldPromptRestoration}
                      shouldPromptCondition={shouldPromptCondition}
                      setShouldPromptCondition={setShouldPromptCondition}
                      shouldPromptRestorationMaterial={shouldPromptRestorationMaterial}
                      setShouldPromptRestorationMaterial={setShouldPromptRestorationMaterial}
                      shouldPromptProtesa={shouldPromptProtesa}
                      setShouldPromptProtesa={setShouldPromptProtesa}
                      shouldPromptProtesaMaterial={shouldPromptProtesaMaterial}
                      setShouldPromptProtesaMaterial={setShouldPromptProtesaMaterial}
                      restorationData={restorationData}
                      setRestorationData={setRestorationData}
                      restorasiGigiColor={restorasiGigiColor}
                      buttonChoiceRestoration={buttonChoiceRestoration}
                      setButtonChoiceRestoration={setButtonChoiceRestoration}
                      buttonChoiceCondition={buttonChoiceCondition}
                      setButtonChoiceCondition={setButtonChoiceCondition}
                      buttonChoiceRestorationMaterial={buttonChoiceRestorationMaterial}
                      setButtonChoiceRestorationMaterial={setButtonChoiceRestorationMaterial}
                      buttonChoiceProtesa={buttonChoiceProtesa}
                      setButtonChoiceProtesa={setButtonChoiceProtesa}
                      buttonChoiceProtesaMaterial={buttonChoiceProtesaMaterial}
                      setButtonChoiceProtesaMaterial={setButtonChoiceProtesaMaterial}
                      choiceToothCategory={choiceToothCategory}
                    />
                    <RestorasiMaterialButtonModal
                      openModalType={openModalType}
                      openModal={openModal}
                      closeModal={closeModal}
                      getDataDentalRestorationMaterial={getDataDentalRestorationMaterial}
                      cleanedTooth={selectedTooth}
                      setSelectedTooth={setSelectedTooth}
                      setVisibleOdontogram={false}
                      toothRestorationMaterials={toothRestorationMaterials}
                      setToothRestorationMaterials={setToothRestorationMaterials}
                      selectedTeeth={selectedTeeth}
                      setSelectedTeeth={setSelectedTeeth}
                      activeRestorasiMaterialSelections={activeRestorasiMaterialSelections}
                      setActiveRestorasiMaterialSelections={setActiveRestorasiMaterialSelections}
                      tempRestorasiMaterialSelections={tempRestorasiMaterialSelections}
                      setTempRestorasiMaterialSelections={setTempRestorasiMaterialSelections}
                      activeMode={activeMode}
                      setActiveMode={setActiveMode}
                      shouldPromptRestoration={shouldPromptRestoration}
                      setShouldPromptRestoration={setShouldPromptRestoration}
                      shouldPromptCondition={shouldPromptCondition}
                      setShouldPromptCondition={setShouldPromptCondition}
                      shouldPromptRestorationMaterial={shouldPromptRestorationMaterial}
                      setShouldPromptRestorationMaterial={setShouldPromptRestorationMaterial}
                      shouldPromptProtesa={shouldPromptProtesa}
                      setShouldPromptProtesa={setShouldPromptProtesa}
                      shouldPromptProtesaMaterial={shouldPromptProtesaMaterial}
                      setShouldPromptProtesaMaterial={setShouldPromptProtesaMaterial}
                      restorationMaterialData={restorationMaterialData}
                      setRestorationMaterialData={setRestorationMaterialData}
                      restorasiMaterialGigiColor={restorasiMaterialGigiColor}
                      buttonChoiceRestoration={buttonChoiceRestoration}
                      setButtonChoiceRestoration={setButtonChoiceRestoration}
                      buttonChoiceCondition={buttonChoiceCondition}
                      setButtonChoiceCondition={setButtonChoiceCondition}
                      buttonChoiceRestorationMaterial={buttonChoiceRestorationMaterial}
                      setButtonChoiceRestorationMaterial={setButtonChoiceRestorationMaterial}
                      buttonChoiceProtesa={buttonChoiceProtesa}
                      setButtonChoiceProtesa={setButtonChoiceProtesa}
                      buttonChoiceProtesaMaterial={buttonChoiceProtesaMaterial}
                      setButtonChoiceProtesaMaterial={setButtonChoiceProtesaMaterial}
                      choiceToothCategory={choiceToothCategory}
                    />
                    <ProtesaButtonModal
                      openModalType={openModalType}
                      openModal={openModal}
                      closeModal={closeModal}
                      getDataDentalProtesa={getDataDentalProtesa}
                      cleanedTooth={selectedTooth}
                      setSelectedTooth={setSelectedTooth}
                      toothProtesas={toothProtesas}
                      setToothProtesas={setToothProtesas}
                      selectedTeeth={selectedTeeth}
                      setSelectedTeeth={setSelectedTeeth}
                      activeProtesaSelections={activeProtesaSelections}
                      setActiveProtesaSelections={setActiveProtesaSelections}
                      tempProtesaSelections={tempProtesaSelections}
                      setTempProtesaSelections={setTempProtesaSelections}
                      activeMode={activeMode}
                      setActiveMode={setActiveMode}
                      shouldPromptRestoration={shouldPromptRestoration}
                      setShouldPromptRestoration={setShouldPromptRestoration}
                      shouldPromptCondition={shouldPromptCondition}
                      setShouldPromptCondition={setShouldPromptCondition}
                      shouldPromptRestorationMaterial={shouldPromptRestorationMaterial}
                      setShouldPromptRestorationMaterial={setShouldPromptRestorationMaterial}
                      shouldPromptProtesa={shouldPromptProtesa}
                      setShouldPromptProtesa={setShouldPromptProtesa}
                      shouldPromptProtesaMaterial={shouldPromptProtesaMaterial}
                      setShouldPromptProtesaMaterial={setShouldPromptProtesaMaterial}
                      protesaData={protesaData}
                      setVisibleOdontogram={false}
                      setProtesaData={setProtesaData}
                      protesaGigiColor={protesaGigiColor}
                      buttonChoiceRestoration={buttonChoiceRestoration}
                      setButtonChoiceRestoration={setButtonChoiceRestoration}
                      buttonChoiceCondition={buttonChoiceCondition}
                      setButtonChoiceCondition={setButtonChoiceCondition}
                      buttonChoiceRestorationMaterial={buttonChoiceRestorationMaterial}
                      setButtonChoiceRestorationMaterial={setButtonChoiceRestorationMaterial}
                      buttonChoiceProtesa={buttonChoiceProtesa}
                      setButtonChoiceProtesa={setButtonChoiceProtesa}
                      buttonChoiceProtesaMaterial={buttonChoiceProtesaMaterial}
                      setButtonChoiceProtesaMaterial={setButtonChoiceProtesaMaterial}
                      choiceToothCategory={choiceToothCategory}
                    />
                    <ProtesaMaterialButtonModal
                      openModalType={openModalType}
                      openModal={openModal}
                      closeModal={closeModal}
                      getDataDentalProtesaMaterial={getDataDentalProtesaMaterial}
                      cleanedTooth={selectedTooth}
                      setSelectedTooth={setSelectedTooth}
                      toothProtesaMaterial={toothProtesaMaterial}
                      setToothProtesaMaterial={setToothProtesaMaterial}
                      selectedTeeth={selectedTeeth}
                      setSelectedTeeth={setSelectedTeeth}
                      activeProtesaMaterialSelections={activeProtesaMaterialSelections}
                      setActiveProtesaMaterialSelections={setActiveProtesaMaterialSelections}
                      tempProtesaMaterialSelections={tempProtesaMaterialSelections}
                      setTempProtesaMaterialSelections={setTempProtesaMaterialSelections}
                      activeMode={activeMode}
                      setActiveMode={setActiveMode}
                      shouldPromptRestoration={shouldPromptRestoration}
                      setShouldPromptRestoration={setShouldPromptRestoration}
                      shouldPromptCondition={shouldPromptCondition}
                      setShouldPromptCondition={setShouldPromptCondition}
                      shouldPromptRestorationMaterial={shouldPromptRestorationMaterial}
                      setShouldPromptRestorationMaterial={setShouldPromptRestorationMaterial}
                      shouldPromptProtesa={shouldPromptProtesa}
                      setShouldPromptProtesa={setShouldPromptProtesa}
                      shouldPromptProtesaMaterial={shouldPromptProtesaMaterial}
                      setShouldPromptProtesaMaterial={setShouldPromptProtesaMaterial}
                      protesaMaterialData={protesaMaterialData}
                      setVisibleOdontogram={false}
                      setProtesaMaterialData={setProtesaMaterialData}
                      protesaMaterialGigiColor={protesaMaterialGigiColor}
                      buttonChoiceRestoration={buttonChoiceRestoration}
                      setButtonChoiceRestoration={setButtonChoiceRestoration}
                      buttonChoiceCondition={buttonChoiceCondition}
                      setButtonChoiceCondition={setButtonChoiceCondition}
                      buttonChoiceRestorationMaterial={buttonChoiceRestorationMaterial}
                      setButtonChoiceRestorationMaterial={setButtonChoiceRestorationMaterial}
                      buttonChoiceProtesa={buttonChoiceProtesa}
                      setButtonChoiceProtesa={setButtonChoiceProtesa}
                      buttonChoiceProtesaMaterial={buttonChoiceProtesaMaterial}
                      setButtonChoiceProtesaMaterial={setButtonChoiceProtesaMaterial}
                      choiceToothCategory={choiceToothCategory}
                    />
                  </Row>
                  <Row>
                    <div className="col-md-4 mt-2">
                      <DebrisIndexButtonModal
                        visibleOdontogram={visibleOdontogram}
                        setVisibleOdontogram={setVisibleOdontogram}
                        setVisibleOdontogramKalkulus={setVisibleOdontogramKalkulus}
                        toothShapes={toothShapes}
                        customToothShapes={customToothShapes}
                        renderToothPolygon={renderToothPolygon}
                        activeIndex={activeIndex}
                        setActiveIndex={setActiveIndex}
                      />
                    </div>
                    <div className="col-md-4 mt-2">
                      <KalkulusIndexButtonModal
                        setVisibleOdontogram={setVisibleOdontogram}
                        visibleOdontogramKalkulus={visibleOdontogramKalkulus}
                        setVisibleOdontogramKalkulus={setVisibleOdontogramKalkulus}
                        toothShapes={toothShapes}
                        customToothShapes={customToothShapes}
                        renderToothPolygon={renderToothPolygon}
                        activeIndex={activeIndex}
                        setActiveIndex={setActiveIndex}
                      />
                    </div>
                  </Row>
                  <div className="mt-3" style={{ display: "flex", alignItems: " center", fontSize: "15px", color: "", fontStyle: "", fontWeight: "bold" }}>
                    Keterangan Gigi : {infoGigi}
                  </div>
                  <Row className="mt-3">
                    <div style={{ fontSize: "15px", fontWeight: "bold" }}>
                      <div style={{ display: "flex", gap: "16px" }}>
                        {/* Kolom Pertama */}
                        <div style={{ flex: 1 }}>
                          {visibleOdontogram &&
                            <>
                              <div style={{ display: "flex", alignItems: "center" }}>
                                Kondisi Gigi: {kondisiGigi}
                              </div>
                              <div style={{ display: "flex", alignItems: "center" }}>
                                Restorasi Gigi: {restorasiGigi}
                              </div>
                              <div style={{ display: "flex", alignItems: "center" }}>
                                Bahan Restorasi Gigi: {restorasiMaterialGigi}
                              </div>
                              <div style={{ display: "flex", alignItems: "center" }}>
                                Protesa Gigi: {protesaGigi}
                              </div>
                              <div style={{ display: "flex", alignItems: "center" }}>
                                Bahan Protesa Gigi: {protesaMaterialGigi}
                              </div>
                            </>
                          }
                          {!visibleOdontogram &&
                            <>
                              <div style={{ display: "flex", alignItems: "center" }}>
                                Debris Index Gigi: {debrisIndexGigi}
                              </div>
                            </>
                          }

                          {!visibleOdontogramKalkulus &&
                            <>
                              <div style={{ display: "flex", alignItems: "center" }}>
                                Kalkulus Index Gigi: {kalkulusIndexGigi}
                              </div>
                            </>
                          }

                        </div>

                        {/* Kolom Kedua */}
                        {visibleOdontogram &&
                          <div style={{ flex: 1 }}>
                            <div style={{ display: "flex", alignItems: "center" }}>
                              Oklusi: {occlusiGigi}
                            </div>
                            <div style={{ display: "flex", alignItems: "center" }}>
                              Torus Palatinus: {torusPalatinusGigi}
                            </div>
                            <div style={{ display: "flex", alignItems: "center" }}>
                              Torus Mandibularis: {torusMandiBularisGigi}
                            </div>
                            <div style={{ display: "flex", alignItems: "center" }}>
                              Palatum: {palatumGigi}
                            </div>
                            <div style={{ display: "flex", alignItems: "center" }}>
                              Diastema: {diastemaGigi}
                            </div>
                            <div style={{ display: "flex", alignItems: "center" }}>
                              Anomali: {anomaliGigi}
                            </div>
                          </div>
                        }
                      </div>
                    </div>
                  </Row>
                  {visibleOdontogram && visibleOdontogramKalkulus && activeIndex !== 'kalkulus' && activeIndex !== 'debris' ?
                    <>
                      {formchoiceGigi?.choiceGigi === "satu_gigi" || formchoiceGigi?.choiceGigi === "ra_rb_full" || formchoiceGigi?.choiceGigi === "ra_rb_dewasa" ||
                        formchoiceGigi?.choiceGigi === "ra_dewasa_anak" || formchoiceGigi?.choiceGigi === "ra_dewasa" || formchoiceGigi?.choiceGigi === "ra_anak" ||
                        formchoiceGigi?.choiceGigi === "rb_dewasa_anak" || formchoiceGigi?.choiceGigi === "rb_dewasa" || formchoiceGigi?.choiceGigi === "rb_anak" ||
                        formchoiceGigi?.choiceGigi === "ra_rb_anak" || formchoiceGigi?.choiceGigi === "regio_1" || formchoiceGigi?.choiceGigi === "regio_2" ||
                        formchoiceGigi?.choiceGigi === "regio_3" || formchoiceGigi?.choiceGigi === "regio_4" || formchoiceGigi?.choiceGigi === "regio_5" ||
                        formchoiceGigi?.choiceGigi === "regio_6" || formchoiceGigi?.choiceGigi === "regio_7" || formchoiceGigi?.choiceGigi === "regio_8" ?
                        <Col className="mt-2" xl='12' sm='12' style={{ padding: "0px 0px", fontSize: "12px" }} >

                          {/* Gigi Atas Dewasa */}
                          <div style={{ display: "flex" }}>
                            <div style={{ flex: "50%", display: "flex", justifyContent: "end", paddingRight: "30px" }}>
                              <div style={{ width: "42px", margin: "5px" }}>
                                <div style={{ textAlign: "center" }}>18</div>
                                <svg width="42" height="42" viewBox="0 0 42 42">
                                  {toothShapes.map(({ points }) => renderToothPolygon(points, "18"))}
                                </svg>
                              </div>

                              <div style={{ width: "42px", margin: "5px" }}>
                                <div style={{ textAlign: "center" }}>17</div>
                                <svg width="42" height="42" viewBox="0 0 42 42">
                                  {toothShapes.map(({ points }) => renderToothPolygon(points, "17"))}
                                </svg>
                              </div>

                              <div style={{ width: "42px", margin: "5px" }}>
                                <div style={{ textAlign: "center" }}>16</div>
                                <svg width="42" height="42" viewBox="0 0 42 42">
                                  {toothShapes.map(({ points }) => renderToothPolygon(points, "16"))}
                                </svg>
                              </div>

                              <div style={{ width: "42px", margin: "5px" }}>
                                <div style={{ textAlign: "center" }}>15</div>
                                <svg width="42" height="42" viewBox="0 0 42 42">
                                  {toothShapes.map(({ points }) => renderToothPolygon(points, "15"))}
                                </svg>
                              </div>

                              <div style={{ width: "42px", margin: "5px" }}>
                                <div style={{ textAlign: "center" }}>14</div>
                                <svg width="42" height="42" viewBox="0 0 42 42">
                                  {toothShapes.map(({ points }) => renderToothPolygon(points, "14"))}
                                </svg>
                              </div>

                              <div style={{ width: "42px", margin: "5px" }}>
                                <div style={{ textAlign: "center" }}>13</div>
                                <svg width={42} height={42}>
                                  <g>
                                    {customToothShapes["13"].map(({ points }) => renderToothPolygon(points, "13"))}
                                  </g>
                                </svg>
                              </div>

                              <div style={{ width: "42px", margin: "5px" }}>
                                <div style={{ textAlign: "center" }}>12</div>
                                <svg width={42} height={42}>
                                  <g>
                                    {customToothShapes["12"].map(({ points }) => renderToothPolygon(points, "12"))}
                                  </g>
                                </svg>
                              </div>

                              <div style={{ width: "42px", margin: "5px" }}>
                                <div style={{ textAlign: "center" }}>11</div>
                                <svg width={42} height={42}>
                                  <g>
                                    {customToothShapes["11"].map(({ points }) => renderToothPolygon(points, "11"))}
                                  </g>
                                </svg>
                              </div>
                            </div>

                            <div style={{ flex: "50%", display: "flex", justifyContent: "start", paddingLeft: "30px" }}>
                              <div style={{ width: "42px", margin: "5px" }}>
                                <div style={{ textAlign: "center" }}>21</div>
                                <svg width={42} height={42}>
                                  <g>
                                    {customToothShapes["21"].map(({ points }) => renderToothPolygon(points, "21"))}
                                  </g>
                                </svg>
                              </div>

                              <div style={{ width: "42px", margin: "5px" }}>
                                <div style={{ textAlign: "center" }}>22</div>
                                <svg width={42} height={42}>
                                  <g>
                                    {customToothShapes["22"].map(({ points }) => renderToothPolygon(points, "22"))}
                                  </g>
                                </svg>
                              </div>

                              <div style={{ width: "42px", margin: "5px" }}>
                                <div style={{ textAlign: "center" }}>23</div>
                                <svg width={42} height={42}>
                                  <g>
                                    {customToothShapes["23"].map(({ points }) => renderToothPolygon(points, "23"))}
                                  </g>
                                </svg>
                              </div>

                              <div style={{ width: "42px", margin: "5px" }}>
                                <div style={{ textAlign: "center" }}>24</div>
                                <svg width="42" height="42" viewBox="0 0 42 42">
                                  {toothShapes.map(({ points }) => renderToothPolygon(points, "24"))}
                                </svg>
                              </div>

                              <div style={{ width: "42px", margin: "5px" }}>
                                <div style={{ textAlign: "center" }}>25</div>
                                <svg width="42" height="42" viewBox="0 0 42 42">
                                  {toothShapes.map(({ points }) => renderToothPolygon(points, "25"))}
                                </svg>
                              </div>

                              <div style={{ width: "42px", margin: "5px" }}>
                                <div style={{ textAlign: "center" }}>26</div>
                                <svg width="42" height="42" viewBox="0 0 42 42">
                                  {toothShapes.map(({ points }) => renderToothPolygon(points, "26"))}
                                </svg>
                              </div>

                              <div style={{ width: "42px", margin: "5px" }}>
                                <div style={{ textAlign: "center" }}>27</div>
                                <svg width="42" height="42" viewBox="0 0 42 42">
                                  {toothShapes.map(({ points }) => renderToothPolygon(points, "27"))}
                                </svg>
                              </div>

                              <div style={{ width: "42px", margin: "5px" }}>
                                <div style={{ textAlign: "center" }}>28</div>
                                <svg width="42" height="42" viewBox="0 0 42 42">
                                  {toothShapes.map(({ points }) => renderToothPolygon(points, "28"))}
                                </svg>
                              </div>

                            </div>
                          </div>

                          {/* Gigi Atas Anak */}
                          <div style={{ display: "flex" }}>
                            <div style={{ flex: "50%", display: "flex", justifyContent: "end", paddingRight: "30px" }}>

                              <div style={{ width: "42px", margin: "5px" }}>
                                <div style={{ textAlign: "center" }}>55</div>
                                <svg width="42" height="42" viewBox="0 0 42 42">
                                  {toothShapes.map(({ points }) => renderToothPolygon(points, "55"))}
                                </svg>
                              </div>

                              <div style={{ width: "42px", margin: "5px" }}>
                                <div style={{ textAlign: "center" }}>54</div>
                                <svg width="42" height="42" viewBox="0 0 42 42">
                                  {toothShapes.map(({ points }) => renderToothPolygon(points, "54"))}
                                </svg>
                              </div>

                              <div style={{ width: "42px", margin: "5px" }}>
                                <div style={{ textAlign: "center" }}>53</div>
                                <svg width={42} height={42}>
                                  <g>
                                    {customToothShapes["53"].map(({ points }) => renderToothPolygon(points, "53"))}
                                  </g>
                                </svg>
                              </div>

                              <div style={{ width: "42px", margin: "5px" }}>
                                <div style={{ textAlign: "center" }}>52</div>
                                <svg width={42} height={42}>
                                  <g>
                                    {customToothShapes["52"].map(({ points }) => renderToothPolygon(points, "52"))}
                                  </g>
                                </svg>
                              </div>

                              <div style={{ width: "42px", margin: "5px" }}>
                                <div style={{ textAlign: "center" }}>51</div>
                                <svg width={42} height={42}>
                                  <g>
                                    {customToothShapes["51"].map(({ points }) => renderToothPolygon(points, "51"))}
                                  </g>
                                </svg>
                              </div>
                            </div>

                            <div style={{ flex: "50%", display: "flex", justifyContent: "start", paddingLeft: "30px" }}>

                              <div style={{ width: "42px", margin: "5px" }}>
                                <div style={{ textAlign: "center" }}>61</div>
                                <svg width={42} height={42}>
                                  <g>
                                    {customToothShapes["61"].map(({ points }) => renderToothPolygon(points, "61"))}
                                  </g>
                                </svg>
                              </div>

                              <div style={{ width: "42px", margin: "5px" }}>
                                <div style={{ textAlign: "center" }}>62</div>
                                <svg width={42} height={42}>
                                  <g>
                                    {customToothShapes["62"].map(({ points }) => renderToothPolygon(points, "62"))}
                                  </g>
                                </svg>
                              </div>

                              <div style={{ width: "42px", margin: "5px" }}>
                                <div style={{ textAlign: "center" }}>63</div>
                                <svg width={42} height={42}>
                                  <g>
                                    {customToothShapes["63"].map(({ points }) => renderToothPolygon(points, "63"))}
                                  </g>
                                </svg>
                              </div>

                              <div style={{ width: "42px", margin: "5px" }}>
                                <div style={{ textAlign: "center" }}>64</div>
                                <svg width="42" height="42" viewBox="0 0 42 42">
                                  {toothShapes.map(({ points }) => renderToothPolygon(points, "64"))}
                                </svg>
                              </div>

                              <div style={{ width: "42px", margin: "5px" }}>
                                <div style={{ textAlign: "center" }}>65</div>
                                <svg width="42" height="42" viewBox="0 0 42 42">
                                  {toothShapes.map(({ points }) => renderToothPolygon(points, "65"))}
                                </svg>
                              </div>
                            </div>
                          </div>

                          {/* Gigi Bawah Anak */}
                          <div className="mt-2" style={{ display: "flex" }}>
                            <div style={{ flex: "50%", display: "flex", justifyContent: "end", paddingRight: "30px" }}>

                              <div style={{ width: "42px", margin: "5px" }}>
                                <svg width="42" height="42" viewBox="0 0 42 42">
                                  {toothShapes.map(({ points }) => renderToothPolygon(points, "85"))}
                                </svg>
                                <div style={{ textAlign: "center" }}>85</div>
                              </div>

                              <div style={{ width: "42px", margin: "5px" }}>
                                <svg width="42" height="42" viewBox="0 0 42 42">
                                  {toothShapes.map(({ points }) => renderToothPolygon(points, "84"))}
                                </svg>
                                <div style={{ textAlign: "center" }}>84</div>
                              </div>

                              <div style={{ width: "42px", margin: "5px" }}>
                                <svg width={42} height={42}>
                                  <g>
                                    {customToothShapes["83"].map(({ points }) => renderToothPolygon(points, "83"))}
                                  </g>
                                </svg>
                                <div style={{ textAlign: "center" }}>83</div>
                              </div>

                              <div style={{ width: "42px", margin: "5px" }}>
                                <svg width={42} height={42}>
                                  <g>
                                    {customToothShapes["82"].map(({ points }) => renderToothPolygon(points, "82"))}
                                  </g>
                                </svg>
                                <div style={{ textAlign: "center" }}>82</div>
                              </div>

                              <div style={{ width: "42px", margin: "5px" }}>
                                <svg width={42} height={42}>
                                  <g>
                                    {customToothShapes["81"].map(({ points }) => renderToothPolygon(points, "81"))}
                                  </g>
                                </svg>
                                <div style={{ textAlign: "center" }}>81</div>
                              </div>
                            </div>

                            <div style={{ flex: "50%", display: "flex", justifyContent: "start", paddingLeft: "30px" }}>

                              <div style={{ width: "42px", margin: "5px" }}>
                                <svg width={42} height={42}>
                                  <g>
                                    {customToothShapes["71"].map(({ points }) => renderToothPolygon(points, "71"))}
                                  </g>
                                </svg>
                                <div style={{ textAlign: "center" }}>71</div>
                              </div>

                              <div style={{ width: "42px", margin: "5px" }}>
                                <svg width={42} height={42}>
                                  <g>
                                    {customToothShapes["72"].map(({ points }) => renderToothPolygon(points, "72"))}
                                  </g>
                                </svg>
                                <div style={{ textAlign: "center" }}>72</div>
                              </div>

                              <div style={{ width: "42px", margin: "5px" }}>
                                <svg width={42} height={42}>
                                  <g>
                                    {customToothShapes["73"].map(({ points }) => renderToothPolygon(points, "73"))}
                                  </g>
                                </svg>
                                <div style={{ textAlign: "center" }}>73</div>
                              </div>

                              <div style={{ width: "42px", margin: "5px" }}>
                                <svg width="42" height="42" viewBox="0 0 42 42">
                                  {toothShapes.map(({ points }) => renderToothPolygon(points, "74"))}
                                </svg>
                                <div style={{ textAlign: "center" }}>74</div>
                              </div>

                              <div style={{ width: "42px", margin: "5px" }}>
                                <svg width="42" height="42" viewBox="0 0 42 42">
                                  {toothShapes.map(({ points }) => renderToothPolygon(points, "75"))}
                                </svg>
                                <div style={{ textAlign: "center" }}>75</div>
                              </div>

                            </div>
                          </div>

                          {/* Gigi Bawah Dewasa */}
                          <div style={{ display: "flex" }}>
                            <div style={{ flex: "50%", display: "flex", justifyContent: "end", paddingRight: "30px" }}>

                              <div style={{ width: "42px", margin: "5px" }}>
                                <svg width="42" height="42" viewBox="0 0 42 42">
                                  {toothShapes.map(({ points }) => renderToothPolygon(points, "48"))}
                                </svg>
                                <div style={{ textAlign: "center" }}>48</div>
                              </div>

                              <div style={{ width: "42px", margin: "5px" }}>
                                <svg width="42" height="42" viewBox="0 0 42 42">
                                  {toothShapes.map(({ points }) => renderToothPolygon(points, "47"))}
                                </svg>
                                <div style={{ textAlign: "center" }}>47</div>
                              </div>

                              <div style={{ width: "42px", margin: "5px" }}>
                                <svg width="42" height="42" viewBox="0 0 42 42">
                                  {toothShapes.map(({ points }) => renderToothPolygon(points, "46"))}
                                </svg>
                                <div style={{ textAlign: "center" }}>46</div>
                              </div>

                              <div style={{ width: "42px", margin: "5px" }}>
                                <svg width="42" height="42" viewBox="0 0 42 42">
                                  {toothShapes.map(({ points }) => renderToothPolygon(points, "45"))}
                                </svg>
                                <div style={{ textAlign: "center" }}>45</div>
                              </div>

                              <div style={{ width: "42px", margin: "5px" }}>
                                <svg width="42" height="42" viewBox="0 0 42 42">
                                  {toothShapes.map(({ points }) => renderToothPolygon(points, "44"))}
                                </svg>
                                <div style={{ textAlign: "center" }}>44</div>
                              </div>

                              <div style={{ width: "42px", margin: "5px" }}>
                                <svg width={42} height={42}>
                                  <g>
                                    {customToothShapes["43"].map(({ points }) => renderToothPolygon(points, "43"))}
                                  </g>
                                </svg>
                                <div style={{ textAlign: "center" }}>43</div>
                              </div>

                              <div style={{ width: "42px", margin: "5px" }}>
                                <svg width={42} height={42}>
                                  <g>
                                    {customToothShapes["42"].map(({ points }) => renderToothPolygon(points, "42"))}
                                  </g>
                                </svg>
                                <div style={{ textAlign: "center" }}>42</div>
                              </div>

                              <div style={{ width: "42px", margin: "5px" }}>
                                <svg width={42} height={42}>
                                  <g>
                                    {customToothShapes["41"].map(({ points }) => renderToothPolygon(points, "41"))}
                                  </g>
                                </svg>
                                <div style={{ textAlign: "center" }}>41</div>
                              </div>

                            </div>

                            <div style={{ flex: "50%", display: "flex", justifyContent: "start", paddingLeft: "30px" }}>

                              <div style={{ width: "42px", margin: "5px" }}>
                                <svg width={42} height={42}>
                                  <g>
                                    {customToothShapes["31"].map(({ points }) => renderToothPolygon(points, "31"))}
                                  </g>
                                </svg>
                                <div style={{ textAlign: "center" }}>31</div>
                              </div>

                              <div style={{ width: "42px", margin: "5px" }}>
                                <svg width={42} height={42}>
                                  <g>
                                    {customToothShapes["32"].map(({ points }) => renderToothPolygon(points, "32"))}
                                  </g>
                                </svg>
                                <div style={{ textAlign: "center" }}>32</div>
                              </div>

                              <div style={{ width: "42px", margin: "5px" }}>
                                <svg width={42} height={42}>
                                  <g>
                                    {customToothShapes["33"].map(({ points }) => renderToothPolygon(points, "33"))}
                                  </g>
                                </svg>
                                <div style={{ textAlign: "center" }}>33</div>
                              </div>

                              <div style={{ width: "42px", margin: "5px" }}>
                                <svg width="42" height="42" viewBox="0 0 42 42">
                                  {toothShapes.map(({ points }) => renderToothPolygon(points, "34"))}
                                </svg>
                                <div style={{ textAlign: "center" }}>34</div>
                              </div>

                              <div style={{ width: "42px", margin: "5px" }}>
                                <svg width="42" height="42" viewBox="0 0 42 42">
                                  {toothShapes.map(({ points }) => renderToothPolygon(points, "35"))}
                                </svg>
                                <div style={{ textAlign: "center" }}>35</div>
                              </div>

                              <div style={{ width: "42px", margin: "5px" }}>
                                <svg width="42" height="42" viewBox="0 0 42 42">
                                  {toothShapes.map(({ points }) => renderToothPolygon(points, "36"))}
                                </svg>
                                <div style={{ textAlign: "center" }}>36</div>
                              </div>

                              <div style={{ width: "42px", margin: "5px" }}>
                                <svg width="42" height="42" viewBox="0 0 42 42">
                                  {toothShapes.map(({ points }) => renderToothPolygon(points, "37"))}
                                </svg>
                                <div style={{ textAlign: "center" }}>37</div>
                              </div>

                              <div style={{ width: "42px", margin: "5px" }}>
                                <svg width="42" height="42" viewBox="0 0 42 42">
                                  {toothShapes.map(({ points }) => renderToothPolygon(points, "38"))}
                                </svg>
                                <div style={{ textAlign: "center" }}>38</div>
                              </div>
                            </div>

                          </div>

                        </Col>
                        :
                        <></>
                      }

                      {formchoiceGigi?.choiceGigi === "per_gigi" ?
                        <Col className="mt-2" xl='12' sm='12' style={{ padding: "0px 0px", fontSize: "12px" }} >
                          {/* Gigi Atas Dewasa */}
                          <div style={{ display: "flex" }}>
                            <div style={{ flex: "50%", display: "flex", justifyContent: "end", paddingRight: "30px" }}>
                              <div style={{ width: "42px", margin: "5px" }}>
                                <div style={{ textAlign: "center" }}>18</div>
                                <svg width={42} height={42} style={{ border: "1px solid black", borderBottom: "2px solid black" }}>
                                  <g>
                                    {bagianGigiMap.map(({ kode, points }) => {
                                      const fullKode = `18${kode}`;
                                      return (
                                        <polygon
                                          key={fullKode}
                                          data-nomor-gigi={fullKode}
                                          points={points}
                                          onClick={(e) => handlePolygonClick(e, "tooth_number")}
                                          onMouseEnter={handleMouseEnterBagianGigi}
                                          onMouseLeave={handleMouseLeaveBagianGigi}
                                          style={{ fill: getToothFillColor(fullKode), stroke: 'black' }}
                                        />
                                      );
                                    })}
                                  </g>
                                </svg>
                              </div>

                              <div style={{ width: "42px", margin: "5px" }}>
                                <div style={{ textAlign: "center" }}>17</div>
                                <svg className="" width={42} height={42} style={{ border: "1px solid black", borderBottom: "2px solid black" }}>
                                  <g>
                                    {bagianGigiMap.map(({ kode, points }) => {
                                      const fullKode = `17${kode}`;
                                      return (
                                        <polygon
                                          key={fullKode}
                                          data-nomor-gigi={fullKode}
                                          points={points}
                                          onClick={(e) => handlePolygonClick(e, "tooth_number")}
                                          onMouseEnter={handleMouseEnterBagianGigi}
                                          onMouseLeave={handleMouseLeaveBagianGigi}
                                          style={{ fill: getToothFillColor(fullKode), stroke: 'black' }}
                                        />
                                      );
                                    })}
                                  </g>
                                </svg>

                              </div>

                              <div style={{ width: "42px", margin: "5px" }}>
                                <div style={{ textAlign: "center" }}>16</div>
                                <svg className="" width={42} height={42} style={{ border: "1px solid black", borderBottom: "2px solid black" }}>
                                  <g>
                                    {bagianGigiMap.map(({ kode, points }) => {
                                      const fullKode = `16${kode}`;
                                      return (
                                        <polygon
                                          key={fullKode}
                                          data-nomor-gigi={fullKode}
                                          points={points}
                                          onClick={(e) => handlePolygonClick(e, "tooth_number")}
                                          onMouseEnter={handleMouseEnterBagianGigi}
                                          onMouseLeave={handleMouseLeaveBagianGigi}
                                          style={{ fill: getToothFillColor(fullKode), stroke: 'black' }}
                                        />
                                      );
                                    })}
                                  </g>
                                </svg>

                              </div>

                              <div style={{ width: "42px", margin: "5px" }}>
                                <div style={{ textAlign: "center" }}>15</div>
                                <svg className="" width={42} height={42} style={{ border: "1px solid black", borderBottom: "2px solid black" }}>
                                  <g>
                                    {bagianGigiMap.map(({ kode, points }) => {
                                      const fullKode = `15${kode}`;
                                      return (
                                        <polygon
                                          key={fullKode}
                                          data-nomor-gigi={fullKode}
                                          points={points}
                                          onClick={(e) => handlePolygonClick(e, "tooth_number")}
                                          onMouseEnter={handleMouseEnterBagianGigi}
                                          onMouseLeave={handleMouseLeaveBagianGigi}
                                          style={{ fill: getToothFillColor(fullKode), stroke: 'black' }}
                                        />
                                      );
                                    })}
                                  </g>
                                </svg>

                              </div>

                              <div style={{ width: "42px", margin: "5px" }}>
                                <div style={{ textAlign: "center" }}>14</div>
                                <svg className="" width={42} height={42} style={{ border: "1px solid black", borderBottom: "2px solid black" }}>
                                  <g>
                                    {bagianGigiMap.map(({ kode, points }) => {
                                      const fullKode = `14${kode}`;
                                      return (
                                        <polygon
                                          key={fullKode}
                                          data-nomor-gigi={fullKode}
                                          points={points}
                                          onClick={(e) => handlePolygonClick(e, "tooth_number")}
                                          onMouseEnter={handleMouseEnterBagianGigi}
                                          onMouseLeave={handleMouseLeaveBagianGigi}
                                          style={{ fill: getToothFillColor(fullKode), stroke: 'black' }}
                                        />
                                      );
                                    })}
                                  </g>
                                </svg>
                              </div>

                              <div style={{ width: "42px", margin: "5px" }}>
                                <div style={{ textAlign: "center" }}>13</div>
                                <svg className="" width={42} height={42} style={{ border: "1px solid black", borderBottom: "2px solid black" }}>
                                  <g>
                                    {bagianGigiMapOther.map(({ kode, points }) => {
                                      const fullKode = `13${kode}`;
                                      return (
                                        <polygon
                                          key={fullKode}
                                          data-nomor-gigi={fullKode}
                                          points={points}
                                          onClick={(e) => handlePolygonClick(e, "tooth_number")}
                                          onMouseEnter={handleMouseEnterBagianGigi}
                                          onMouseLeave={handleMouseLeaveBagianGigi}
                                          style={{ fill: getToothFillColor(fullKode), stroke: 'black' }}
                                        />
                                      );
                                    })}
                                  </g>
                                </svg>
                              </div>

                              <div style={{ width: "42px", margin: "5px" }}>
                                <div style={{ textAlign: "center" }}>12</div>

                                <svg className="" width={42} height={42} style={{ border: "1px solid black", borderBottom: "2px solid black" }}>
                                  <g>
                                    {bagianGigiMapOther.map(({ kode, points }) => {
                                      const fullKode = `12${kode}`;
                                      return (
                                        <polygon
                                          key={fullKode}
                                          data-nomor-gigi={fullKode}
                                          points={points}
                                          onClick={(e) => handlePolygonClick(e, "tooth_number")}
                                          onMouseEnter={handleMouseEnterBagianGigi}
                                          onMouseLeave={handleMouseLeaveBagianGigi}
                                          style={{ fill: getToothFillColor(fullKode), stroke: 'black' }}
                                        />
                                      );
                                    })}
                                  </g>
                                </svg>
                              </div>

                              <div style={{ width: "42px", margin: "5px" }}>
                                <div style={{ textAlign: "center" }}>11</div>

                                <svg className="" width={42} height={42} style={{ border: "1px solid black", borderBottom: "2px solid black" }}>
                                  <g>
                                    {bagianGigiMapOther.map(({ kode, points }) => {
                                      const fullKode = `11${kode}`;
                                      return (
                                        <polygon
                                          key={fullKode}
                                          data-nomor-gigi={fullKode}
                                          points={points}
                                          onClick={(e) => handlePolygonClick(e, "tooth_number")}
                                          onMouseEnter={handleMouseEnterBagianGigi}
                                          onMouseLeave={handleMouseLeaveBagianGigi}
                                          style={{ fill: getToothFillColor(fullKode), stroke: 'black' }}
                                        />
                                      );
                                    })}
                                  </g>
                                </svg>
                              </div>
                            </div>

                            <div style={{ flex: "50%", display: "flex", justifyContent: "start", paddingLeft: "30px" }}>

                              <div style={{ width: "42px", margin: "5px" }}>
                                <div style={{ textAlign: "center" }}>21</div>

                                <svg className="" width={42} height={42} style={{ border: "1px solid black", borderBottom: "2px solid black" }}>
                                  <g>
                                    {bagianGigiMapOther.map(({ kode, points }) => {
                                      const fullKode = `21${kode}`;
                                      return (
                                        <polygon
                                          key={fullKode}
                                          data-nomor-gigi={fullKode}
                                          points={points}
                                          onClick={(e) => handlePolygonClick(e, "tooth_number")}
                                          onMouseEnter={handleMouseEnterBagianGigi}
                                          onMouseLeave={handleMouseLeaveBagianGigi}
                                          style={{ fill: getToothFillColor(fullKode), stroke: 'black' }}
                                        />
                                      );
                                    })}
                                  </g>
                                </svg>
                              </div>

                              <div style={{ width: "42px", margin: "5px" }}>
                                <div style={{ textAlign: "center" }}>22</div>

                                <svg className="" width={42} height={42} style={{ border: "1px solid black", borderBottom: "2px solid black" }}>
                                  <g>
                                    {bagianGigiMapOther.map(({ kode, points }) => {
                                      const fullKode = `22${kode}`;
                                      return (
                                        <polygon
                                          key={fullKode}
                                          data-nomor-gigi={fullKode}
                                          points={points}
                                          onClick={(e) => handlePolygonClick(e, "tooth_number")}
                                          onMouseEnter={handleMouseEnterBagianGigi}
                                          onMouseLeave={handleMouseLeaveBagianGigi}
                                          style={{ fill: getToothFillColor(fullKode), stroke: 'black' }}
                                        />
                                      );
                                    })}
                                  </g>
                                </svg>
                              </div>

                              <div style={{ width: "42px", margin: "5px" }}>
                                <div style={{ textAlign: "center" }}>23</div>

                                <svg className="" width={42} height={42} style={{ border: "1px solid black", borderBottom: "2px solid black" }}>
                                  <g>
                                    {bagianGigiMapOther.map(({ kode, points }) => {
                                      const fullKode = `23${kode}`;
                                      return (
                                        <polygon
                                          key={fullKode}
                                          data-nomor-gigi={fullKode}
                                          points={points}
                                          onClick={(e) => handlePolygonClick(e, "tooth_number")}
                                          onMouseEnter={handleMouseEnterBagianGigi}
                                          onMouseLeave={handleMouseLeaveBagianGigi}
                                          style={{ fill: getToothFillColor(fullKode), stroke: 'black' }}
                                        />
                                      );
                                    })}
                                  </g>
                                </svg>
                              </div>

                              <div style={{ width: "42px", margin: "5px" }}>
                                <div style={{ textAlign: "center" }}>24</div>
                                <svg className="" width={42} height={42} style={{ border: "1px solid black", borderBottom: "2px solid black" }}>
                                  <g>
                                    {bagianGigiMap.map(({ kode, points }) => {
                                      const fullKode = `24${kode}`;
                                      return (
                                        <polygon
                                          key={fullKode}
                                          data-nomor-gigi={fullKode}
                                          points={points}
                                          onClick={(e) => handlePolygonClick(e, "tooth_number")}
                                          onMouseEnter={handleMouseEnterBagianGigi}
                                          onMouseLeave={handleMouseLeaveBagianGigi}
                                          style={{ fill: getToothFillColor(fullKode), stroke: 'black' }}
                                        />
                                      );
                                    })}
                                  </g>
                                </svg>
                              </div>

                              <div style={{ width: "42px", margin: "5px" }}>
                                <div style={{ textAlign: "center" }}>25</div>
                                <svg className="" width={42} height={42} style={{ border: "1px solid black", borderBottom: "2px solid black" }}>
                                  <g>
                                    {bagianGigiMap.map(({ kode, points }) => {
                                      const fullKode = `25${kode}`;
                                      return (
                                        <polygon
                                          key={fullKode}
                                          data-nomor-gigi={fullKode}
                                          points={points}
                                          onClick={(e) => handlePolygonClick(e, "tooth_number")}
                                          onMouseEnter={handleMouseEnterBagianGigi}
                                          onMouseLeave={handleMouseLeaveBagianGigi}
                                          style={{ fill: getToothFillColor(fullKode), stroke: 'black' }}
                                        />
                                      );
                                    })}
                                  </g>
                                </svg>
                              </div>

                              <div style={{ width: "42px", margin: "5px" }}>
                                <div style={{ textAlign: "center" }}>26</div>
                                <svg className="" width={42} height={42} style={{ border: "1px solid black", borderBottom: "2px solid black" }}>
                                  <g>
                                    {bagianGigiMap.map(({ kode, points }) => {
                                      const fullKode = `26${kode}`;
                                      return (
                                        <polygon
                                          key={fullKode}
                                          data-nomor-gigi={fullKode}
                                          points={points}
                                          onClick={(e) => handlePolygonClick(e, "tooth_number")}
                                          onMouseEnter={handleMouseEnterBagianGigi}
                                          onMouseLeave={handleMouseLeaveBagianGigi}
                                          style={{ fill: getToothFillColor(fullKode), stroke: 'black' }}
                                        />
                                      );
                                    })}
                                  </g>
                                </svg>

                              </div>

                              <div style={{ width: "42px", margin: "5px" }}>
                                <div style={{ textAlign: "center" }}>27</div>
                                <svg className="" width={42} height={42} style={{ border: "1px solid black", borderBottom: "2px solid black" }}>
                                  <g>
                                    {bagianGigiMap.map(({ kode, points }) => {
                                      const fullKode = `27${kode}`;
                                      return (
                                        <polygon
                                          key={fullKode}
                                          data-nomor-gigi={fullKode}
                                          points={points}
                                          onClick={(e) => handlePolygonClick(e, "tooth_number")}
                                          onMouseEnter={handleMouseEnterBagianGigi}
                                          onMouseLeave={handleMouseLeaveBagianGigi}
                                          style={{ fill: getToothFillColor(fullKode), stroke: 'black' }}
                                        />
                                      );
                                    })}
                                  </g>
                                </svg>

                              </div>

                              <div style={{ width: "42px", margin: "5px" }}>
                                <div style={{ textAlign: "center" }}>28</div>
                                <svg className="" width={42} height={42} style={{ border: "1px solid black", borderBottom: "2px solid black" }}>
                                  <g>
                                    {bagianGigiMap.map(({ kode, points }) => {
                                      const fullKode = `28${kode}`;
                                      return (
                                        <polygon
                                          key={fullKode}
                                          data-nomor-gigi={fullKode}
                                          points={points}
                                          onClick={(e) => handlePolygonClick(e, "tooth_number")}
                                          onMouseEnter={handleMouseEnterBagianGigi}
                                          onMouseLeave={handleMouseLeaveBagianGigi}
                                          style={{ fill: getToothFillColor(fullKode), stroke: 'black' }}
                                        />
                                      );
                                    })}
                                  </g>
                                </svg>

                              </div>


                            </div>
                          </div>

                          {/* Gigi Atas Anak */}
                          <div style={{ display: "flex" }}>
                            <div style={{ flex: "50%", display: "flex", justifyContent: "end", paddingRight: "30px" }}>

                              <div style={{ width: "42px", margin: "5px" }}>
                                <div style={{ textAlign: "center" }}>55</div>
                                <svg className="" width={42} height={42} style={{ border: "1px solid black", borderBottom: "2px solid black" }}>
                                  <g>
                                    {bagianGigiMap.map(({ kode, points }) => {
                                      const fullKode = `55${kode}`;
                                      return (
                                        <polygon
                                          key={fullKode}
                                          data-nomor-gigi={fullKode}
                                          points={points}
                                          onClick={(e) => handlePolygonClick(e, "tooth_number")}
                                          onMouseEnter={handleMouseEnterBagianGigi}
                                          onMouseLeave={handleMouseLeaveBagianGigi}
                                          style={{ fill: getToothFillColor(fullKode), stroke: 'black' }}
                                        />
                                      );
                                    })}
                                  </g>
                                </svg>

                              </div>

                              <div style={{ width: "42px", margin: "5px" }}>
                                <div style={{ textAlign: "center" }}>54</div>
                                <svg className="" width={42} height={42} style={{ border: "1px solid black", borderBottom: "2px solid black" }}>
                                  <g>
                                    {bagianGigiMap.map(({ kode, points }) => {
                                      const fullKode = `54${kode}`;
                                      return (
                                        <polygon
                                          key={fullKode}
                                          data-nomor-gigi={fullKode}
                                          points={points}
                                          onClick={(e) => handlePolygonClick(e, "tooth_number")}
                                          onMouseEnter={handleMouseEnterBagianGigi}
                                          onMouseLeave={handleMouseLeaveBagianGigi}
                                          style={{ fill: getToothFillColor(fullKode), stroke: 'black' }}
                                        />
                                      );
                                    })}
                                  </g>
                                </svg>
                              </div>

                              <div style={{ width: "42px", margin: "5px" }}>
                                <div style={{ textAlign: "center" }}>53</div>

                                <svg className="" width={42} height={42} style={{ border: "1px solid black", borderBottom: "2px solid black" }}>
                                  <g>
                                    {bagianGigiMapOther.map(({ kode, points }) => {
                                      const fullKode = `53${kode}`;
                                      return (
                                        <polygon
                                          key={fullKode}
                                          data-nomor-gigi={fullKode}
                                          points={points}
                                          onClick={(e) => handlePolygonClick(e, "tooth_number")}
                                          onMouseEnter={handleMouseEnterBagianGigi}
                                          onMouseLeave={handleMouseLeaveBagianGigi}
                                          style={{ fill: getToothFillColor(fullKode), stroke: 'black' }}
                                        />
                                      );
                                    })}
                                  </g>
                                </svg>
                              </div>

                              <div style={{ width: "42px", margin: "5px" }}>
                                <div style={{ textAlign: "center" }}>52</div>
                                <svg className="" width={42} height={42} style={{ border: "1px solid black", borderBottom: "2px solid black" }}>
                                  <g>
                                    {bagianGigiMapOther.map(({ kode, points }) => {
                                      const fullKode = `52${kode}`;
                                      return (
                                        <polygon
                                          key={fullKode}
                                          data-nomor-gigi={fullKode}
                                          points={points}
                                          onClick={(e) => handlePolygonClick(e, "tooth_number")}
                                          onMouseEnter={handleMouseEnterBagianGigi}
                                          onMouseLeave={handleMouseLeaveBagianGigi}
                                          style={{ fill: getToothFillColor(fullKode), stroke: 'black' }}
                                        />
                                      );
                                    })}
                                  </g>
                                </svg>
                              </div>

                              <div style={{ width: "42px", margin: "5px" }}>
                                <div style={{ textAlign: "center" }}>51</div>

                                <svg className="" width={42} height={42} style={{ border: "1px solid black", borderBottom: "2px solid black" }}>
                                  <g>
                                    {bagianGigiMapOther.map(({ kode, points }) => {
                                      const fullKode = `51${kode}`;
                                      return (
                                        <polygon
                                          key={fullKode}
                                          data-nomor-gigi={fullKode}
                                          points={points}
                                          onClick={(e) => handlePolygonClick(e, "tooth_number")}
                                          onMouseEnter={handleMouseEnterBagianGigi}
                                          onMouseLeave={handleMouseLeaveBagianGigi}
                                          style={{ fill: getToothFillColor(fullKode), stroke: 'black' }}
                                        />
                                      );
                                    })}
                                  </g>
                                </svg>
                              </div>
                            </div>

                            <div style={{ flex: "50%", display: "flex", justifyContent: "start", paddingLeft: "30px" }}>

                              <div style={{ width: "42px", margin: "5px" }}>
                                <div style={{ textAlign: "center" }}>61</div>

                                <svg className="" width={42} height={42} style={{ border: "1px solid black", borderBottom: "2px solid black" }}>
                                  <g>
                                    {bagianGigiMapOther.map(({ kode, points }) => {
                                      const fullKode = `61${kode}`;
                                      return (
                                        <polygon
                                          key={fullKode}
                                          data-nomor-gigi={fullKode}
                                          points={points}
                                          onClick={(e) => handlePolygonClick(e, "tooth_number")}
                                          onMouseEnter={handleMouseEnterBagianGigi}
                                          onMouseLeave={handleMouseLeaveBagianGigi}
                                          style={{ fill: getToothFillColor(fullKode), stroke: 'black' }}
                                        />
                                      );
                                    })}
                                  </g>
                                </svg>
                              </div>

                              <div style={{ width: "42px", margin: "5px" }}>
                                <div style={{ textAlign: "center" }}>62</div>

                                <svg className="" width={42} height={42} style={{ border: "1px solid black", borderBottom: "2px solid black" }}>
                                  <g>
                                    {bagianGigiMapOther.map(({ kode, points }) => {
                                      const fullKode = `62${kode}`;
                                      return (
                                        <polygon
                                          key={fullKode}
                                          data-nomor-gigi={fullKode}
                                          points={points}
                                          onClick={(e) => handlePolygonClick(e, "tooth_number")}
                                          onMouseEnter={handleMouseEnterBagianGigi}
                                          onMouseLeave={handleMouseLeaveBagianGigi}
                                          style={{ fill: getToothFillColor(fullKode), stroke: 'black' }}
                                        />
                                      );
                                    })}
                                  </g>
                                </svg>
                              </div>

                              <div style={{ width: "42px", margin: "5px" }}>
                                <div style={{ textAlign: "center" }}>63</div>

                                <svg className="" width={42} height={42} style={{ border: "1px solid black", borderBottom: "2px solid black" }}>
                                  <g>
                                    {bagianGigiMapOther.map(({ kode, points }) => {
                                      const fullKode = `63${kode}`;
                                      return (
                                        <polygon
                                          key={fullKode}
                                          data-nomor-gigi={fullKode}
                                          points={points}
                                          onClick={(e) => handlePolygonClick(e, "tooth_number")}
                                          onMouseEnter={handleMouseEnterBagianGigi}
                                          onMouseLeave={handleMouseLeaveBagianGigi}
                                          style={{ fill: getToothFillColor(fullKode), stroke: 'black' }}
                                        />
                                      );
                                    })}
                                  </g>
                                </svg>
                              </div>

                              <div style={{ width: "42px", margin: "5px" }}>
                                <div style={{ textAlign: "center" }}>64</div>
                                <svg className="" width={42} height={42} style={{ border: "1px solid black", borderBottom: "2px solid black" }}>
                                  <g>
                                    {bagianGigiMap.map(({ kode, points }) => {
                                      const fullKode = `64${kode}`;
                                      return (
                                        <polygon
                                          key={fullKode}
                                          data-nomor-gigi={fullKode}
                                          points={points}
                                          onClick={(e) => handlePolygonClick(e, "tooth_number")}
                                          onMouseEnter={handleMouseEnterBagianGigi}
                                          onMouseLeave={handleMouseLeaveBagianGigi}
                                          style={{ fill: getToothFillColor(fullKode), stroke: 'black' }}
                                        />
                                      );
                                    })}
                                  </g>
                                </svg>
                              </div>

                              <div style={{ width: "42px", margin: "5px" }}>
                                <div style={{ textAlign: "center" }}>65</div>
                                <svg className="" width={42} height={42} style={{ border: "1px solid black", borderBottom: "2px solid black" }}>
                                  <g>
                                    {bagianGigiMap.map(({ kode, points }) => {
                                      const fullKode = `65${kode}`;
                                      return (
                                        <polygon
                                          key={fullKode}
                                          data-nomor-gigi={fullKode}
                                          points={points}
                                          onClick={(e) => handlePolygonClick(e, "tooth_number")}
                                          onMouseEnter={handleMouseEnterBagianGigi}
                                          onMouseLeave={handleMouseLeaveBagianGigi}
                                          style={{ fill: getToothFillColor(fullKode), stroke: 'black' }}
                                        />
                                      );
                                    })}
                                  </g>
                                </svg>
                              </div>

                            </div>
                          </div>

                          {/* Gigi Bawah Anak */}
                          <div className="mt-2" style={{ display: "flex" }}>
                            <div style={{ flex: "50%", display: "flex", justifyContent: "end", paddingRight: "30px" }}>
                              <div style={{ width: "42px", margin: "5px" }}>
                                <svg className="" width={42} height={42} style={{ border: "1px solid black", borderBottom: "2px solid black" }}>
                                  <g>
                                    {bagianGigiMap.map(({ kode, points }) => {
                                      const fullKode = `85${kode}`;
                                      return (
                                        <polygon
                                          key={fullKode}
                                          data-nomor-gigi={fullKode}
                                          points={points}
                                          onClick={(e) => handlePolygonClick(e, "tooth_number")}
                                          onMouseEnter={handleMouseEnterBagianGigi}
                                          onMouseLeave={handleMouseLeaveBagianGigi}
                                          style={{ fill: getToothFillColor(fullKode), stroke: 'black' }}
                                        />
                                      );
                                    })}
                                  </g>
                                </svg>
                                <div style={{ textAlign: "center" }}>85</div>

                              </div>

                              <div style={{ width: "42px", margin: "5px" }}>
                                <svg className="" width={42} height={42} style={{ border: "1px solid black", borderBottom: "2px solid black" }}>
                                  <g>
                                    {bagianGigiMap.map(({ kode, points }) => {
                                      const fullKode = `84${kode}`;
                                      return (
                                        <polygon
                                          key={fullKode}
                                          data-nomor-gigi={fullKode}
                                          points={points}
                                          onClick={(e) => handlePolygonClick(e, "tooth_number")}
                                          onMouseEnter={handleMouseEnterBagianGigi}
                                          onMouseLeave={handleMouseLeaveBagianGigi}
                                          style={{ fill: getToothFillColor(fullKode), stroke: 'black' }}
                                        />
                                      );
                                    })}
                                  </g>
                                </svg>
                                <div style={{ textAlign: "center" }}>84</div>

                              </div>

                              <div style={{ width: "42px", margin: "5px" }}>
                                <svg className="" width={42} height={42} style={{ border: "1px solid black", borderBottom: "2px solid black" }}>
                                  <g>
                                    {bagianGigiMapOther.map(({ kode, points }) => {
                                      const fullKode = `83${kode}`;
                                      return (
                                        <polygon
                                          key={fullKode}
                                          data-nomor-gigi={fullKode}
                                          points={points}
                                          onClick={(e) => handlePolygonClick(e, "tooth_number")}
                                          onMouseEnter={handleMouseEnterBagianGigi}
                                          onMouseLeave={handleMouseLeaveBagianGigi}
                                          style={{ fill: getToothFillColor(fullKode), stroke: 'black' }}
                                        />
                                      );
                                    })}
                                  </g>
                                </svg>
                                <div style={{ textAlign: "center" }}>83</div>
                              </div>

                              <div style={{ width: "42px", margin: "5px" }}>
                                <svg className="" width={42} height={42} style={{ border: "1px solid black", borderBottom: "2px solid black" }}>
                                  <g>
                                    {bagianGigiMapOther.map(({ kode, points }) => {
                                      const fullKode = `82${kode}`;
                                      return (
                                        <polygon
                                          key={fullKode}
                                          data-nomor-gigi={fullKode}
                                          points={points}
                                          onClick={(e) => handlePolygonClick(e, "tooth_number")}
                                          onMouseEnter={handleMouseEnterBagianGigi}
                                          onMouseLeave={handleMouseLeaveBagianGigi}
                                          style={{ fill: getToothFillColor(fullKode), stroke: 'black' }}
                                        />
                                      );
                                    })}
                                  </g>
                                </svg>
                                <div style={{ textAlign: "center" }}>82</div>

                              </div>

                              <div style={{ width: "42px", margin: "5px" }}>
                                <svg className="" width={42} height={42} style={{ border: "1px solid black", borderBottom: "2px solid black" }}>
                                  <g>
                                    {bagianGigiMapOther.map(({ kode, points }) => {
                                      const fullKode = `81${kode}`;
                                      return (
                                        <polygon
                                          key={fullKode}
                                          data-nomor-gigi={fullKode}
                                          points={points}
                                          onClick={(e) => handlePolygonClick(e, "tooth_number")}
                                          onMouseEnter={handleMouseEnterBagianGigi}
                                          onMouseLeave={handleMouseLeaveBagianGigi}
                                          style={{ fill: getToothFillColor(fullKode), stroke: 'black' }}
                                        />
                                      );
                                    })}
                                  </g>
                                </svg>
                                <div style={{ textAlign: "center" }}>81</div>
                              </div>
                            </div>

                            <div style={{ flex: "50%", display: "flex", justifyContent: "start", paddingLeft: "30px" }}>

                              <div style={{ width: "42px", margin: "5px" }}>

                                <svg className="" width={42} height={42} style={{ border: "1px solid black", borderBottom: "2px solid black" }}>
                                  <g>
                                    {bagianGigiMapOther.map(({ kode, points }) => {
                                      const fullKode = `71${kode}`;
                                      return (
                                        <polygon
                                          key={fullKode}
                                          data-nomor-gigi={fullKode}
                                          points={points}
                                          onClick={(e) => handlePolygonClick(e, "tooth_number")}
                                          onMouseEnter={handleMouseEnterBagianGigi}
                                          onMouseLeave={handleMouseLeaveBagianGigi}
                                          style={{ fill: getToothFillColor(fullKode), stroke: 'black' }}
                                        />
                                      );
                                    })}
                                  </g>
                                </svg>
                                <div style={{ textAlign: "center" }}>71</div>
                              </div>

                              <div style={{ width: "42px", margin: "5px" }}>
                                <svg className="" width={42} height={42} style={{ border: "1px solid black", borderBottom: "2px solid black" }}>
                                  <g>
                                    {bagianGigiMapOther.map(({ kode, points }) => {
                                      const fullKode = `72${kode}`;
                                      return (
                                        <polygon
                                          key={fullKode}
                                          data-nomor-gigi={fullKode}
                                          points={points}
                                          onClick={(e) => handlePolygonClick(e, "tooth_number")}
                                          onMouseEnter={handleMouseEnterBagianGigi}
                                          onMouseLeave={handleMouseLeaveBagianGigi}
                                          style={{ fill: getToothFillColor(fullKode), stroke: 'black' }}
                                        />
                                      );
                                    })}
                                  </g>
                                </svg>
                                <div style={{ textAlign: "center" }}>72</div>

                              </div>

                              <div style={{ width: "42px", margin: "5px" }}>
                                <svg className="" width={42} height={42} style={{ border: "1px solid black", borderBottom: "2px solid black" }}>

                                  <g>
                                    {bagianGigiMapOther.map(({ kode, points }) => {
                                      const fullKode = `73${kode}`;
                                      return (
                                        <polygon
                                          key={fullKode}
                                          data-nomor-gigi={fullKode}
                                          points={points}
                                          onClick={(e) => handlePolygonClick(e, "tooth_number")}
                                          onMouseEnter={handleMouseEnterBagianGigi}
                                          onMouseLeave={handleMouseLeaveBagianGigi}
                                          style={{ fill: getToothFillColor(fullKode), stroke: 'black' }}
                                        />
                                      );
                                    })}
                                  </g>
                                </svg>
                                <div style={{ textAlign: "center" }}>73</div>
                              </div>

                              <div style={{ width: "42px", margin: "5px" }}>
                                <svg className="" width={42} height={42} style={{ border: "1px solid black", borderBottom: "2px solid black" }}>
                                  <g>
                                    {bagianGigiMap.map(({ kode, points }) => {
                                      const fullKode = `74${kode}`;
                                      return (
                                        <polygon
                                          key={fullKode}
                                          data-nomor-gigi={fullKode}
                                          points={points}
                                          onClick={(e) => handlePolygonClick(e, "tooth_number")}
                                          onMouseEnter={handleMouseEnterBagianGigi}
                                          onMouseLeave={handleMouseLeaveBagianGigi}
                                          style={{ fill: getToothFillColor(fullKode), stroke: 'black' }}
                                        />
                                      );
                                    })}
                                  </g>
                                </svg>
                                <div style={{ textAlign: "center" }}>74</div>

                              </div>

                              <div style={{ width: "42px", margin: "5px" }}>
                                <svg className="" width={42} height={42} style={{ border: "1px solid black", borderBottom: "2px solid black" }}>
                                  <g>
                                    {bagianGigiMap.map(({ kode, points }) => {
                                      const fullKode = `75${kode}`;
                                      return (
                                        <polygon
                                          key={fullKode}
                                          data-nomor-gigi={fullKode}
                                          points={points}
                                          onClick={(e) => handlePolygonClick(e, "tooth_number")}
                                          onMouseEnter={handleMouseEnterBagianGigi}
                                          onMouseLeave={handleMouseLeaveBagianGigi}
                                          style={{ fill: getToothFillColor(fullKode), stroke: 'black' }}
                                        />
                                      );
                                    })}
                                  </g>
                                </svg>
                                <div style={{ textAlign: "center" }}>75</div>

                              </div>

                            </div>
                          </div>

                          {/* Gigi Bawah Dewasa */}
                          <div style={{ display: "flex" }}>
                            <div style={{ flex: "50%", display: "flex", justifyContent: "end", paddingRight: "30px" }}>

                              <div style={{ width: "42px", margin: "5px" }}>
                                <svg className="" width={42} height={42} style={{ border: "1px solid black", borderBottom: "2px solid black" }}>
                                  <g>
                                    {bagianGigiMap.map(({ kode, points }) => {
                                      const fullKode = `48${kode}`;
                                      return (
                                        <polygon
                                          key={fullKode}
                                          data-nomor-gigi={fullKode}
                                          points={points}
                                          onClick={(e) => handlePolygonClick(e, "tooth_number")}
                                          onMouseEnter={handleMouseEnterBagianGigi}
                                          onMouseLeave={handleMouseLeaveBagianGigi}
                                          style={{ fill: getToothFillColor(fullKode), stroke: 'black' }}
                                        />
                                      );
                                    })}
                                  </g>
                                </svg>
                                <div style={{ textAlign: "center" }}>48</div>

                              </div>

                              <div style={{ width: "42px", margin: "5px" }}>
                                <svg className="" width={42} height={42} style={{ border: "1px solid black", borderBottom: "2px solid black" }}>
                                  <g>
                                    {bagianGigiMap.map(({ kode, points }) => {
                                      const fullKode = `47${kode}`;
                                      return (
                                        <polygon
                                          key={fullKode}
                                          data-nomor-gigi={fullKode}
                                          points={points}
                                          onClick={(e) => handlePolygonClick(e, "tooth_number")}
                                          onMouseEnter={handleMouseEnterBagianGigi}
                                          onMouseLeave={handleMouseLeaveBagianGigi}
                                          style={{ fill: getToothFillColor(fullKode), stroke: 'black' }}
                                        />
                                      );
                                    })}
                                  </g>
                                </svg>
                                <div style={{ textAlign: "center" }}>47</div>

                              </div>

                              <div style={{ width: "42px", margin: "5px" }}>
                                <svg className="" width={42} height={42} style={{ border: "1px solid black", borderBottom: "2px solid black" }}>
                                  <g>
                                    {bagianGigiMap.map(({ kode, points }) => {
                                      const fullKode = `46${kode}`;
                                      return (
                                        <polygon
                                          key={fullKode}
                                          data-nomor-gigi={fullKode}
                                          points={points}
                                          onClick={(e) => handlePolygonClick(e, "tooth_number")}
                                          onMouseEnter={handleMouseEnterBagianGigi}
                                          onMouseLeave={handleMouseLeaveBagianGigi}
                                          style={{ fill: getToothFillColor(fullKode), stroke: 'black' }}
                                        />
                                      );
                                    })}
                                  </g>
                                </svg>
                                <div style={{ textAlign: "center" }}>46</div>

                              </div>

                              <div style={{ width: "42px", margin: "5px" }}>
                                <svg className="" width={42} height={42} style={{ border: "1px solid black", borderBottom: "2px solid black" }}>
                                  <g>
                                    {bagianGigiMap.map(({ kode, points }) => {
                                      const fullKode = `45${kode}`;
                                      return (
                                        <polygon
                                          key={fullKode}
                                          data-nomor-gigi={fullKode}
                                          points={points}
                                          onClick={(e) => handlePolygonClick(e, "tooth_number")}
                                          onMouseEnter={handleMouseEnterBagianGigi}
                                          onMouseLeave={handleMouseLeaveBagianGigi}
                                          style={{ fill: getToothFillColor(fullKode), stroke: 'black' }}
                                        />
                                      );
                                    })}
                                  </g>
                                </svg>
                                <div style={{ textAlign: "center" }}>45</div>

                              </div>

                              <div style={{ width: "42px", margin: "5px" }}>
                                <svg className="" width={42} height={42} style={{ border: "1px solid black", borderBottom: "2px solid black" }}>
                                  <g>
                                    {bagianGigiMap.map(({ kode, points }) => {
                                      const fullKode = `44${kode}`;
                                      return (
                                        <polygon
                                          key={fullKode}
                                          data-nomor-gigi={fullKode}
                                          points={points}
                                          onClick={(e) => handlePolygonClick(e, "tooth_number")}
                                          onMouseEnter={handleMouseEnterBagianGigi}
                                          onMouseLeave={handleMouseLeaveBagianGigi}
                                          style={{ fill: getToothFillColor(fullKode), stroke: 'black' }}
                                        />
                                      );
                                    })}
                                  </g>
                                </svg>
                                <div style={{ textAlign: "center" }}>44</div>

                              </div>

                              <div style={{ width: "42px", margin: "5px" }}>

                                <svg className="" width={42} height={42} style={{ border: "1px solid black", borderBottom: "2px solid black" }}>
                                  <g>
                                    {bagianGigiMapOther.map(({ kode, points }) => {
                                      const fullKode = `43${kode}`;
                                      return (
                                        <polygon
                                          key={fullKode}
                                          data-nomor-gigi={fullKode}
                                          points={points}
                                          onClick={(e) => handlePolygonClick(e, "tooth_number")}
                                          onMouseEnter={handleMouseEnterBagianGigi}
                                          onMouseLeave={handleMouseLeaveBagianGigi}
                                          style={{ fill: getToothFillColor(fullKode), stroke: 'black' }}
                                        />
                                      );
                                    })}
                                  </g>
                                </svg>
                                <div style={{ textAlign: "center" }}>43</div>

                              </div>

                              <div style={{ width: "42px", margin: "5px" }}>

                                <svg className="" width={42} height={42} style={{ border: "1px solid black", borderBottom: "2px solid black" }}>
                                  <g>
                                    {bagianGigiMapOther.map(({ kode, points }) => {
                                      const fullKode = `42${kode}`;
                                      return (
                                        <polygon
                                          key={fullKode}
                                          data-nomor-gigi={fullKode}
                                          points={points}
                                          onClick={(e) => handlePolygonClick(e, "tooth_number")}
                                          onMouseEnter={handleMouseEnterBagianGigi}
                                          onMouseLeave={handleMouseLeaveBagianGigi}
                                          style={{ fill: getToothFillColor(fullKode), stroke: 'black' }}
                                        />
                                      );
                                    })}
                                  </g>
                                </svg>
                                <div style={{ textAlign: "center" }}>42</div>

                              </div>

                              <div style={{ width: "42px", margin: "5px" }}>

                                <svg className="" width={42} height={42} style={{ border: "1px solid black", borderBottom: "2px solid black" }}>
                                  <g>
                                    {bagianGigiMapOther.map(({ kode, points }) => {
                                      const fullKode = `41${kode}`;
                                      return (
                                        <polygon
                                          key={fullKode}
                                          data-nomor-gigi={fullKode}
                                          points={points}
                                          onClick={(e) => handlePolygonClick(e, "tooth_number")}
                                          onMouseEnter={handleMouseEnterBagianGigi}
                                          onMouseLeave={handleMouseLeaveBagianGigi}
                                          style={{ fill: getToothFillColor(fullKode), stroke: 'black' }}
                                        />
                                      );
                                    })}
                                  </g>
                                </svg>
                                <div style={{ textAlign: "center" }}>41</div>

                              </div>
                            </div>

                            <div style={{ flex: "50%", display: "flex", justifyContent: "start", paddingLeft: "30px" }}>

                              <div style={{ width: "42px", margin: "5px" }}>
                                <svg className="" width={42} height={42} style={{ border: "1px solid black", borderBottom: "2px solid black" }}>
                                  <g>
                                    {bagianGigiMapOther.map(({ kode, points }) => {
                                      const fullKode = `31${kode}`;
                                      return (
                                        <polygon
                                          key={fullKode}
                                          data-nomor-gigi={fullKode}
                                          points={points}
                                          onClick={(e) => handlePolygonClick(e, "tooth_number")}
                                          onMouseEnter={handleMouseEnterBagianGigi}
                                          onMouseLeave={handleMouseLeaveBagianGigi}
                                          style={{ fill: getToothFillColor(fullKode), stroke: 'black' }}
                                        />
                                      );
                                    })}
                                  </g>
                                </svg>
                                <div style={{ textAlign: "center" }}>31</div>

                              </div>

                              <div style={{ width: "42px", margin: "5px" }}>
                                <svg className="" width={42} height={42} style={{ border: "1px solid black", borderBottom: "2px solid black" }}>
                                  <g>
                                    {bagianGigiMapOther.map(({ kode, points }) => {
                                      const fullKode = `32${kode}`;
                                      return (
                                        <polygon
                                          key={fullKode}
                                          data-nomor-gigi={fullKode}
                                          points={points}
                                          onClick={(e) => handlePolygonClick(e, "tooth_number")}
                                          onMouseEnter={handleMouseEnterBagianGigi}
                                          onMouseLeave={handleMouseLeaveBagianGigi}
                                          style={{ fill: getToothFillColor(fullKode), stroke: 'black' }}
                                        />
                                      );
                                    })}
                                  </g>
                                </svg>
                                <div style={{ textAlign: "center" }}>32</div>

                              </div>

                              <div style={{ width: "42px", margin: "5px" }}>
                                <svg className="" width={42} height={42} style={{ border: "1px solid black", borderBottom: "2px solid black" }}>
                                  <g>
                                    {bagianGigiMapOther.map(({ kode, points }) => {
                                      const fullKode = `33${kode}`;
                                      return (
                                        <polygon
                                          key={fullKode}
                                          data-nomor-gigi={fullKode}
                                          points={points}
                                          onClick={(e) => handlePolygonClick(e, "tooth_number")}
                                          onMouseEnter={handleMouseEnterBagianGigi}
                                          onMouseLeave={handleMouseLeaveBagianGigi}
                                          style={{ fill: getToothFillColor(fullKode), stroke: 'black' }}
                                        />
                                      );
                                    })}
                                  </g>
                                </svg>
                                <div style={{ textAlign: "center" }}>33</div>

                              </div>

                              <div style={{ width: "42px", margin: "5px" }}>
                                <svg className="" width={42} height={42} style={{ border: "1px solid black", borderBottom: "2px solid black" }}>
                                  <g>
                                    {bagianGigiMap.map(({ kode, points }) => {
                                      const fullKode = `34${kode}`;
                                      return (
                                        <polygon
                                          key={fullKode}
                                          data-nomor-gigi={fullKode}
                                          points={points}
                                          onClick={(e) => handlePolygonClick(e, "tooth_number")}
                                          onMouseEnter={handleMouseEnterBagianGigi}
                                          onMouseLeave={handleMouseLeaveBagianGigi}
                                          style={{ fill: getToothFillColor(fullKode), stroke: 'black' }}
                                        />
                                      );
                                    })}
                                  </g>
                                </svg>
                                <div style={{ textAlign: "center" }}>34</div>

                              </div>

                              <div style={{ width: "42px", margin: "5px" }}>

                                <svg width={42} height={42} style={{ border: "1px solid black", borderBottom: "2px solid black" }}>
                                  <g>
                                    {bagianGigiMap.map(({ kode, points }) => {
                                      const fullKode = `35${kode}`;
                                      return (
                                        <polygon
                                          key={fullKode}
                                          data-nomor-gigi={fullKode}
                                          points={points}
                                          onClick={(e) => handlePolygonClick(e, "tooth_number")}
                                          onMouseEnter={handleMouseEnterBagianGigi}
                                          onMouseLeave={handleMouseLeaveBagianGigi}
                                          style={{ fill: getToothFillColor(fullKode), stroke: 'black' }}
                                        />
                                      );
                                    })}
                                  </g>
                                </svg>
                                <div style={{ textAlign: "center" }}>35</div>

                              </div>


                              <div style={{ width: "42px", margin: "5px" }}>

                                <svg width={42} height={42} style={{ border: "1px solid black", borderBottom: "2px solid black" }}>
                                  <g>
                                    {bagianGigiMap.map(({ kode, points }) => {
                                      const fullKode = `36${kode}`;
                                      return (
                                        <polygon
                                          key={fullKode}
                                          data-nomor-gigi={fullKode}
                                          points={points}
                                          onClick={(e) => handlePolygonClick(e, "tooth_number")}
                                          onMouseEnter={handleMouseEnterBagianGigi}
                                          onMouseLeave={handleMouseLeaveBagianGigi}
                                          style={{ fill: getToothFillColor(fullKode), stroke: 'black' }}
                                        />
                                      );
                                    })}
                                  </g>
                                </svg>
                                <div style={{ textAlign: "center" }}>36</div>
                              </div>
                              <div style={{ width: "42px", margin: "5px" }}>
                                <svg width={42} height={42} style={{ border: "1px solid black", borderBottom: "2px solid black" }}>
                                  <g>
                                    {bagianGigiMap.map(({ kode, points }) => {
                                      const fullKode = `37${kode}`;
                                      return (
                                        <polygon
                                          key={fullKode}
                                          data-nomor-gigi={fullKode}
                                          points={points}
                                          onClick={(e) => handlePolygonClick(e, "tooth_number")}
                                          onMouseEnter={handleMouseEnterBagianGigi}
                                          onMouseLeave={handleMouseLeaveBagianGigi}
                                          style={{ fill: getToothFillColor(fullKode), stroke: 'black' }}
                                        />
                                      );
                                    })}
                                  </g>
                                </svg>
                                <div style={{ textAlign: "center" }}>37</div>
                              </div>


                              <div style={{ width: "42px", margin: "5px" }}>

                                <svg width={42} height={42} style={{ border: "1px solid black", borderBottom: "2px solid black" }}>
                                  <g>
                                    {bagianGigiMap.map(({ kode, points }) => {
                                      const fullKode = `38${kode}`;
                                      return (
                                        <polygon
                                          key={fullKode}
                                          data-nomor-gigi={fullKode}
                                          points={points}
                                          onClick={(e) => handlePolygonClick(e, "tooth_number")}
                                          onMouseEnter={handleMouseEnterBagianGigi}
                                          onMouseLeave={handleMouseLeaveBagianGigi}
                                          style={{ fill: getToothFillColor(fullKode), stroke: 'black' }}
                                        />
                                      );
                                    })}
                                  </g>
                                </svg>
                                <div style={{ textAlign: "center" }}>38</div>
                              </div>
                            </div>
                          </div>
                        </Col>
                        :
                        <></>
                      }
                    </>

                    : (
                      <>
                        {activeIndex === "kalkulus" && (
                          <OdontogramKalkulusIndex
                            formchoiceGigi={formchoiceGigi}
                            toothShapes={toothShapes}
                            customToothShapes={customToothShapes}
                            renderToothPolygonKalkulusIndex={renderToothPolygonKalkulusIndex}
                            onDataChange={handleChildDataKalkulus}
                            setKalkulusPerTooth={setKalkulusPerTooth}
                            onChangeKalkulusPerTooth={setKalkulusPerTooth}
                            toothPosition={(pos) => setPositionTooth(pos)}
                            onKalkulusChange={(data, nomor) => {
                              if (!nomor) return;

                              const kalkulusArray = Array.isArray(data[nomor]) ? data[nomor] : [];

                              const kalkulusNames = kalkulusArray
                                .filter((d) => d && d.display_name)
                                .map((d) => d.display_name)
                                .join(", ");

                              setKalkulusIndexGigi(kalkulusNames || "Belum ada data");
                            }}
                          />
                        )}

                        {activeIndex === "debris" && (
                          <OdontogramDebrisIndex
                            formchoiceGigi={formchoiceGigi}
                            toothShapes={toothShapes}
                            customToothShapes={customToothShapes}
                            renderToothPolygonDebrisIndex={renderToothPolygonDebrisIndex}
                            onDataChange={handleChildData}
                            setDebrisPerTooth={setDebrisPerTooth}
                            onChangeDebrisPerTooth={setDebrisPerTooth}
                            toothPosition={(pos) => setPositionTooth(pos)}
                            onDebrisChange={(data, nomor) => {
                              if (!nomor) return;

                              const debrisArray = Array.isArray(data[nomor]) ? data[nomor] : [];

                              const debrisNames = debrisArray
                                .filter((d) => d && d.display_name)
                                .map((d) => d.display_name)
                                .join(", ");

                              setDebrisIndexGigi(debrisNames || "Belum ada data");
                            }}
                          />
                        )}
                      </>
                    )}


                  <Row className="mt-2">
                    <Col>
                      <OklusiButtonModal
                        getDataDentalOcclusi={getDataDentalOcclusi}
                        cleanedTooth={cleanedTooth}
                        toothOcclusi={toothOcclusi}
                        setToothOcclusi={setToothOcclusi}
                        selectedTeeth={selectedTeeth}
                        setOpenModalType={setOpenModalType}
                        activeOcclusiSelections={activeOcclusiSelections}
                        setActiveOcclusiSelections={setActiveOcclusiSelections}
                        tempOcclusiSelections={tempOcclusiSelections}
                        setTempOcclusiSelections={setTempOcclusiSelections}
                        activeMode={activeMode}
                        setActiveMode={setActiveMode}
                        onOcclusiSelected={handleOcclusiSelected}
                      />
                    </Col>
                    <Col>
                      <TorusPalatinusButtonModal
                        getDataDentalTorusPalatinus={getDataDentalTorusPalatinus}
                        cleanedTooth={cleanedTooth}
                        toothTorusPalatinus={toothTorusPalatinus}
                        setToothTorusPalatinus={setToothTorusPalatinus}
                        selectedTeeth={selectedTeeth}
                        setOpenModalType={setOpenModalType}
                        activeTorusPalatinusSelections={activeTorusPalatinusSelections}
                        setActiveTorusPalatinusSelections={setActiveTorusPalatinusSelections}
                        tempTorusPalatinusSelections={tempTorusPalatinusSelections}
                        setTempTorusPalatinusSelections={setTempTorusPalatinusSelections}
                        activeMode={activeMode}
                        setActiveMode={setActiveMode}
                        onTorusPalatinusSelected={handleTorusPalatinusSelected}
                      />
                    </Col>
                    <Col>
                      <TorusMandibularisButtonModal
                        getDataDentalTorusMandibularis={getDataDentalTorusMandiBularis}
                        cleanedTooth={cleanedTooth}
                        toothTorusMandibularis={toothTorusMandiBularis}
                        setToothTorusMandibularis={setToothTorusMandiBularis}
                        selectedTeeth={selectedTeeth}
                        setOpenModalType={setOpenModalType}
                        activeTorusMandibularisSelections={activeTorusMandiBularisSelections}
                        setActiveTorusMandibularisSelections={setActiveTorusMandiBularisSelections}
                        tempTorusMandibularisSelections={tempTorusMandiBularisSelections}
                        setTempTorusMandibularisSelections={setTempTorusMandiBularisSelections}
                        activeMode={activeMode}
                        setActiveMode={setActiveMode}
                        onTorusMandibularisSelected={handleTorusMandiBularisSelected}
                      />
                    </Col>
                    <Col>
                      <PalatumButtonModal
                        getDataDentalPalatum={getDataDentalPalatum}
                        cleanedTooth={cleanedTooth}
                        toothPalatum={toothPalatum}
                        setToothPalatum={setToothPalatum}
                        selectedTeeth={selectedTeeth}
                        setOpenModalType={setOpenModalType}
                        activePalatumSelections={activePalatumSelections}
                        setActivePalatumSelections={setActivePalatumSelections}
                        tempPalatumSelections={tempPalatumSelections}
                        setTempPalatumSelections={setTempPalatumSelections}
                        activeMode={activeMode}
                        setActiveMode={setActiveMode}
                        onPalatumSelected={handlePalatumSelected}
                      />
                    </Col>
                    <Col>
                      <DiastemaButtonModal
                        getDataDentalDiastema={getDataDentalDiastema}
                        cleanedTooth={cleanedTooth}
                        toothDiastema={toothDiastema}
                        setToothDiastema={setToothDiastema}
                        setOpenModalType={setOpenModalType}
                        selectedTeeth={selectedTeeth}
                        activeDiastemaSelections={activeDiastemaSelections}
                        setActiveDiastemaSelections={setActiveDiastemaSelections}
                        tempDiastemaSelections={tempDiastemaSelections}
                        setTempDiastemaSelections={setTempDiastemaSelections}
                        activeMode={activeMode}
                        setActiveMode={setActiveMode}
                        onDiastemaSelected={handleDiastemaSelected}
                        onDiastemaDescriptionChange={handleDiastemaDescriptionChange}

                      />
                    </Col>
                    <Col>
                      <AnomaliButtonModal
                        getDataDentalAnomali={getDataDentalAnomali}
                        cleanedTooth={cleanedTooth}
                        toothAnomali={toothAnomali}
                        setToothAnomali={setToothAnomali}
                        setOpenModalType={setOpenModalType}
                        selectedTeeth={selectedTeeth}
                        activeAnomaliSelections={activeAnomaliSelections}
                        setActiveAnomaliSelections={setActiveAnomaliSelections}
                        tempAnomaliSelections={tempAnomaliSelections}
                        setTempAnomaliSelections={setTempAnomaliSelections}
                        activeMode={activeMode}
                        setActiveMode={setActiveMode}
                        onAnomaliSelected={handleAnomaliSelected}
                        onAnomaliDescriptionChange={handleAnomaliDescriptionChange}
                      />
                    </Col>
                  </Row>
                  <Container>
                    <Row className="mt-2">
                      {/* Kolom 1 */}
                      <Col md={3} className="mb-3">
                        <OralConditionModal
                          value={form.other_dental_oral_conditions}
                          onSave={(note) => {
                            setForm((prev) => ({
                              ...prev,
                              other_dental_oral_conditions: note,
                            }));
                            setGetDataItem((prev) => ({
                              ...prev,
                              other_dental_oral_conditions: note,
                            }));
                          }}
                        />
                      </Col>
                      {/* Kolom 2 */}
                      <Col md={3} className="mb-3">
                        <DecayedTeethCountModal
                          value={form.number_of_decayed_teeth}
                          onSave={(note) => {
                            setForm((prev) => ({
                              ...prev,
                              number_of_decayed_teeth: note,
                            }));
                            setGetDataItem((prev) => ({
                              ...prev,
                              number_of_decayed_teeth: note,
                            }));
                          }}
                        />
                      </Col>

                      {/* Kolom 3 */}
                      <Col md={3} className="mb-3">
                        <ToothMissingCountModal
                          value={form.number_of_missing_teeth}
                          onSave={(note) => {
                            setForm((prev) => ({
                              ...prev,
                              number_of_missing_teeth: note,
                            }));
                            setGetDataItem((prev) => ({
                              ...prev,
                              number_of_missing_teeth: note,
                            }));
                          }}
                        />
                      </Col>

                      {/* Kolom 4 */}
                      <Col md={3} className="mb-3">
                        <ToothFilledCountModal
                          value={form.number_of_teeth_filled}
                          onSave={(note) => {
                            setForm((prev) => ({
                              ...prev,
                              number_of_teeth_filled: note,
                            }));
                            setGetDataItem((prev) => ({
                              ...prev,
                              number_of_teeth_filled: note,
                            }));
                          }}
                        />
                      </Col>
                    </Row>
                  </Container>

                  <div className="mt-3" style={{ display: "flex" }}>
                    <div className="button-treatment-plan-add" style={{ border: "none", backgroundColor: "", color: "white", borderRadius: "3px", fontSize: "12px", padding: "5px 10px", cursor: "pointer" }} onClick={handleAddClick}>
                      <FaPlus style={{ marginRight: "5px", fontSize: "10px" }} />Add
                    </div>
                    <div className="ml-2">
                      <div className="button-treatment-plan-reset" style={{ border: "none", backgroundColor: "", color: "white", borderRadius: "3px", fontSize: "12px", padding: "5px 10px", cursor: "pointer" }} onClick={handleResetPolygon}>
                        <FaUndoAlt style={{ marginRight: "5px", fontSize: "10px" }} /> Reset
                      </div>
                    </div>
                    {inputList.length > 0 && (
                      <div
                        onClick={() => setModalCardReminderAfter(true)}
                        title="Lihat Kartu Pengingat"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          border: "1px solid #DEE2E6",
                          backgroundColor: "",
                          color: "#001f8b",
                          borderRadius: "3px",
                          fontSize: "12px",
                          padding: "5px 10px",
                          cursor: "pointer",
                          marginLeft: "8px",
                          height: "110%"
                        }}
                      >
                        <FaInfoCircle style={{ fontSize: "12px" }} />
                      </div>
                    )}

                  </div>
                </>
              </div>
            </div>


            <table className="table mt-4">
              <thead>
                <tr style={{ backgroundColor: "#00F3EB" }}>
                  <th style={{ fontFamily: "revert", fontSize: "12px", textAlign: "center", color: "", border: "none", fontFamily: "sans-serif" }}>NO</th>
                  <th style={{ fontFamily: "revert", fontSize: "12px", textAlign: "center", color: "", border: "none", fontFamily: "sans-serif" }}>KETERANGAN</th>
                  <th style={{ fontFamily: "revert", fontSize: "12px", textAlign: "center", color: "", border: "none", fontFamily: "sans-serif" }}>QTY</th>
                  <th style={{ fontFamily: "revert", fontSize: "12px", textAlign: "center", color: "", border: "none", fontFamily: "sans-serif" }}>ESTIMATE PRICE</th>
                  <th style={{ fontFamily: "revert", fontSize: "12px", textAlign: "center", color: "", border: "none", fontFamily: "sans-serif" }}>ACTION</th>
                </tr>
              </thead>
              <tbody>
                {inputList.map((user, index) => (
                  <tr key={index} style={{ fontFamily: "sans-serif", fontSize: "11px", textAlign: "center" }}>
                    <td style={{ lineHeight: "2", border: "none" }}>{getDataFee.length + index + 1}</td>
                    <td style={{ lineHeight: "2", border: "none", textAlign: "start" }}>
                      <div style={{
                        display: "flex",
                        justifyContent: "space-between",
                        flexWrap: "wrap",
                        alignItems: "center",
                      }}>
                        <div style={{ fontWeight: "bold", textTransform: "uppercase" }}>
                          {getDataTreatment.find(t => t.id === user.id_treatment)?.name}
                          {user?.tooth_number && (
                            <div style={{ fontWeight: "normal" }}>
                              <strong>Gigi: </strong>
                              {(() => {
                                const bagianMap = {
                                  O: "Oklusal",
                                  P: "Palatal",
                                  B: "Bukal",
                                  D: "Distal",
                                  M: "Mesial",
                                  L: "Labial"
                                };

                                const getLabel = (kode) => {
                                  const match = kode.match(/^(\d{1,2})([A-Z]?)$/);
                                  if (!match) return kode;
                                  const [, nomor, bagian] = match;
                                  return bagian ? `${nomor}-${bagianMap[bagian] || bagian}` : nomor;
                                };

                                let teeth = [];
                                // ✅ Coba parse jika berupa object JSON
                                try {
                                  if (typeof user.tooth_number === "string" && user.tooth_number.trim().startsWith("{")) {
                                    const parsed = JSON.parse(user.tooth_number);
                                    teeth = Object.keys(parsed);
                                  } else {
                                    const toothRaw = user.tooth_number.trim();
                                    teeth = toothRaw.match(/[0-9]{2}[A-Z]?/g) || [];
                                    // const isPerBagian = /[0-9]{2}[A-Z]/.test(toothRaw);
                                    // teeth = isPerBagian
                                    //   ? toothRaw.match(/[0-9]{2}[A-Z]/g)
                                    //   : (
                                    //     /^\d+$/.test(toothRaw) && toothRaw.length % 2 === 0
                                    //       ? toothRaw.match(/.{1,2}/g)
                                    //       : toothRaw.split(/\s+/).filter(Boolean)
                                    //   );
                                  }
                                } catch (e) {
                                  console.warn("Gagal parse tooth_number:", e);
                                }

                                return teeth?.map((tooth, idx) => {
                                  const popover = renderPopover?.(tooth, user);
                                  if (!popover) {
                                    return (
                                      <span key={idx} style={{ color: "#6c757d", marginRight: 6 }}>
                                        ({getLabel(tooth)})
                                      </span>
                                    );
                                  }

                                  return (
                                    <OverlayTrigger
                                      key={idx}
                                      trigger="click"
                                      placement="top"
                                      overlay={popover}
                                      rootClose
                                    >
                                      <span style={{ cursor: "pointer", marginRight: 6, color: "#0d6efd" }}>
                                        ({getLabel(tooth)})
                                      </span>
                                    </OverlayTrigger>
                                  );
                                });
                              })()}
                            </div>
                          )}


                        </div>
                      </div>
                    </td>

                    <td style={{ lineHeight: "2", border: "none" }}>{getDataTreatmentOneQty.filter(item => item?.id_treatment === user?.id_treatment).length > 0 ? 1 : user?.qty}</td>
                    <td style={{ lineHeight: "2", border: "none", display: "flex" }}>
                      <div style={{ flex: "10%", display: "flex", justifyContent: "start" }}>
                        Rp
                      </div>
                      <div style={{ flex: "90%", display: "flex", justifyContent: "end" }}>
                        {formatToRupiah(user?.estimate_price * (getDataTreatmentOneQty.filter(item => item?.id_treatment === user?.id_treatment).length > 0 ? 1 : (user?.qty === 32 ? 1 : user?.qty)))}
                      </div>
                    </td>
                    <td style={{ lineHeight: "1", border: "none" }}>
                      <div className="" style={{ display: "flex", justifyContent: "center", alignItems: "start" }}>
                        <div className="" style={{ border: "none", backgroundColor: "red", color: "white", borderRadius: "3px", fontSize: "12px", padding: "4px 10px", cursor: "pointer" }} onClick={() => handleRemoveClick(index)}>remove</div>
                      </div>
                    </td>
                  </tr>
                ))}
                {/* {inputList.map((user,index) => (
            <tr key={index} style={{fontFamily:"sans-serif", fontSize:"11px", textAlign:"center"}}>
              <td style={{ lineHeight: "2", border: "none" }}>{getDataFee.length + index + 1}</td>
              <td style={{ lineHeight: "2", border: "none", textAlign: "start" }}>
              {getDataTreatment.map(treatment => {
                if (treatment.id === user.id_treatment) {
                  return treatment.name.toUpperCase() + " " + (user?.tooth_number.toUpperCase() ?? "");
                }
              })}
              </td>   
              <td style={{ lineHeight: "2", border: "none" }}>{user?.qty}</td>
              <td style={{ lineHeight: "2", border: "none", display: "flex" }}>
                <div style={{ flex: "10%", display: "flex", justifyContent: "start" }}>
                  Rp
                </div>
                <div style={{ flex: "90%", display: "flex", justifyContent: "end" }}>
                  {formatToRupiah(user?.estimate_price)}
                </div>
              </td>
                  
              
              <td style={{ lineHeight: "1",border: "none"}}>
                <div className="" style={{display:"flex", justifyContent:"center", alignItems:"start"}}>
                  <div className="" style={{border:"none", backgroundColor:"red", color:"white", borderRadius:"3px", fontSize:"12px", padding:"4px 10px", cursor:"pointer"}} onClick={() => handleRemoveClick(index)}>remove</div>
                </div>
              </td>
            </tr>
            ))} */}

                <tr className="mt-4" style={{ fontFamily: "sans-serif", fontSize: "11px", textAlign: "center", borderTop: "1px solid #C0C0C0" }}>
                  <td style={{ lineHeight: "1", border: "none" }}></td>
                  <td style={{ lineHeight: "1", border: "none" }}></td>
                  <td style={{ lineHeight: "1", border: "none" }}></td>
                  <td style={{ lineHeight: "1", border: "none", display: "flex" }}>
                    <div style={{ flex: "10%", display: "flex", justifyContent: "start", fontWeight: "bold" }}>
                      TOTAL
                    </div>
                    <div style={{ flex: "90%", display: "flex", justifyContent: "end", fontWeight: "bold" }}>
                      Rp {formatToRupiah(toltalDataTreatmentPriceOn)}
                    </div>
                  </td>
                  <td style={{ lineHeight: "2", border: "none" }}></td>

                </tr>
              </tbody>
            </table>
            <div style={{ padding: "0px 0px", marginTop: "0px", display: "flex", justifyContent: "center" }}>
              <div style={{ width: "20%" }}>
                <Button className="mt-4" type='submit' color='primary' block style={{ padding: "8px 10px", fontSize: "12px", borderRadius: "5px" }}>
                  Simpan Treatment
                </Button>
              </div>
            </div>
          </Form>

        </>

        :
        <>
          <table className="table">
            <thead>
              <tr style={{ backgroundColor: "#00F3EB" }}>
                <th style={{ fontFamily: "revert", fontSize: "12px", textAlign: "center", color: "", border: "none", fontFamily: "sans-serif" }}>NO</th>
                <th style={{ fontFamily: "revert", fontSize: "12px", textAlign: "center", color: "", border: "none", fontFamily: "sans-serif", }}>KETERANGAN</th>
                <th style={{ fontFamily: "revert", fontSize: "12px", textAlign: "center", color: "", border: "none", fontFamily: "sans-serif" }}>JUMLAH</th>
                <th style={{ fontFamily: "revert", fontSize: "12px", textAlign: "center", color: "", border: "none", fontFamily: "sans-serif" }}>ACTION</th>
                {/* <th style={{ fontFamily: "revert", fontSize: "12px", textAlign: "center", color: "", border: "none", fontFamily: "sans-serif" }}>OBAT</th> */}
                <th style={{ fontFamily: "revert", fontSize: "12px", textAlign: "center", color: "", border: "none", fontFamily: "sans-serif" }}>HARGA</th>
              </tr>
            </thead>
            <tbody>
              {/* {getDataFee.map((user,index) => (
              <tr key={index} style={{ fontFamily: "sans-serif", fontSize: "11px", textAlign: "center" }}>
                <td style={{ lineHeight: "1", border: "none" }}>{index + 1}</td>
                <td style={{ lineHeight: "1", border: "none", textAlign: "start" }}>{user?.name.toUpperCase()}</td>
                <td style={{ lineHeight: "1", border: "none" }}>{user?.qty}</td>
                <td style={{ lineHeight: "1", border: "none" }}>
                  
                </td>
                <td style={{ lineHeight: "1", border: "none", display: "flex" }}>
                  <div style={{ flex: "10%", display: "flex", justifyContent: "start" }}>
                    Rp
                  </div>
                  <div style={{ flex: "90%", display: "flex", justifyContent: "end" }}>
                    {formatToRupiah(user?.price)}
                  </div>
                </td>
              </tr>
            ))} */}

              {getDataDetailsApproval.map((user, index) => (
                <tr key={index} style={{ fontFamily: "sans-serif", fontSize: "11px", textAlign: "center", }}>
                  {/* <td style={{ lineHeight: "1", border: "none" }}>{getDataFee.length + index + 1}</td> */}
                  <td style={{ lineHeight: "1", border: "none", textAlign: "start" }}>
                    <div>
                      {user?.treatment_data.name.toUpperCase()}
                      {user?.tooth_number === null || user?.tooth_number === "null" ? "" :
                        getDataTreatmentOneQty.filter(item => item?.id_treatment === user?.id_treatment).length > 0 ?
                          (user?.tooth_number === "18  17  16  15  14  13  12  11  21  22  23  24  25  26  27  28  55  54  53  52  51  61  62  63  64  65  85  84  83  82  81  71  72  73  74  75  48  47  46  45  44  43  42  41  31  32  33  34  35  36  37  38" && "(RA+RB)") ||
                          (user?.tooth_number === "18  17  16  15  14  13  12  11  21  22  23  24  25  26  27  28  48  47  46  45  44  43  42  41  31  32  33  34  35  36  37  38" && "(RA+RB)") ||
                          (user?.tooth_number === "55  54  53  52  51  61  62  63  64  65  85  84  83  82  81  71  72  73  74  75" && "(RA+RB)") ||
                          (user?.tooth_number === "18  17  16  15  14  13  12  11  21  22  23  24  25  26  27  28  55  54  53  52  51  61  62  63  64  65" && "(RA)") ||
                          (user?.tooth_number === "18  17  16  15  14  13  12  11  21  22  23  24  25  26  27  28" && "(RA)") ||
                          (user?.tooth_number === "55  54  53  52  51  61  62  63  64  65" && "(RA)") ||
                          (user?.tooth_number === "85  84  83  82  81  71  72  73  74  75  48  47  46  45  44  43  42  41  31  32  33  34  35  36  37  38" && "(RB)") ||
                          (user?.tooth_number === "48  47  46  45  44  43  42  41  31  32  33  34  35  36  37  38" && "(RB)") ||
                          (user?.tooth_number === "85  84  83  82  81  71  72  73  74  75" && "(RB)")
                          :
                          `(${user?.tooth_number})`
                      }
                    </div>
                    <div style={{ fontWeight: "800" }}>
                      DIAGNOSA : {user?.description === null ? "" : user?.description.toUpperCase()}
                    </div>
                  </td>
                  <td style={{ lineHeight: "1", border: "none" }}>{getDataTreatmentOneQty.filter(item => item?.id_treatment === user?.id_treatment).length > 0 ? 1 : user?.qty}</td>
                  <td style={{ lineHeight: "1", border: "none" }}>
                    {user?.patient_approval === 1 ?
                      <div style={{ display: "flex", justifyContent: "center" }}>
                        <div>
                          <Button block style={{ padding: "3px 10px", fontSize: "12px", borderRadius: "3px", backgroundColor: "#00D580", border: "none", cursor: "" }}>
                            <FaCheckCircle style={{ marginRight: "5px" }} />
                            Sudah Approve
                          </Button>
                        </div>
                      </div>
                      :
                      <div style={{ display: "flex", justifyContent: "center" }}>
                        <div>
                          <Button onClick={() => { ApproveTreatment(user?.id, user?.description, user?.id_description, user?.code_description) }} block style={{ padding: "3px 20px", fontSize: "12px", borderRadius: "3px", backgroundColor: "#0000D5", border: "none" }}>
                            Approve
                          </Button>
                        </div>
                      </div>
                    }
                  </td>

                  {/* <td style={{ lineHeight: "1", border: "none" }}>
                  <div style={{ display: "flex", justifyContent: "center" }}>
                      <div>
                        <Button onClick={() => {ApproveTreatment(user?.id, user?.description)}}  block style={{padding:"3px 20px",fontSize:"12px",borderRadius:"3px", backgroundColor:"#0000D5", border:"none"}}>
                          Obat 
                        </Button>
                      </div>
                    </div>
                </td> */}

                  <td style={{ lineHeight: "1", border: "none", display: "flex" }}>
                    <div style={{ flex: "10%", display: "flex", justifyContent: "start" }}>
                      Rp
                    </div>
                    <div style={{ flex: "90%", display: "flex", justifyContent: "end" }}>
                      {formatToRupiah(user?.estimate_price * (getDataTreatmentOneQty.filter(item => item?.id_treatment === user?.id_treatment).length > 0 ? 1 : user?.qty))}
                    </div>
                  </td>
                </tr>
              ))}

            </tbody>
          </table>

          <div style={{ display: "flex", justifyContent: "end" }}>
            <div style={{ flex: "50%" }}>
            </div>
            <div style={{ flex: "50%", backgroundColor: "#C6C6C6", display: "flex", fontSize: "12px", fontWeight: "bold", padding: "5px 5px", borderRight: "none", borderLeft: "none" }}>
              <div style={{ flex: "50%" }}>
                TOTAL
              </div>
              <div style={{ flex: "50%", display: "flex", alignItems: "center" }}>
                <div style={{ flex: "10%", display: "flex", justifyContent: "start" }}>
                  Rp
                </div>
                <div style={{ flex: "90%", display: "flex", justifyContent: "end" }}>
                  <span id="totalPrice">
                    <FormatRupiah type="text" value={`${totalDataTreatmentPrice}`} />
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div style={{ padding: "30px 0px", marginTop: "0px", display: "flex", justifyContent: "center" }}>
            <div style={{ width: "20%" }}>
              <Button onClick={handleSubmitMedicalInvoice} className="mt-4" type='' block style={{ backgroundColor: "#3F3FFF", padding: "8px 10px", fontSize: "12px", borderRadius: "5px" }}>
                Konfirmasi Treatment
              </Button>
            </div>
          </div>
        </>
      }

    </div>
  );
}
